import MdiCheckBold from '~icons/mdi/check-bold'
import MdiCropSquare from '~icons/mdi/crop-square'
import MdiCheckCircleOutline from '~icons/mdi/check-circle-outline'
import MdiCheckboxMarkedCircle from '~icons/mdi/checkbox-marked-circle'
import MdiCheckboxBlankCircleOutline from '~icons/mdi/checkbox-blank-circle-outline'
import MdiStar from '~icons/mdi/star'
import MdiStarOutline from '~icons/mdi/star-outline'
import MdiHeart from '~icons/mdi/heart'
import MdiHeartOutline from '~icons/mdi/heart-outline'
import LayoutSidebar from '~icons/tabler/layout-sidebar'
import MdiMoonFull from '~icons/mdi/moon-full'
import MdiMoonNew from '~icons/mdi/moon-new'
import MdiThumbUp from '~icons/mdi/thumb-up'
import MdiThumbUpOutline from '~icons/mdi/thumb-up-outline'
import MdiFlag from '~icons/mdi/flag'
import MdiFlagOutline from '~icons/mdi/flag-outline'
import MsMove from '~icons/material-symbols/drive-file-move-outline'
import MSCloseRounded from '~icons/material-symbols/close-rounded'
import MdiTableLarge from '~icons/mdi/table-large'
import MdiEyeCircleOutline from '~icons/mdi/eye-circle-outline'
import MsGroup from '~icons/material-symbols/groups-outline-rounded'
import MsAddBoxOutline from '~icons/nc-icons/add-box'
import LogosAirtable from '~icons/logos/airtable'
import MsSort from '~icons/material-symbols/sort'
import MaterialSymbolsEdit from '~icons/material-symbols/edit-outline-rounded'
import MaterialSymbolsWarningOutlineRounded from '~icons/material-symbols/warning-outline-rounded'
import MaterialSymbolsDragIndicator from '~icons/ri/draggable'
import PlusSquare from '~icons/nc-icons/plus-square'
import MobileShare from '~icons/nc-icons/share'
import PhLayout from '~icons/ph/layout'
import Minus from '~icons/material-symbols/remove-rounded'
import Code from '~icons/material-symbols/code-rounded'
import Palette from '~icons/material-symbols/palette-outline'
import MsSync from '~icons/material-symbols/sync-rounded'
import MdiRefresh from '~icons/mdi/refresh'
import ApiSnippet from '~icons/material-symbols/settings-ethernet-rounded'
import Phishing from '~icons/material-symbols/phishing-outline-rounded'
import MdiAccountGroup from '~icons/mdi/account-group'
import MdiDotsVertical from '~icons/mdi/dots-vertical'
import MdiDotsHorizontal from '~icons/mdi/dots-horizontal'
import MdiPdf from '~icons/mdi/file-pdf'
import PhExcelThin from '~icons/ph/microsoft-excel-logo-light'
import VscodeIconsExcelColored from '~icons/vscode-icons/file-type-excel'
import PhCsvThin from '~icons/ph/file-csv'
import PhSplitVerticalThin from '~icons/material-symbols/height-rounded'
import PhSplitHorizontalThin from '~icons/material-symbols/arrow-range-rounded'
import LogosDiscordIcon from '~icons/logos/discord-icon'
import LogosRedditIcon from '~icons/logos/reddit-icon'
import RiTwitterXFill from '~icons/ri/twitter-x-line'
import PhGithubLogoLight from '~icons/ph/github-logo-light'
import MsInfo from '~icons/material-symbols/info-outline-rounded'
import PhSparkleFill from '~icons/ph/sparkle-fill'
import MsDatabase from '~icons/mdi/database-outline'
import MdiDatabaseSearch from '~icons/mdi/database-search'
import MdiMagicStaff from '~icons/mdi/magic-staff'
import PhCaretDoubleLeftThin from '~icons/ph/caret-double-left-light'
import Right from '~icons/material-symbols/chevron-right-rounded'
import Left from '~icons/material-symbols/chevron-left-rounded'
import Up from '~icons/material-symbols/keyboard-arrow-up-rounded'
import Down from '~icons/material-symbols/keyboard-arrow-down-rounded'
import PhTriangleFill from '~icons/ph/triangle-fill'
import LcSend from '~icons/lucide/send'
import MdiPuzzle from '~icons/mdi/puzzle'
import MaterialSymbolsArrowDropUp from '~icons/material-symbols/arrow-drop-up'
import MaterialSymbolsArrowDropDown from '~icons/material-symbols/arrow-drop-down'

import HasManyIcon from '~icons/nc-icons/hasmany'
import ManytoManyIcon from '~icons/nc-icons/manytomany'
import BelongsToIcon from '~icons/nc-icons/belongsto'
import HasManySolidIcon from '~icons/nc-icons/hm-solid'
import ManytoManySolidIcon from '~icons/nc-icons/mm-solid'
import BelongsToSolidIcon from '~icons/nc-icons/bt-solid'
import Record from '~icons/nc-icons/record'
import TableCurrent from '~icons/nc-icons/table-current'
import Project from '~icons/nc-icons/project'
import LookupIcon from '~icons/nc-icons/lookup'
import FileImageIcon from '~icons/nc-icons/file-image'
import AutomationIcon from '~icons/nc-icons/automations'
import AiPlayIcon from '~icons/nc-icons/ai-play'

import PhUsers from '~icons/ph/users'
import PhUser from '~icons/ph/user'

// Roles
import SuperAdmin from '~icons/nc-icons/super-admin'
import Owner from '~icons/nc-icons/owner'
import Creator from '~icons/nc-icons/creator'
import Editor from '~icons/nc-icons/editor'
import Commentor from '~icons/nc-icons/commentor'
import Viewer from '~icons/nc-icons/viewer'
import NoAccess from '~icons/nc-icons/no-access'

// toolbar
import Fields from '~icons/nc-icons/fields'
import Filter from '~icons/nc-icons/filter'
import Group from '~icons/nc-icons/group'
import Sort from '~icons/nc-icons/sort'

// NocoDB Icons
import NcEye from '~icons/nc-icons/eye'
import NcEyeOff from '~icons/nc-icons/eye-off'
import NcStar from '~icons/nc-icons/star'
import NcUnStar from '~icons/nc-icons/star-remove'
import NcSearch from '~icons/nc-icons/search'
import NcCreditCard from '~icons/nc-icons/credit-card'
import NcLayers from '~icons/nc-icons/layers'
import NcUser from '~icons/nc-icons/user'
import NcUsers from '~icons/nc-icons/users'
import NcCheck from '~icons/nc-icons/check'
import NcIconsRowHeightMedium from '~icons/nc-icons/row-height-medium'
import NcIconsRowHeightShort from '~icons/nc-icons/row-height-short'
import NcIconsRowHeightTall from '~icons/nc-icons/row-height-tall'
import NcIconsRowHeightExtraTall from '~icons/nc-icons/row-height-extra-tall'
import NcIconsGift from '~icons/nc-icons/gift'
import NcArticle from '~icons/nc-icons/article'
import NcCommentHere from '~icons/nc-icons/comment-here'
import NcAddDataSource from '~icons/nc-icons/add-data-source'
import NcDatabaseIcon from '~icons/nc-icons/database'
import NcChevronDown from '~icons/nc-icons/chevron-down'
import NcChevronUpDown from '~icons/nc-icons/chevron-up-down'
import NcTrash from '~icons/nc-icons/trash'
import NcPencil from '~icons/nc-icons/pencil'
import NcRename from '~icons/nc-icons/rename'
import NcDuplicate from '~icons/nc-icons/duplicate'
import NcEdit from '~icons/nc-icons/edit'
import NcCopy from '~icons/nc-icons/copy'
import NcPaste from '~icons/nc-icons/paste'
import NcArrowUp from '~icons/nc-icons/arrow-up'
import NcArrowDown from '~icons/nc-icons/arrow-down'
import NcArrowLeft from '~icons/nc-icons/arrow-left'
import NcArrowRight from '~icons/nc-icons/arrow-right'
import NcUpload from '~icons/nc-icons/upload'
import NcDownload from '~icons/nc-icons/download'
import NcOffice from '~icons/nc-icons/office'
import NcArrowUpRight from '~icons/nc-icons/arrow-up-right'
import NcSlash from '~icons/nc-icons/slash'
import NcNotification from '~icons/nc-icons/bell'
import NcCheckCircle from '~icons/nc-icons/check-circle'
import NcCheckFill from '~icons/nc-icons/checkFill'
import NcExternalLink from '~icons/nc-icons/external-link'
import NcCamera from '~icons/nc-icons/camera'
import NcRefreshCW from '~icons/nc-icons/refresh-cw'
import NcBulb from '~icons/nc-icons/bulb'
import NcSnow from '~icons/nc-icons/snow'
// import NcProjectGray from '~icons/nc-icons/project-gray'
import NcPhoneCall from '~icons/nc-icons/phone-call'
import NcItalic from '~icons/nc-icons/italic'
import NcBold from '~icons/nc-icons/bold'
import NcUnderline from '~icons/nc-icons/underline'
import NcLink from '~icons/nc-icons/link'
import NcAtSign from '~icons/nc-icons/at-sign'
import NcStrike from '~icons/nc-icons/strike-through'
import NcCrop from '~icons/nc-icons/crop'
import NcControlPanel from '~icons/nc-icons/control-panel'
import NcHome from '~icons/nc-icons/home'
import NcHome1 from '~icons/nc-icons/home1'
import NcWorkspace from '~icons/nc-icons/workspace'
import NcMegaPhone from '~icons/nc-icons/megaphone'

import NcCellBarcode from '~icons/nc-icons/cell-barcode'
import NcCellCheckbox from '~icons/nc-icons/cell-checkbox'
import NcCellDate from '~icons/nc-icons/cell-date'
import NcCellYear from '~icons/nc-icons/cell-year'
import NcCellEmail from '~icons/nc-icons/cell-email'
import NcCellFormula from '~icons/nc-icons/cell-formula'
import NcCellCurrency from '~icons/nc-icons/cell-currency'
import NcCellDatetime from '~icons/nc-icons/cell-datetime'
import NcCellDb from '~icons/nc-icons/cell-db'
import NcCellDecimal from '~icons/nc-icons/cell-decimal'
import NcCellDuration from '~icons/nc-icons/cell-duration'
import NcCellGeometry from '~icons/nc-icons/cell-geometry'
import NcCellJson from '~icons/nc-icons/cell-json'
import NcCellLinks from '~icons/nc-icons/cell-link'
import NcCellLongText from '~icons/nc-icons/cell-longtext'
import NcCellLookup from '~icons/nc-icons/cell-lookup'
import NcCellMultiSelect from '~icons/nc-icons/cell-multiselect'
import NcCellAutoNumber from '~icons/nc-icons/cell-auto-number'
import NcCellNumber from '~icons/nc-icons/cell-number'
import NcCellPercent from '~icons/nc-icons/cell-percentage'
import NcCellPhone from '~icons/nc-icons/cell-phone'
import NcCellQrCode from '~icons/nc-icons/cell-qrcode'
import NcCellRating from '~icons/nc-icons/cell-rating'
import NcCellRollup from '~icons/nc-icons/cell-rollup'
import NcCellSingleSelect from '~icons/nc-icons/cell-select'
import NcCellText from '~icons/nc-icons/cell-text'
import NcCellTime from '~icons/nc-icons/cell-time'
import NcCellUrl from '~icons/nc-icons/cell-url'
import NcCellUser from '~icons/nc-icons/cell-user'
import NcCellSystemDate from '~icons/nc-icons/system-date'
import NcCellSystemKey from '~icons/nc-icons/system-key'
import NcCellSystemUser from '~icons/nc-icons/system-user'
import NcCellSystemText from '~icons/nc-icons/system-text'
import NcCellAttachment from '~icons/nc-icons/cell-attachment'
import NcCellButton from '~icons/nc-icons/cell-button'
import NcCellAiButton from '~icons/nc-icons/cell-ai-button'
import NcCellAi from '~icons/nc-icons/cell-ai'
import NcCellColour from '~icons/nc-icons/cell-colour'
import NcCellUuid from '~icons/nc-icons/cell-uuid'

import NcCircleCheck from '~icons/nc-icons/circle-check'
import OnetoOneIcon from '~icons/nc-icons/onetoone'

import NcDiscord from '~icons/nc-icons/discord'
import NcReddit from '~icons/nc-icons/reddit'
import NcTwitter from '~icons/nc-icons/twitter'

import NcFile from '~icons/nc-icons/file'
import NcFileBig from '~icons/nc-icons/file-big'
import NcSettings from '~icons/nc-icons/settings'
import NcHelp from '~icons/nc-icons/help'
import NcAlertTriangle from '~icons/nc-icons/alert-triangle'
import NcAudit from '~icons/nc-icons/audit'
import NcAuditNew from '~icons/nc-icons-v2/audit-new'
import NcMessageCircle from '~icons/nc-icons/message-circle'
import NcKey from '~icons/nc-icons/key'

import NcMinimize from '~icons/nc-icons/minimize'
import NcMinimizeAll from '~icons/nc-icons/minimize-all'
import NcMaximize from '~icons/nc-icons/maximize'
import NcMaximizeAll from '~icons/nc-icons/maximize-all'
import NcDrag from '~icons/nc-icons/drag'
import NcRefresh from '~icons/nc-icons/refresh'
import NcPlay from '~icons/nc-icons/play'
import GoogleDocs from '~icons/nc-icons/google-docs'
import NcGlobe from '~icons/nc-icons/globe'
import NcIntegration from '~icons/nc-icons/integration'
import NcGitCommit from '~icons/nc-icons/git-commit'
import NcCircle from '~icons/nc-icons/circle'
import NcServer1 from '~icons/nc-icons/server1'
import NcThumbsUpOutline from '~icons/nc-icons/thumbs-up-outline'
import NcNocoDB from '~icons/nc-icons/nocodb'
import NcNocoDB1 from '~icons/nc-icons/nocodb1'
import NcNocoDBSquarePuck from '~icons/nc-icons/nocodb-square-puck'

// Sync data
import NcAppleSolid from '~icons/nc-icons/apple_solid'
import NcAsana from '~icons/nc-icons/asana'
import NcBox from '~icons/nc-icons/box'
import NcGithubSolid from '~icons/nc-icons/github_solid'
import NcGitlab from '~icons/nc-icons/gitlab'
import NcGoogleCalendar from '~icons/nc-icons/google_calendar'
import NcGoogleSheet from '~icons/nc-icons/google_sheet'
import NcGoogleDrive from '~icons/nc-icons/google-drive'
import NcHubspot from '~icons/nc-icons/hubspot'
import NcJira from '~icons/nc-icons/jira'
import NcLinear from '~icons/nc-icons-v2/linear'
import NcMailchimp from '~icons/nc-icons/mailchimp'
import NcMicrosoftAccess from '~icons/nc-icons/microsoft_access'
import NcMicrosoftExcel from '~icons/nc-icons/microsoft_excel'
import NcMicrosoftOutlook from '~icons/nc-icons/microsoft_outlook'
import NcMiro from '~icons/nc-icons/miro'
import NcSalesforce from '~icons/nc-icons/salesforce'
import NcSnowflake from '~icons/nc-icons/snowflake'
import NcStripe from '~icons/nc-icons/stripe'
import NcSurveyMonkey from '~icons/nc-icons/survey_monkey'
import NcTableau from '~icons/nc-icons/tableau'
import NcTrello from '~icons/nc-icons/trello'
import NcTypeform from '~icons/nc-icons/typeform'
import NcWorkday from '~icons/nc-icons/workday'
import NcZendesk from '~icons/nc-icons/zendesk'
import NcFreshdesk from '~icons/nc-icons/freshdesk'

import NcBookOpen from '~icons/nc-icons/book-open'
import NcCircleCheckSolid from '~icons/nc-icons/check-circle-solid'
import NcAlertTriangleSolid from '~icons/nc-icons/alert-triangle-solid'
import NcMail from '~icons/nc-icons/mail'
import NcSlack from '~icons/nc-icons/slack'
import NcMicrosoftTeams from '~icons/nc-icons/microsoft-teams'
import NcMattermost from '~icons/nc-icons/mattermost'
import NcTwilio from '~icons/nc-icons/twilio'
import NcWhatsapp from '~icons/nc-icons/whatsapp'
import NcWhatsappSolid from '~icons/nc-icons/whatsapp-solid'
import NcMCP from '~icons/nc-icons/mcp'

import NcDollerSign from '~icons/nc-icons/doller-sign'
import NcMultiFile from '~icons/nc-icons/multi-file'
import NcHeart from '~icons/nc-icons/heart'
import NcSave from '~icons/nc-icons/save'

import NcMySql from '~icons/logos/mysql-icon'
import NcPostgreSql from '~icons/nc-icons/postgresql'
import NcSqlServer from '~icons/nc-icons/sql-server'
import NcDataBricks from '~icons/nc-icons/data-bricks'
import NcMssqlServer from '~icons/nc-icons/mssql-server'
import NcGmail from '~icons/nc-icons/gmail'
import NcTelegram from '~icons/nc-icons/telegram'
import NcMicrosoftDynamics365 from '~icons/nc-icons/microsoft-dynamics-365'
import NcPipedrive from '~icons/nc-icons/pipedrive'
import NcZohoCrm from '~icons/nc-icons/zoho-crm'
import NcGreenhouse from '~icons/nc-icons/greenhouse'
import NcLever from '~icons/nc-icons/lever'
import NcBitBucket from '~icons/nc-icons/bit-bucket'
import NcQuickbooks from '~icons/nc-icons/quickbooks'
import NcIntercom from '~icons/nc-icons/intercom'
import NcDropbox from '~icons/nc-icons/dropbox'
import NcOpenai from '~icons/nc-icons/openai'
import NcClaude from '~icons/nc-icons/claude'
import NcOllama from '~icons/nc-icons/ollama'
import NcGroq from '~icons/nc-icons/groq'
import NcPosthog from '~icons/nc-icons/posthog'
import NcNocodbPg from '~icons/nc-icons/nocodb-pg'
import NcStopCircle from '~icons/nc-icons/stop-circle'
import NcEnter from '~icons/nc-icons/enter'
import NcAmazonAws from '~icons/nc-icons/amazon_aws'

// Buttons Icons V2

import NcColumnsIcon from '~icons/nc-icons-v2/columns.svg'
import NcUnderlineIcon from '~icons/nc-icons-v2/underline.svg'
import NcGridIcon from '~icons/nc-icons-v2/grid.svg'
import NcTriangleIcon from '~icons/nc-icons-v2/triangle.svg'
import NcSearchIcon from '~icons/nc-icons-v2/search.svg'
import NcVolume2Icon from '~icons/nc-icons-v2/volume-2.svg'
import NcArrowUpCircleIcon from '~icons/nc-icons-v2/arrow-up-circle.svg'
import NcArrowUpCircleSolidIcon from '~icons/nc-icons-v2/arrow-up-circle-solid.svg'
import NcPauseCircleIcon from '~icons/nc-icons-v2/pause-circle.svg'
import NcCheckSquareIcon from '~icons/nc-icons-v2/check-square.svg'
import NcArrowDownIcon from '~icons/nc-icons-v2/arrow-down.svg'
import NcCornerRightUpIcon from '~icons/nc-icons-v2/corner-right-up.svg'
import NcChevronsRightIcon from '~icons/nc-icons-v2/chevrons-right.svg'
import NcListIcon from '~icons/nc-icons-v2/list.svg'
import NcListEndIcon from '~icons/nc-icons-v2/list-end.svg'
import NcWandSparklesIcon from '~icons/nc-icons-v2/wand-sparkles.svg'
import NcUpgradeSparkleIcon from '~icons/nc-icons-v2/upgrade-sparkle.svg'
import NcNumberListIcon from '~icons/nc-icons-v2/number-list.svg'
import NcCheckListIcon from '~icons/nc-icons-v2/check-list.svg'
import NcChevronsDownIcon from '~icons/nc-icons-v2/chevrons-down.svg'
import NcCornerUpRightIcon from '~icons/nc-icons-v2/corner-up-right.svg'
import NcTargetIcon from '~icons/nc-icons-v2/target.svg'
import NcScissorsIcon from '~icons/nc-icons-v2/scissors.svg'
import NcMinimize2Icon from '~icons/nc-icons-v2/minimize-2.svg'
import NcPlayCircleIcon from '~icons/nc-icons-v2/play-circle.svg'
import NcCrosshairIcon from '~icons/nc-icons-v2/crosshair.svg'
import NcAirplayIcon from '~icons/nc-icons-v2/airplay.svg'
import NcXOctagonIcon from '~icons/nc-icons-v2/x-octagon.svg'
import NcRepeatIcon from '~icons/nc-icons-v2/repeat.svg'
import NcEdit3Icon from '~icons/nc-icons-v2/edit-3.svg'
import NcVolume1Icon from '~icons/nc-icons-v2/volume-1.svg'
import NcToggleRightIcon from '~icons/nc-icons-v2/toggle-right.svg'
import NcUserIcon from '~icons/nc-icons-v2/user.svg'
import NcFileMinusIcon from '~icons/nc-icons-v2/file-minus.svg'
import NcXCircleIcon from '~icons/nc-icons-v2/x-circle.svg'
import NcCircleIcon from '~icons/nc-icons-v2/circle.svg'
import NcPhoneMissedIcon from '~icons/nc-icons-v2/phone-missed.svg'
import NcEdit2Icon from '~icons/nc-icons-v2/edit-2.svg'
import NcCornerLeftUpIcon from '~icons/nc-icons-v2/corner-left-up.svg'
import NcHomeIcon from '~icons/nc-icons-v2/home.svg'
import NcHomeFilledIcon from '~icons/nc-icons-v2/home-filled.svg'
import NcTableOutlineIcon from '~icons/nc-icons-v2/table-outline.svg'
import NcTableFilledIcon from '~icons/nc-icons-v2/table-filled.svg'
import NcTableIcon from '~icons/nc-icons-v2/nc-table.svg'
import NcAutomationsFilledIcon from '~icons/nc-icons-v2/automations-filled.svg'
import NcGitlabIcon from '~icons/nc-icons-v2/gitlab.svg'
import NcSmartphoneIcon from '~icons/nc-icons-v2/smartphone.svg'
import NcMoreHorizontalIcon from '~icons/nc-icons-v2/more-horizontal.svg'
import NcSlidersIcon from '~icons/nc-icons-v2/sliders.svg'
import NcArrowUpLeftIcon from '~icons/nc-icons-v2/arrow-up-left.svg'
import NcChevronDownIcon from '~icons/nc-icons-v2/chevron-down.svg'
import NcHexagonIcon from '~icons/nc-icons-v2/hexagon.svg'
import NcGithubIcon from '~icons/nc-icons-v2/github.svg'
import NcCropIcon from '~icons/nc-icons-v2/crop.svg'
import NcBriefcaseIcon from '~icons/nc-icons-v2/briefcase.svg'
import NcRotateCwIcon from '~icons/nc-icons-v2/rotate-cw.svg'
import NcInboxIcon from '~icons/nc-icons-v2/inbox.svg'
import NcAlignJustifyIcon from '~icons/nc-icons-v2/align-justify.svg'
import NcPlusSquareIcon from '~icons/nc-icons-v2/plus-square.svg'
import NcPowerIcon from '~icons/nc-icons-v2/power.svg'
import NcDatabaseIcon2 from '~icons/nc-icons-v2/database.svg'
import NcCameraOffIcon from '~icons/nc-icons-v2/camera-off.svg'
import NcToggleLeftIcon from '~icons/nc-icons-v2/toggle-left.svg'
import NcFileIcon from '~icons/nc-icons-v2/file.svg'
import NcMessageCircleIcon from '~icons/nc-icons-v2/message-circle.svg'
import NcTerminalIcon from '~icons/nc-icons-v2/terminal.svg'
import NcMoveIcon from '~icons/nc-icons-v2/move.svg'
import NcMoveHorizontalIcon from '~icons/nc-icons-v2/move-horizontal.svg'
import NcMaximizeIcon from '~icons/nc-icons-v2/maximize.svg'
import NcChevronUpIcon from '~icons/nc-icons-v2/chevron-up.svg'
import NcArrowDownLeftIcon from '~icons/nc-icons-v2/arrow-down-left.svg'
import NcFileTextIcon from '~icons/nc-icons-v2/file-text.svg'
import NcFileTextSolidIcon from '~icons/nc-icons-v2/file-text-solid.svg'
import NcDropletIcon from '~icons/nc-icons-v2/droplet.svg'
import NcZapOffIcon from '~icons/nc-icons-v2/zap-off.svg'
import NcXIcon from '~icons/nc-icons-v2/x.svg'
import NcBarChartIcon from '~icons/nc-icons-v2/bar-chart.svg'
import NcLockIcon from '~icons/nc-icons-v2/lock.svg'
import NcLogInIcon from '~icons/nc-icons-v2/log-in.svg'
import NcRefreshCwIcon from '~icons/nc-icons-v2/refresh-cw.svg'
import NcChevronRightIcon from '~icons/nc-icons-v2/chevron-right.svg'
import NcClipboardIcon from '~icons/nc-icons-v2/clipboard.svg'
import NcPackageIcon from '~icons/nc-icons-v2/package.svg'
import NcInstagramIcon from '~icons/nc-icons-v2/instagram.svg'
import NcLinkIcon from '~icons/nc-icons-v2/link.svg'
import NcVideoOffIcon from '~icons/nc-icons-v2/video-off.svg'
import NcKeyIcon from '~icons/nc-icons-v2/key.svg'
import NcCornerDownRightIcon from '~icons/nc-icons-v2/corner-down-right.svg'
import NcArrowRightIcon from '~icons/nc-icons-v2/arrow-right.svg'
import NcStopCircleIcon from '~icons/nc-icons-v2/stop-circle.svg'
import NcLogOutIcon from '~icons/nc-icons-v2/log-out.svg'
import NcArrowLeftCircleIcon from '~icons/nc-icons-v2/arrow-left-circle.svg'
import NcBarChart2Icon from '~icons/nc-icons-v2/bar-chart-2.svg'
import NcGitPullRequestIcon from '~icons/nc-icons-v2/git-pull-request.svg'
import NcMinimizeIcon from '~icons/nc-icons-v2/minimize.svg'
import NcMinusSquareIcon from '~icons/nc-icons-v2/minus-square.svg'
import NcSettingsIcon from '~icons/nc-icons-v2/settings.svg'
import NcCloudSnowIcon from '~icons/nc-icons-v2/cloud-snow.svg'
import NcThumbsDownIcon from '~icons/nc-icons-v2/thumbs-down.svg'
import NcTypeIcon from '~icons/nc-icons-v2/type.svg'
import NcPhoneOutgoingIcon from '~icons/nc-icons-v2/phone-outgoing.svg'
import NcPocketIcon from '~icons/nc-icons-v2/pocket.svg'
import NcMailIcon from '~icons/nc-icons-v2/mail.svg'
import NcShieldIcon from '~icons/nc-icons-v2/shield.svg'
import NcDownloadIcon from '~icons/nc-icons-v2/download.svg'
import NcPhoneForwardedIcon from '~icons/nc-icons-v2/phone-forwarded.svg'
import NcCornerRightDownIcon from '~icons/nc-icons-v2/corner-right-down.svg'
import NcBookOpenIcon from '~icons/nc-icons-v2/book-open.svg'
import NcServerIcon from '~icons/nc-icons-v2/server.svg'
import NcTvIcon from '~icons/nc-icons-v2/tv.svg'
import NcSkipForwardIcon from '~icons/nc-icons-v2/skip-forward.svg'
import NcVolumeIcon from '~icons/nc-icons-v2/volume.svg'
import NcUserPlusIcon from '~icons/nc-icons-v2/user-plus.svg'
import NcBatteryChargingIcon from '~icons/nc-icons-v2/battery-charging.svg'
import NcLayersIcon from '~icons/nc-icons-v2/layers.svg'
import NcSlashIcon from '~icons/nc-icons-v2/slash.svg'
import NcRadioIcon from '~icons/nc-icons-v2/radio.svg'
import NcBookIcon from '~icons/nc-icons-v2/book.svg'
import NcUserMinusIcon from '~icons/nc-icons-v2/user-minus.svg'
import NcBellIcon from '~icons/nc-icons-v2/bell.svg'
import NcGitBranchIcon from '~icons/nc-icons-v2/git-branch.svg'
import NcCodeIcon from '~icons/nc-icons-v2/code.svg'
import NcCodeBlockIcon from '~icons/nc-icons-v2/code-block.svg'
import NcCastIcon from '~icons/nc-icons-v2/cast.svg'
import NcFlagIcon from '~icons/nc-icons-v2/flag.svg'
import NcEyeOffIcon from '~icons/nc-icons-v2/eye-off.svg'
import NcBatteryIcon from '~icons/nc-icons-v2/battery.svg'
import NcDiscIcon from '~icons/nc-icons-v2/disc.svg'
import NcFrownIcon from '~icons/nc-icons-v2/frown.svg'
import NcToolIcon from '~icons/nc-icons-v2/tool.svg'
import NcBoldIcon from '~icons/nc-icons-v2/bold.svg'
import NcHashIcon from '~icons/nc-icons-v2/hash.svg'
import NcShare2Icon from '~icons/nc-icons-v2/share-2.svg'
import NcPlusIcon from '~icons/nc-icons-v2/plus.svg'
import NcCheckIcon from '~icons/nc-icons-v2/check.svg'
import NcRotateCcwIcon from '~icons/nc-icons-v2/rotate-ccw.svg'
import NcUndoIcon from '~icons/nc-icons-v2/undo.svg'
import NcRedoIcon from '~icons/nc-icons-v2/redo.svg'
import NcHardDriveIcon from '~icons/nc-icons-v2/hard-drive.svg'
import NcBluetoothIcon from '~icons/nc-icons-v2/bluetooth.svg'
import NcPieChartIcon from '~icons/nc-icons-v2/pie-chart.svg'
import NcRssIcon from '~icons/nc-icons-v2/rss.svg'
import NcWifiIcon from '~icons/nc-icons-v2/wifi.svg'
import NcCornerUpLeftIcon from '~icons/nc-icons-v2/corner-up-left.svg'
import NcInfoIcon from '~icons/nc-icons-v2/info.svg'
import NcUserXIcon from '~icons/nc-icons-v2/user-x.svg'
import NcLoaderIcon from '~icons/nc-icons-v2/loader.svg'
import NcRefreshCcwIcon from '~icons/nc-icons-v2/refresh-ccw.svg'
import NcFolderPlusIcon from '~icons/nc-icons-v2/folder-plus.svg'
import NcMicIcon from '~icons/nc-icons-v2/mic.svg'
import NcCopyIcon from '~icons/nc-icons-v2/copy.svg'
import NcZoomInIcon from '~icons/nc-icons-v2/zoom-in.svg'
import NcArrowRightCircleIcon from '~icons/nc-icons-v2/arrow-right-circle.svg'
import NcAlignRightIcon from '~icons/nc-icons-v2/align-right.svg'
import NcImageIcon from '~icons/nc-icons-v2/image.svg'
import NcMaximize2Icon from '~icons/nc-icons-v2/maximize-2.svg'
import NcCheckCircleIcon from '~icons/nc-icons-v2/check-circle.svg'
import NcSaveIcon from '~icons/nc-icons-v2/save.svg'
import NcSmileIcon from '~icons/nc-icons-v2/smile.svg'
import NcNavigationIcon from '~icons/nc-icons-v2/navigation.svg'
import NcPaperclipIcon from '~icons/nc-icons-v2/paperclip.svg'
import NcFastForwardIcon from '~icons/nc-icons-v2/fast-forward.svg'
import NcXSquareIcon from '~icons/nc-icons-v2/x-square.svg'
import NcAwardIcon from '~icons/nc-icons-v2/award.svg'
import NcZoomOutIcon from '~icons/nc-icons-v2/zoom-out.svg'
import NcBoxIcon from '~icons/nc-icons-v2/box.svg'
import NcThumbsUpIcon from '~icons/nc-icons-v2/thumbs-up.svg'
import NcPercentIcon from '~icons/nc-icons-v2/percent.svg'
import NcSidebarIcon from '~icons/nc-icons-v2/sidebar.svg'
import NcSquareIcon from '~icons/nc-icons-v2/square.svg'
import NcPlayIcon from '~icons/nc-icons-v2/play.svg'
import NcGitCommitIcon from '~icons/nc-icons-v2/git-commit.svg'
import NcSendIcon from '~icons/nc-icons-v2/send.svg'
import NcPhoneCallIcon from '~icons/nc-icons-v2/phone-call.svg'
import NcCameraIcon from '~icons/nc-icons-v2/camera.svg'
import NcLink2Icon from '~icons/nc-icons-v2/link-2.svg'
import NcPrinterIcon from '~icons/nc-icons-v2/printer.svg'
import NcFolderMinusIcon from '~icons/nc-icons-v2/folder-minus.svg'
import NcArrowUpRightIcon from '~icons/nc-icons-v2/arrow-up-right.svg'
import NcPenToolIcon from '~icons/nc-icons-v2/pen-tool.svg'
import NcAtSignIcon from '~icons/nc-icons-v2/at-sign.svg'
import NcTrashIcon from '~icons/nc-icons-v2/trash.svg'
import NcHistoryIcon from '~icons/nc-icons-v2/history.svg'
import NcWifiOffIcon from '~icons/nc-icons-v2/wifi-off.svg'
import NcCornerLeftDownIcon from '~icons/nc-icons-v2/corner-left-down.svg'
import NcDollarSignIcon from '~icons/nc-icons-v2/dollar-sign.svg'
import NcStarIcon from '~icons/nc-icons-v2/star.svg'
import NcCloudOffIcon from '~icons/nc-icons-v2/cloud-off.svg'
import NcMessageSquareIcon from '~icons/nc-icons-v2/message-square.svg'
import NcMessageSquare1OutlineIcon from '~icons/nc-icons-v2/message-square1-outline.svg'
import NcMessageSquare1SolidIcon from '~icons/nc-icons-v2/message-square1-solid.svg'
import NcEditIcon from '~icons/nc-icons-v2/edit.svg'
import NcAlertCircleIcon from '~icons/nc-icons-v2/alert-circle.svg'
import NcAlertCircleFilledIcon from '~icons/nc-icons-v2/alert-circle-filled.svg'
import NcChevronsUpIcon from '~icons/nc-icons-v2/chevrons-up.svg'
import NcUploadCloudIcon from '~icons/nc-icons-v2/upload-cloud.svg'
import NcYoutubeIcon from '~icons/nc-icons-v2/youtube.svg'
import NcUnlockIcon from '~icons/nc-icons-v2/unlock.svg'
import NcCompassIcon from '~icons/nc-icons-v2/compass.svg'
import NcPlusCircleIcon from '~icons/nc-icons-v2/plus-circle.svg'
import NcCreditCardIcon from '~icons/nc-icons-v2/credit-card.svg'
import NcTrash2Icon from '~icons/nc-icons-v2/trash-2.svg'
import NcSkipBackIcon from '~icons/nc-icons-v2/skip-back.svg'
import NcFilePlusIcon from '~icons/nc-icons-v2/file-plus.svg'
import NcDeleteIcon from '~icons/nc-icons-v2/delete.svg'
import NcCommandIcon from '~icons/nc-icons-v2/command.svg'
import NcClockIcon from '~icons/nc-icons-v2/clock.svg'
import NcOctagonIcon from '~icons/nc-icons-v2/octagon.svg'
import NcPhoneIcon from '~icons/nc-icons-v2/phone.svg'
import NcEyeIcon from '~icons/nc-icons-v2/eye.svg'
import NcPhoneOffIcon from '~icons/nc-icons-v2/phone-off.svg'
import NcExternalLinkIcon from '~icons/nc-icons-v2/external-link.svg'
import NcZapIcon from '~icons/nc-icons-v2/zap.svg'
import NcAgentIcon from '~icons/nc-icons-v2/agent.svg'
import NcMoreVerticalIcon from '~icons/nc-icons-v2/more-vertical.svg'
import NcMicOffIcon from '~icons/nc-icons-v2/mic-off.svg'
import NcShareIcon from '~icons/nc-icons-v2/share.svg'
import NcArrowUpIcon from '~icons/nc-icons-v2/arrow-up.svg'
import NcArrowUpDownIcon from '~icons/nc-icons-v2/arrow-up-down.svg'
import NcBellOffIcon from '~icons/nc-icons-v2/bell-off.svg'
import NcLinkedinIcon from '~icons/nc-icons-v2/linkedin.svg'
import NcVideoIcon from '~icons/nc-icons-v2/video.svg'
import NcActivityIcon from '~icons/nc-icons-v2/activity.svg'
import NcMapPinIcon from '~icons/nc-icons-v2/map-pin.svg'
import NcPinIcon from '~icons/nc-icons-v2/pin.svg'
import NcPinOffIcon from '~icons/nc-icons-v2/pin-off.svg'
import NcFilterIcon from '~icons/nc-icons-v2/filter.svg'
import NcPhoneIncomingIcon from '~icons/nc-icons-v2/phone-incoming.svg'
import NcItalicIcon from '~icons/nc-icons-v2/italic.svg'
import NcChevronsLeftIcon from '~icons/nc-icons-v2/chevrons-left.svg'
import NcCalendarIcon from '~icons/nc-icons-v2/calendar.svg'
import NcGlobeIcon from '~icons/nc-icons-v2/globe.svg'
import NcArrowLeftIcon from '~icons/nc-icons-v2/arrow-left.svg'
import NcAlignCenterIcon from '~icons/nc-icons-v2/align-center.svg'
import NcMinusCircleIcon from '~icons/nc-icons-v2/minus-circle.svg'
import NcArrowDownRightIcon from '~icons/nc-icons-v2/arrow-down-right.svg'
import NcVolumeXIcon from '~icons/nc-icons-v2/volume-x.svg'
import NcCloudIcon from '~icons/nc-icons-v2/cloud.svg'
import NcDownloadCloudIcon from '~icons/nc-icons-v2/download-cloud.svg'
import NcShuffleIcon from '~icons/nc-icons-v2/shuffle.svg'
import NcRewindIcon from '~icons/nc-icons-v2/rewind.svg'
import NcUploadIcon from '~icons/nc-icons-v2/upload.svg'
import NcTrendingDownIcon from '~icons/nc-icons-v2/trending-down.svg'
import NcPauseIcon from '~icons/nc-icons-v2/pause.svg'
import NcArrowDownCircleIcon from '~icons/nc-icons-v2/arrow-down-circle.svg'
import NcBookmarkIcon from '~icons/nc-icons-v2/bookmark.svg'
import NcBookmarkSolidIcon from '~icons/nc-icons-v2/bookmark-solid.svg'
import NcAlertTriangleIcon from '~icons/nc-icons-v2/alert-triangle.svg'
import NcUserCheckIcon from '~icons/nc-icons-v2/user-check.svg'
import NcTabletIcon from '~icons/nc-icons-v2/tablet.svg'
import NcAlertOctagonIcon from '~icons/nc-icons-v2/alert-octagon.svg'
import NcMenuIcon from '~icons/nc-icons-v2/menu.svg'
import NcChromeIcon from '~icons/nc-icons-v2/chrome.svg'
import NcFolderIcon from '~icons/nc-icons-v2/folder.svg'
import NcFolderClosedIcon from '~icons/nc-icons-v2/folder-closed.svg'
import NcFolderOpenIcon from '~icons/nc-icons-v2/folder-open.svg'
import NcPaletteIcon from '~icons/nc-icons-v2/palette.svg'
import NcUsersIcon from '~icons/nc-icons-v2/users.svg'
import NcCornerDownLeftIcon from '~icons/nc-icons-v2/corner-down-left.svg'
import NcMonitorIcon from '~icons/nc-icons-v2/monitor.svg'
import NcMinusIcon from '~icons/nc-icons-v2/minus.svg'
import NcNavigation2Icon from '~icons/nc-icons-v2/navigation-2.svg'
import NcChevronLeftIcon from '~icons/nc-icons-v2/chevron-left.svg'
import NcFilmIcon from '~icons/nc-icons-v2/film.svg'
import NcMoonIcon from '~icons/nc-icons-v2/moon.svg'
import NcShieldOffIcon from '~icons/nc-icons-v2/shield-off.svg'
import NcMousePointerIcon from '~icons/nc-icons-v2/mouse-pointer.svg'
import NcAlignLeftIcon from '~icons/nc-icons-v2/align-left.svg'
import NcInsertColumnLeftIcon from '~icons/nc-icons-v2/insert-column-left.svg'
import NcInsertColumnRightIcon from '~icons/nc-icons-v2/insert-column-right.svg'
import NcInsertRowAboveIcon from '~icons/nc-icons-v2/insert-row-above.svg'
import NcInsertRowBelowIcon from '~icons/nc-icons-v2/insert-row-below.svg'
import NcMoveRowUpIcon from '~icons/nc-icons-v2/move-row-up.svg'
import NcMoveRowDownIcon from '~icons/nc-icons-v2/move-row-down.svg'
import NcMoveColumnLeftIcon from '~icons/nc-icons-v2/move-column-left.svg'
import NcMoveColumnRightIcon from '~icons/nc-icons-v2/move-column-right.svg'
import NcHeartIcon from '~icons/nc-icons-v2/heart.svg'
import NcTrendingUpIcon from '~icons/nc-icons-v2/trending-up.svg'
import NcYoutube2Icon from '~icons/nc-icons/youtube2.svg'
import NcRedditIcon from '~icons/nc-icons/reddit.svg'
import NcTwitterIcon from '~icons/nc-icons/twitter-x-line.svg'
import NcDiscordIcon from '~icons/nc-icons/discord.svg'
import NcVerticalAlignTop from '~icons/nc-icons/align-vertical-top.svg'
import NcVerticalAlignCenter from '~icons/nc-icons/align-vertical-center.svg'
import NcVerticalAlignBottom from '~icons/nc-icons/align-vertical-bottom.svg'
import NcAngleRotateCw from '~icons/nc-icons/angle-rotate-cw.svg'
import NcCheckCircle2 from '~icons/nc-icons/check-2.svg'
import NcMessageCircleFilled from '~icons/nc-icons-v2/message-circle-filled.svg'
import NcChartScatterPlot from '~icons/nc-icons-v2/scatter-plot.svg'
import NcChartDonut from '~icons/nc-icons-v2/chart-donut.svg'
import NcChartBar from '~icons/nc-icons-v2/chart-bar.svg'
import NcChartLine from '~icons/nc-icons-v2/chart-line.svg'
import NcChartPie from '~icons/nc-icons-v2/chart-pie.svg'
import NcGaugeWidget from '~icons/nc-icons-v2/gauge-widget.svg'

import NcSlash1 from '~icons/nc-icons/slash1'

import NcChevronUpSmall from '~icons/nc-icons/chevron-up-small'
import NcChevronDownSmall from '~icons/nc-icons/chevron-down-small'
import NcChevronUpDownSmall from '~icons/nc-icons/chevron-up-down-small'

// Api snippets lang
import NcLangShell from '~icons/nc-icons/lang-shell.svg'
import NcLangJavascript from '~icons/nc-icons/lang-js.svg'
import NcLangNode from '~icons/nc-icons/lang-node.svg'
import NcLangNocodbSdk from '~icons/nc-icons/lang-nc-sdk.svg'
import NcLangPhp from '~icons/nc-icons/lang-php.svg'
import NcLangPython from '~icons/nc-icons/lang-python.svg'
import NcLangRuby from '~icons/nc-icons/lang-ruby.svg'
import NcLangJava from '~icons/nc-icons/lang-java.svg'
import NcLangC from '~icons/nc-icons/lang-c.svg'

import NcGridViewIcon from '~icons/nc-icons/grid'
import NcFormViewIcon from '~icons/nc-icons/form'
import NcGalleryViewIcon from '~icons/nc-icons/gallery'
import NcKanbanViewIcon from '~icons/nc-icons/kanban'
import NcCalendarViewIcon from '~icons/nc-icons/calendar'
import NcTimelineViewIcon from '~icons/nc-icons/timeline'
import NcGanttViewIcon from '~icons/nc-icons/view-gantt'
import NcMapViewIcon from '~icons/nc-icons/map'
import NcPuzzleSolid from '~icons/nc-icons/puzzle-solid'
import NcPuzzleOutline from '~icons/nc-icons/puzzle-outline'

import NcInfoSolid from '~icons/nc-icons/info-solid'
import NcPlaceholderIcon from '~icons/nc-icons/placeholder-icon'
import NcImagePlaceholderIcon from '~icons/nc-icons/image-placeholder.svg'
import NcSpanner from '~icons/nc-icons/spanner'
import NcScript from '~icons/nc-icons/script'
import NcAutoAwesome from '~icons/nc-icons/auto_awesome'
import NcPlusAi from '~icons/nc-icons/plus-ai'
import NcPlusMultiple from '~icons/nc-icons/plus-multiple'
import NcPlusSquareSolid from '~icons/nc-icons/plus-square-solid'
import NcDashboards from '~icons/nc-icons/dashboards'

/* file types */

import NcFileTypeCsv from '~icons/nc-icons-v2/file-type-csv'
import NcFileTypeCsvSmall from '~icons/nc-icons-v2/file-type-csv-small'
import NcFileTypeExcel from '~icons/nc-icons-v2/file-type-excel'
import NcFileTypePdf from '~icons/nc-icons-v2/file-type-pdf'
import NcFileTypeWord from '~icons/nc-icons-v2/file-type-word'
import NcFileTypePresentation from '~icons/nc-icons-v2/file-type-presentation'
import NcFileTypeVideo from '~icons/nc-icons-v2/file-type-video'
import NcFileTypeAudio from '~icons/nc-icons-v2/file-type-audio'
import NcFileTypeImage from '~icons/nc-icons-v2/file-type-image'
import NcFileTypeZip from '~icons/nc-icons-v2/file-type-zip'
import NcFileTypeUnknown from '~icons/nc-icons-v2/file-type-unknown'
import NcFileSearch from '~icons/nc-icons-v2/file-search'
import NcFileTypeJson from '~icons/nc-icons-v2/file-type-json'

/* imports */

import NcImportAirtable from '~icons/nc-icons-v2/import-airtable'
import NcImportCsv from '~icons/nc-icons-v2/import-csv'
import NcImportJson from '~icons/nc-icons-v2/import-json'
import NcImportExcel from '~icons/nc-icons-v2/import-excel'
import NcImportSheets from '~icons/nc-icons-v2/import-sheets'
import NcImportSalesforce from '~icons/nc-icons-v2/import-salesforce'
import NcImportMonday from '~icons/nc-icons-v2/import-monday'

import NcHeading1 from '~icons/nc-icons-v2/heading-1'
import NcHeading2 from '~icons/nc-icons-v2/heading-2'
import NcHeading3 from '~icons/nc-icons-v2/heading-3'
import NcQuote from '~icons/nc-icons-v2/quote'

import NcPenLine from '~icons/nc-icons-v2/pen-line.svg'
import NcNode from '~icons/nc-icons-v2/nc-node.svg'
import NcErd from '~icons/nc-icons/erd'
import NcInsertBefore from '~icons/nc-icons/insert-before'
import NcInsertAfter from '~icons/nc-icons/insert-after'
import NcWebhook from '~icons/nc-icons-v2/webhook'

import NcFormResponse from '~icons/nc-icons-v2/new-form-responce'
import NcRecordCreate from '~icons/nc-icons-v2/record-create'
import NcRecordUpdate from '~icons/nc-icons-v2/record-update'
import NcRecordDelete from '~icons/nc-icons-v2/record-delete'
import NcRecordEntersView from '~icons/nc-icons-v2/record-enters-view'
import NcIfElse from '~icons/nc-icons-v2/if-else'

import NcLogoAsanaColored from '~icons/nc-icons-v2/asana-colored.svg'
import NcLogoAsana from '~icons/nc-icons-v2/asana.svg'
import NcLogoBitbucketColored from '~icons/nc-icons-v2/bitbucket-colored.svg'
import NcLogoBitbucket from '~icons/nc-icons-v2/bitbucket.svg'
import NcLogoBoxLogoColored from '~icons/nc-icons-v2/box-logo-colored.svg'
import NcLogoBoxLogo from '~icons/nc-icons-v2/box-logo.svg'
import NcLogoChromeColored from '~icons/nc-icons-v2/chrome-colored.svg'
import NcLogoClaudeAiColored from '~icons/nc-icons-v2/claude-ai-colored.svg'
import NcLogoClaudeAi from '~icons/nc-icons-v2/claude-ai.svg'
import NcLogoDiscordColored from '~icons/nc-icons-v2/discord-colored.svg'
import NcLogoDiscord from '~icons/nc-icons-v2/discord.svg'
import NcLogoDropboxColored from '~icons/nc-icons-v2/dropbox-colored.svg'
import NcLogoDropbox from '~icons/nc-icons-v2/dropbox.svg'
import NcLogoFacebookColored from '~icons/nc-icons-v2/facebook-colored.svg'
import NcLogoFacebook from '~icons/nc-icons-v2/facebook.svg'
import NcLogoFigmaColored from '~icons/nc-icons-v2/figma-colored.svg'
import NcLogoFigma from '~icons/nc-icons-v2/figma.svg'
import NcLogoFramerColored from '~icons/nc-icons-v2/framer-colored.svg'
import NcLogoFramer from '~icons/nc-icons-v2/framer.svg'
import NcLogoFreshdeskColored from '~icons/nc-icons-v2/freshdesk-colored.svg'
import NcLogoFreshdesk from '~icons/nc-icons-v2/freshdesk.svg'
import NcLogoGeminiAiColored from '~icons/nc-icons-v2/gemini-ai-colored.svg'
import NcLogoGeminiAi from '~icons/nc-icons-v2/gemini-ai.svg'
import NcLogoGithubColored from '~icons/nc-icons-v2/github-colored.svg'
import NcLogoGitlabColored from '~icons/nc-icons-v2/gitlab-colored.svg'
import NcLogoGmailColored from '~icons/nc-icons-v2/gmail-colored.svg'
import NcLogoGmail from '~icons/nc-icons-v2/gmail.svg'
import NcLogoGoogleDriveColored from '~icons/nc-icons-v2/google-drive-colored.svg'
import NcLogoGoogleMapColored from '~icons/nc-icons-v2/google-map-colored.svg'
import NcLogoOpenStreetMapColored from '~icons/nc-icons-v2/open-street-map.svg'
import NcLogoGoogleDrive from '~icons/nc-icons-v2/google-drive.svg'
import NcLogoGreenhouseColored from '~icons/nc-icons-v2/greenhouse-colored.svg'
import NcLogoGreenhouse from '~icons/nc-icons-v2/greenhouse.svg'
import NcLogoGroqAiColored from '~icons/nc-icons-v2/groq-ai-colored.svg'
import NcLogoGroqAi from '~icons/nc-icons-v2/groq-ai.svg'
import NcLogoHubspotColored from '~icons/nc-icons-v2/hubspot-colored.svg'
import NcLogoHubspot from '~icons/nc-icons-v2/hubspot.svg'
import NcLogoInstagramColored from '~icons/nc-icons-v2/instagram-colored.svg'
import NcLogoIntercomColored from '~icons/nc-icons-v2/intercom-colored.svg'
import NcLogoIntercom from '~icons/nc-icons-v2/intercom.svg'
import NcLogoJiraColored from '~icons/nc-icons-v2/jira-colored.svg'
import NcLogoJira from '~icons/nc-icons-v2/jira.svg'
import NcLogoLeverColored from '~icons/nc-icons-v2/lever-colored.svg'
import NcLogoLever from '~icons/nc-icons-v2/lever.svg'
import NcLogoLinkedinColored from '~icons/nc-icons-v2/linkedin-colored.svg'
import NcLogoMailchimpColored from '~icons/nc-icons-v2/mailchimp-colored.svg'
import NcLogoMailchimp from '~icons/nc-icons-v2/mailchimp.svg'
import NcLogoMiroColored from '~icons/nc-icons-v2/miro-colored.svg'
import NcLogoMiro from '~icons/nc-icons-v2/miro.svg'
import NcLogoMondayColored from '~icons/nc-icons-v2/monday-colored.svg'
import NcLogoMsDynamicsColored from '~icons/nc-icons-v2/ms-dynamics-colored.svg'
import NcLogoMsDynamics from '~icons/nc-icons-v2/ms-dynamics.svg'
import NcLogoOllamaColored from '~icons/nc-icons-v2/ollama-colored.svg'
import NcLogoOllama from '~icons/nc-icons-v2/ollama.svg'
import NcLogoOpenAiColored from '~icons/nc-icons-v2/open-ai-colored.svg'
import NcLogoOpenAi from '~icons/nc-icons-v2/open-ai.svg'
import NcLogoOutlookColored from '~icons/nc-icons-v2/outlook-colored.svg'
import NcLogoOutlook from '~icons/nc-icons-v2/outlook.svg'
import NcLogoPipedriveColored from '~icons/nc-icons-v2/pipedrive-colored.svg'
import NcLogoPipedrive from '~icons/nc-icons-v2/pipedrive.svg'
import NcLogoQuickbooksColored from '~icons/nc-icons-v2/quickbooks-colored.svg'
import NcLogoQuickbooks from '~icons/nc-icons-v2/quickbooks.svg'
import NcLogoSalesforceColored from '~icons/nc-icons-v2/salesforce-colored.svg'
import NcLogoSalesforce from '~icons/nc-icons-v2/salesforce.svg'
import NcLogoSlackColored from '~icons/nc-icons-v2/slack-colored.svg'
import NcLogoSlack from '~icons/nc-icons-v2/slack.svg'
import NcLogoStripeColored from '~icons/nc-icons-v2/stripe-colored.svg'
import NcLogoStripe from '~icons/nc-icons-v2/stripe.svg'
import NcLogoSurveyMonkeyColored from '~icons/nc-icons-v2/survey-monkey-colored.svg'
import NcLogoSurveyMonkey from '~icons/nc-icons-v2/survey-monkey.svg'
import NcLogoTeamsColored from '~icons/nc-icons-v2/teams-colored.svg'
import NcLogoTeams from '~icons/nc-icons-v2/teams.svg'
import NcLogoTelegramColored from '~icons/nc-icons-v2/telegram-colored.svg'
import NcLogoTelegram from '~icons/nc-icons-v2/telegram.svg'
import NcLogoTrelloColored from '~icons/nc-icons-v2/trello-colored.svg'
import NcLogoTrello from '~icons/nc-icons-v2/trello.svg'
import NcLogoTwilioColored from '~icons/nc-icons-v2/twilio-colored.svg'
import NcLogoTwilio from '~icons/nc-icons-v2/twilio.svg'
import NcLogoTwitchColored from '~icons/nc-icons-v2/twitch-colored.svg'
import NcLogoTwitch from '~icons/nc-icons-v2/twitch.svg'
import NcLogoTwitterColored from '~icons/nc-icons-v2/twitter-colored.svg'
import NcLogoTwitter from '~icons/nc-icons-v2/twitter.svg'
import NcLogoTypeformColored from '~icons/nc-icons-v2/typeform-colored.svg'
import NcLogoTypeform from '~icons/nc-icons-v2/typeform.svg'
import NcLogoWhatsappColored from '~icons/nc-icons-v2/whatsapp-colored.svg'
import NcLogoWhatsapp from '~icons/nc-icons-v2/whatsapp.svg'
import NcLogoWorkdayColored from '~icons/nc-icons-v2/workday-colored.svg'
import NcLogoWorkdayColoredOutline from '~icons/nc-icons-v2/workday-colored-outline.svg'
import NcLogoWorkday from '~icons/nc-icons-v2/workday.svg'
import NcLogoZendeskColored from '~icons/nc-icons-v2/zendesk-colored.svg'
import NcLogoZendesk from '~icons/nc-icons-v2/zendesk.svg'
import NcLogoZohoColored from '~icons/nc-icons-v2/zoho-colored.svg'
import NcLogoZoho from '~icons/nc-icons-v2/zoho.svg'
import NcLogoBaserowColored from '~icons/nc-icons-v2/baserow-colored.svg'
import NcLogoSoftrColored from '~icons/nc-icons-v2/softr-colored.svg'
import NcLogoNotionColored from '~icons/nc-icons-v2/notion-colored.svg'
import NcLogoCodaColored from '~icons/nc-icons-v2/coda-colored.svg'
import NcLogoRetoolColored from '~icons/nc-icons-v2/retool-colored.svg'
import NcLogoN8nColored from '~icons/nc-icons-v2/n8n-colored.svg'
import NcLogoZapierColored from '~icons/nc-icons-v2/zapier-colored.svg'
import NcLogoMakeColored from '~icons/nc-icons-v2/make-colored.svg'
import NcLogoCrewAi from '~icons/nc-icons-v2/crew-ai.svg'
import NcLogoManusIm from '~icons/nc-icons-v2/manus-im.svg'
import NcLogoHuggingface from '~icons/nc-icons-v2/huggingface-colored.svg'
import NcLogoReplitAi from '~icons/nc-icons-v2/replit-ai-colored.svg'
import NcLogoLangchain from '~icons/nc-icons-v2/langchain.svg'
import NcLogoBambooHrColored from '~icons/nc-icons-v2/bamboo-hr-colored.svg'
import NcLogoDockerColored from '~icons/nc-icons-v2/docker-colored.svg'
import NcLogoHootsuiteColored from '~icons/nc-icons-v2/hootsuite-colored.svg'
import NcLogoGongColored from '~icons/nc-icons-v2/gong-colored.svg'
import NcLogoProductBoardColored from '~icons/nc-icons-v2/product-board-colored.svg'
import NcLogoXeroColored from '~icons/nc-icons-v2/xero-colored.svg'
import NcLogoSketchColored from '~icons/nc-icons-v2/sketch-colored.svg'
import NcLogoLookerColored from '~icons/nc-icons-v2/looker-colored.svg'
import NcLogoPowerLogoColored from '~icons/nc-icons-v2/power-logo-colored.svg'
import NcLogoClickupColored from '~icons/nc-icons-v2/clickup-colored.svg'

import NcSendAlt from '~icons/nc-icons-v2/send-alt.svg'
import NcSendHorizontal from '~icons/nc-icons-v2/send-horizontal.svg'
import NcBaseOutline from '~icons/nc-icons-v2/base-outline.svg'
import NcBasePrivate from '~icons/nc-icons-v2/base-private.svg'
import NcBaseOutlineDuo from '~icons/nc-icons-v2/base-outline-duo.svg'
import NcSearchDuo from '~icons/nc-icons-v2/search-duo.svg'
import NcSettingsDuo from '~icons/nc-icons-v2/settings-duo.svg'
import NcIntegrationDuo from '~icons/nc-icons-v2/integration-duo.svg'
import NcMegaPhoneDuo from '~icons/nc-icons-v2/mega-phone-duo.svg'
import NcNotificationDuo from '~icons/nc-icons-v2/notification-duo.svg'
import NcLayout from '~icons/nc-icons-v2/layout.svg'
import NcPlusCircleSolid from '~icons/nc-icons-v2/plus-circle-solid.svg'
import NcHeadphone from '~icons/nc-icons-v2/headphone'
import NcPaintRoller from '~icons/nc-icons-v2/paint-roller.svg'
import NcConditions from '~icons/nc-icons-v2/conditions.svg'
import NcSun from '~icons/nc-icons-v2/sun.svg'
import NcSunMoon from '~icons/nc-icons-v2/sun-moon.svg'

import MdiNcCheckBold from '~icons/nc-icons/mdi-check-bold'
import MdiNcCropSquare from '~icons/nc-icons/mdi-crop-square'
import MdiNcCheckCircleOutline from '~icons/nc-icons/mdi-check-circle-outline'
import MdiNcCheckboxBlankCircleOutline from '~icons/nc-icons/mdi-checkbox-blank-circle-outline'
import MdiNcStar from '~icons/nc-icons/mdi-star'
import MdiNcStarOutline from '~icons/nc-icons/mdi-star-outline'
import MdiNcHeartOutline from '~icons/nc-icons/mdi-heart-outline'
import MdiNcHeart from '~icons/nc-icons/mdi-heart'
import MdiNcMoonFull from '~icons/nc-icons/mdi-moon-full'
import MdiNcMoonNew from '~icons/nc-icons/mdi-moon-new'
import MdiNcThumbUp from '~icons/nc-icons/mdi-thumb-up'
import MdiNcThumbUpOutline from '~icons/nc-icons/mdi-thumb-up-outline'
import MdiNcFlag from '~icons/nc-icons/mdi-flag'
import MdiNcFlagOutline from '~icons/nc-icons/mdi-flag-outline'
import MdiNcAttachFile from '~icons/nc-icons/mdi-attach'
import MdiCloudKeyOutline from '~icons/mdi/cloud-key-outline'
import NcDiscordForum from '~icons/nc-icons/discord-forum'
import NcCrown from '~icons/nc-icons-v2/crown'
import NcMultiCircle from '~icons/nc-icons-v2/multi-circle'
import NcChatwoot from '~icons/nc-icons-v2/chatwoot'
import NcGraduationCap from '~icons/nc-icons-v2/graduation-cap'
import NcSupportAgent from '~icons/nc-icons-v2/support-agent'
import NcBuilding from '~icons/nc-icons-v2/building'
import NcExtUrlPreviewEmptyState from '~icons/nc-icons/extension-url-preview-empty-state'
import NcClipboardType from '~icons/nc-icons-v2/clipboard-type'
import NcKeyboardIcon from '~icons/nc-icons-v2/keyboard'

// keep it for reference
// todo: remove it after all icons are migrated
/* export const iconMapOld = {
  info: MdiInformationOutline,
  loading: MdiLoading,
  arrowCollapse: MdiArrowCollapse,
  markerAlert: MdiMapMarkerAlert,
  appStore: MdiStorefrontOutline,
  chevronLeft: MdiChevronLeft,
  chevronRight: MdiChevronRight,
  imagePlaceholder: MdiFileImageBox,
  linkRemove: MdiLinkVariantRemove,
  closeThick: MdiCloseThick,
  role: MdiDramaMasks,
  tableKey: MdiTableKey,
  export: PhExportLight,
  colInsertAfter: MdiTableColumnPlusAfter,
  colInsertBefore: MdiTableColumnPlusBefore,
  star: PhStar,
  sortAsc: PhSortAscendingThin,
  sortDesc: PhSortDescendingThin,
  contentSaveExit: MdiContentSave,
  contentSaveStay: MdiContentSaveEdit,
  exit: MdiExitToApp,
  snippet: PhBracketsAngleThin,
  embed: PhBracketsAngleThin,
  list: PhListBulletsThin,
  cloud: PhCloudLightningThin,
  apiAndSupport: PhChatTextThin,
  sort: PhSortAscendingThin,
  translate: PhTranslateThin,
  preview: PhPresentationThin,
  link: PhLinkSimpleHorizontalLight,
  returnKey: PhKeyReturnThin,
  keyboard: PhKeyboardLight,
  accountPlus: PhUserPlusLight,
  database: PhDatabaseLight,
  discord: LogosDiscordIcon,
  reddit: LogosRedditIcon,
  github: PhGithubLogoLight,
  twitter: RiTwitterXFill,
  at: PhAtLight,
  plusCircle: PhPlusCircleLight,
  minusCircle: PhMinusCircleLight,
  save: PhFloppyDiskLight,
  signin: PhSignInLight,
  signout: PhSignOutLight,
  lock: PhLockIcon,
  account: PhAccountIcon,
  accountCircle: PhUserCircleLight,
  users: PhUsersThreeThin,
  download: PhDownloadThin,
  upload: PhUploadThin,
  hook: PhHookThin,
  erd: PhTreeThin,
  plus: PhPlusThin,
  search: PhSearchThin,
  copy: PhCopySimpleThin,
  duplicate: PhCopySimpleThin,
  clipboard: PhClipboardThin,
  settings: PhGearThin,
  image: PhImageThin,
  datasource: PhHardDriveThin,
  book: PhBookThin,
  arrowDown: PhCaretDownLight,
  arrowRight: PhCaretRightLight,
  sidebarMinimise: PhCaretDoubleLeftLight,
  threeDotVertical: MdiDotsVertical,
  threeDotHorizontal: MdiDotsHorizontal,
  table: PhTableThin,
  excel: PhExcelThin,
  csv: PhCsvThin,
  code: PhBracketsCurlyThin,
  delete: PhTrashThin,
  edit: PhPencilSimpleThin,
  lookup: PhListMagnifyingGlassThin,
  text: PhStringIcon,
  longText: PhTextAreaIcon,
  clock: ClockIcon,
  web: WebIcon,
  boolean: BooleanIcon,
  calendar: CalendarIcon,
  singleSelect: SingleSelectIcon,
  multiSelect: PhListBulletsThin,
  datetime: DatetimeIcon,
  geoData: GeoDataIcon,
  rating: PhStar,
  generic: GenericIcon,
  numeric: NumericIcon,
  email: EmailIcon,
  sendEmail: MdiEmailArrowRightOutline,
  currency: CurrencyIcon,
  percent: PercentIcon,
  decimal: DecimalIcon,
  specificDbType: MdiDatabaseSettingsOutline,
  duration: DurationIcon,
  phone: FilePhoneIcon,
  formula: PhFunctiontone,
  function: PhFunctiontone,
  key: KeyIcon,
  json: PhBracketsCurlyThin,
  qrCode: PhQrCodeThin,
  qrCodeScan: MdiQrcodeScan,
  barCode: PhBarcodeThin,
  calculator: PhCalculatorThin,
  rollup: PhLifebuoyThin,
  eye: PhEyeThin,
  eyeSlash: PhEyeSlashThin,
  expand: PhExpandThin,
  check: PhCheckThin,
  acl: PhFolderLockThin,
  sync: MdiDatabaseSync,
  warning: PhWarningThin,
  share: PhShareThin,
  reload: PhReloadThin,
  xml: PhCodeThin,
  airtable: PhGridNineThin,
  grid: PhGridThin,
  gallery: PhImageThin,
  form: PhComputerTowerThin,
  map: MdiMapIcon,
  kanban: PhSquareHalfBottomThin,
  view: PhEyeThin,
  rowHeight: PhSplitVerticalThin,
  filter: PhFunnelThin,
  closeCircle: PhXCircleLight,
  closeBox: PhXSquareLight,
  close: PhXLight,
  openInNew: MdiOpenInNew,
  mm: MMIcon,
  hm: HMIcon,
  bt: BTIcon,
  passwordChange: MdiKeyChange,
  mapMarker: MdiMapMarker,
  currentLocation: MdiGpsFixed,
  plusThick: MdiPlusThick,
  dragVertical: MdiDragVertical,
  databaseSync: MdiDatabaseSync,
  fileUpload: MdiFileUploadOutline,
  drag: MdiDrag,
  comment: MdiCommentTextOutline,
  heightShort: NcIconsRowHeightShort,
  heightMedium: NcIconsRowHeightMedium,
  heightTall: NcIconsRowHeightTall,
  heightExtra: NcIconsRowHeightExtraTall,
} as const */

export const iconMap = {
  'calendar': NcCalendarViewIcon,
  'timeline': NcTimelineViewIcon,
  'gantt': NcGanttViewIcon,
  'grid': NcGridViewIcon,
  'form': NcFormViewIcon,
  'gallery': NcGalleryViewIcon,
  'kanban': NcKanbanViewIcon,
  'map': NcMapViewIcon,

  'strike': NcStrike,
  'atSign': NcAtSign,
  'slash': NcSlash,
  'ncSlash1': NcSlash1,
  'arrowUpRight': NcArrowUpRight,
  'ncWorkspace': NcWorkspace,
  'controlPanel': NcControlPanel,
  'home': NcHome,
  'home1': NcHome1,
  'cellBarcode': h(NcCellBarcode, { stroke: 'transparent' }),
  'cellCheckbox': NcCellCheckbox,
  'cellDate': NcCellDate,
  'cellYear': NcCellYear,
  'cellEmail': NcCellEmail,
  'cellFormula': NcCellFormula,
  'cellCurrency': NcCellCurrency,
  'cellDatetime': NcCellDatetime,
  'cellDb': NcCellDb,
  'cellDecimal': NcCellDecimal,
  'cellDuration': NcCellDuration,
  'cellGeometry': NcCellGeometry,
  'cellJson': NcCellJson,
  'cellLinks': NcCellLinks,
  'cellLongText': NcCellLongText,
  'cellLookup': NcCellLookup,
  'cellMultiSelect': NcCellMultiSelect,
  'cellAutoNumber': NcCellAutoNumber,
  'cellNumber': NcCellNumber,
  'cellPercent': NcCellPercent,
  'cellPhone': NcCellPhone,
  'cellQrCode': NcCellQrCode,
  'cellRating': NcCellRating,
  'cellColour': NcCellColour,
  'cellRollup': h(NcCellRollup, { stroke: 'transparent' }),
  'cellSingleSelect': NcCellSingleSelect,
  'cellText': NcCellText,
  'cellUuid': NcCellUuid,
  'cellTime': NcCellTime,
  'cellUrl': NcCellUrl,
  'cellUser': NcCellUser,
  'cellSystemDate': NcCellSystemDate,
  'cellSystemKey': NcCellSystemKey,
  'cellSystemUser': NcCellSystemUser,
  'cellSystemText': NcCellSystemText,
  'cellAttachment': NcCellAttachment,
  'cellButton': NcCellButton,
  'cellAiButton': h(NcCellAiButton, { stroke: 'transparent' }),
  'cellAi': h(NcCellAi, { stroke: 'transparent' }),
  'camera': NcCamera,
  'megaPhone': NcMegaPhone,
  'nocodb': h(NcNocoDB, { stroke: 'transparent' }),
  'nocodb1': h(NcNocoDB1, { stroke: 'transparent' }),
  'nocodbSquarePuck': h(NcNocoDBSquarePuck, { stroke: 'transparent' }),
  'bulb': NcBulb,
  'snow': NcSnow,

  'office': NcOffice,
  'sort': Sort,
  'group': Group,
  'filter': Filter,
  'fields': Fields,
  'mm': ManytoManyIcon,
  'hm': HasManyIcon,
  'bt': BelongsToIcon,
  'mm_solid': ManytoManySolidIcon,
  'hm_solid': HasManySolidIcon,
  'bt_solid': BelongsToSolidIcon,
  'oneToOneSolid': OnetoOneIcon,
  'workspaceDefault': MsGroup,
  'project': h(Project, { stroke: 'transparent' }),
  'search': NcSearch,
  // calendar: Calendar,
  'checkCircle': NcCheckCircle,
  'checkFill': NcCheckFill,
  'externalLink': NcExternalLink,
  'error': h('span', { class: 'material-symbols' }, 'error'),
  'info': h(MsInfo, {}, () => 'info'),
  'inbox': h('span', { class: 'material-symbols' }, 'inbox'),
  'addOutlineBox': MsAddBoxOutline,
  'loading': h('span', { class: 'material-symbols' }, 'autorenew'),
  'arrowCollapse': Up,
  'markerAlert': h('span', { class: 'material-symbols' }, 'warning'),
  'appStore': h('span', { class: 'material-symbols' }, 'apps'),
  'chevronLeft': NcChevronLeftIcon,
  'chevronRight': NcChevronRightIcon,
  'imagePlaceholder': h('span', { class: 'material-symbols' }, 'insert_photo'),
  'linkRemove': h('span', { class: 'material-symbols' }, 'link_off'),
  'closeThick': h('span', { class: 'material-symbols' }, 'cancel'),
  'role': h('span', { class: 'material-symbols' }, 'badge'),
  'tableKey': h('span', { class: 'material-symbols' }, 'table_rows'),
  'export': h('span', { class: 'material-symbols' }, 'get_app'),
  'colInsertAfter': NcInsertAfter,
  'colInsertBefore': NcInsertBefore,
  'star': NcStar,
  'unStar': NcUnStar,
  'sortDesc': MsSort,
  'article': NcArticle,
  'template': h('span', { class: 'material-symbols' }, 'content_copy'),
  'triangleFill': PhTriangleFill,
  'sortAsc': h('span', { class: 'material-symbols', style: { transform: 'scaleY(-1)' } }, 'sort'),
  'contentSaveExit': h('span', { class: 'material-symbols' }, 'save'),
  'contentSaveStay': h('span', { class: 'material-symbols' }, 'save_as'),
  'exit': h('span', { class: 'material-symbols' }, 'exit_to_app'),
  'snippet': ApiSnippet,
  'embed': h('span', { class: 'material-symbols' }, 'code'),
  'list': h('span', { class: 'material-symbols' }, 'list'),
  'viewList': h('span', { class: 'material-symbols' }, 'view_list'),
  'cloud': h('span', { class: 'material-symbols' }, 'cloud'),
  'apiAndSupport': h('span', { class: 'material-symbols' }, 'api'),
  'translate': h('span', { class: 'material-symbols' }, 'translate'),
  'preview': h('span', { class: 'material-symbols' }, 'visibility'),
  'link': h('span', { class: 'material-symbols' }, 'link'),
  'link2': NcLink,
  'returnKey': h('span', { class: 'material-symbols' }, 'keyboard_return'),
  'keyboard': h('span', { class: 'material-symbols' }, 'keyboard'),
  'accountPlus': h('span', { class: 'material-symbols' }, 'person_add'),
  'database': MsDatabase,
  'discord': LogosDiscordIcon,
  'reddit': LogosRedditIcon,
  'github': PhGithubLogoLight,
  'twitter': RiTwitterXFill,
  'at': h('span', { class: 'material-symbols' }, 'alternate_email'),
  'plusCircle': h('span', { class: 'material-symbols' }, 'add_circle'),
  'minusCircle': h('span', { class: 'material-symbols' }, 'remove_circle'),
  'save': h('span', { class: 'material-symbols' }, 'save'),
  'signin': h('span', { class: 'material-symbols' }, 'login'),
  'signout': h('span', { class: 'material-symbols' }, 'logout'),
  'lock': h('span', { class: 'material-symbols' }, 'lock'),
  'account': h('span', { class: 'material-symbols' }, 'person'),
  'accountCircle': h('span', { class: 'material-symbols' }, 'account_circle'),
  'phUser': PhUser,
  'phUsers': PhUsers,
  'user': NcUser,
  'users': NcUsers,
  'cloudDownload': h('span', { class: 'material-symbols' }, 'cloud_download'),
  'download': NcDownload,
  'cloudUpload': h('span', { class: 'material-symbols' }, 'cloud_upload'),
  'upload': NcUpload,
  'hook': Phishing,
  'erd': h('span', { class: 'material-symbols' }, 'account_tree'),
  'plus': NcPlusIcon,
  'plusSquare': PlusSquare,
  'minus': Minus,
  'help': h('span', { class: 'material-symbols' }, 'help'),
  'copy': NcCopy,
  'duplicate': NcDuplicate,
  'clipboard': h('span', { class: 'material-symbols' }, 'content_paste'),
  'settings': NcSettingsIcon,
  'image': h('span', { class: 'material-symbols' }, 'image'),
  'datasource': h('span', { class: 'material-symbols' }, 'hard_drive'),
  'book': h('span', { class: 'material-symbols' }, 'menu_book'),
  'arrowDown': Down,
  'arrowRight': Right,
  'arrowLeft': Left,
  'arrowUp': Up,
  'layout': PhLayout,
  'sidebar': LayoutSidebar,
  'doubleRightArrow': NcChevronsRightIcon,
  'doubleLeftArrow': NcChevronsLeftIcon,
  'sidebarMinimise': PhCaretDoubleLeftThin, // h('span', { class: 'material-symbols' }, 'left_panel_close'),
  // threeDotVertical: h('span', { class: 'material-symbols' }, 'more_vert'),
  // threeDotHorizontal: h('span', { class: 'material-symbols' }, 'more_horiz'),
  'threeDotVertical': MdiDotsVertical,
  'threeDotHorizontal': MdiDotsHorizontal,
  'tableOld': Record,
  'table': TableCurrent,
  'excel': PhExcelThin, // h('span', { class: 'material-symbols' }, 'grid_on'),
  'csv': PhCsvThin, // h('span', { class: 'material-symbols' }, 'grid_on'),
  'code': Code,
  'palette': h(Palette, {}, () => 'palette'),
  'delete': NcTrash,
  'deleteListItem': h('span', { class: 'material-symbols' }, 'delete'),
  'import': h('span', { class: 'material-symbols' }, 'system_update_alt'),
  'edit': MaterialSymbolsEdit,
  'lookup': LookupIcon,
  'text': h('span', { class: 'material-symbols' }, 'text_fields'),
  'longText': h('span', { class: 'material-symbols' }, 'view_headline'),
  'clock': h('span', { class: 'material-symbols' }, 'access_time'),
  'web': h('span', { class: 'material-symbols' }, 'web'),
  'webhook': h('span', { class: 'material-symbols' }, 'webhook'),
  'boolean': h('span', { class: 'material-symbols' }, 'check_box'),
  'singleSelect': h('span', { class: 'material-symbols' }, 'radio_button_checked'),
  'multiSelect': h('span', { class: 'material-symbols' }, 'check_box_outline_blank'),
  'datetime': h('span', { class: 'material-symbols' }, 'date_range'),
  'geoData': h('span', { class: 'material-symbols' }, 'place'),
  'rating': h('span', { class: 'material-symbols' }, 'star_half'),
  'generic': h('span', { class: 'material-symbols' }, 'toc'),
  'number': h('span', { class: 'material-symbols' }, 'looks_one'),
  'email': h('span', { class: 'material-symbols' }, 'email'),
  'sendEmail': h('span', { class: 'material-symbols' }, 'email'),
  'send': LcSend,
  'dataSource': NcAddDataSource,
  'currency': h('span', { class: 'material-symbols' }, 'attach_money'),
  'percent': h('span', { class: 'material-symbols' }, 'percent'),
  'decimal': h('span', { class: 'material-symbols' }, 'decimal_increase'),
  'specificDbType': h('span', { class: 'material-symbols' }, 'inbox_customize'),
  'duration': h('span', { class: 'material-symbols' }, 'timer'),
  'phone': h('span', { class: 'material-symbols' }, 'phone'),
  'formula': h('span', { class: 'material-symbols' }, 'function'),
  'function': h('span', { class: 'material-symbols' }, 'functions'),
  'key': h('span', { class: 'material-symbols' }, 'key'),
  'json': h('span', { class: 'material-symbols' }, 'code'),
  'qrCode': h('span', { class: 'material-symbols' }, 'qr_code'),
  'qrCodeScan': h('span', { class: 'material-symbols' }, 'qr_code_scanner'),
  'barCode': h('span', { class: 'material-symbols' }, 'barcode'),
  'calculator': h('span', { class: 'material-symbols' }, 'calculate'),
  'rollup': h('span', { class: 'material-symbols' }, 'group_work'),
  'eye': NcEye,
  'eyeSlash': NcEyeOff,
  'expand': h('span', { class: 'material-symbols' }, 'open_in_full'),
  'shrink': h('span', { class: 'material-symbols' }, 'close_fullscreen'),
  'check': NcCheck,
  'circleCheck': MdiCheckboxMarkedCircle,
  'circleCheck3': NcCheckCircle2,
  'acl': h('span', { class: 'material-symbols' }, 'shield'),
  'sync': MsSync,
  'warning': MaterialSymbolsWarningOutlineRounded,
  'share': h('span', { class: 'material-symbols' }, 'share'),
  'mobileShare': MobileShare,
  'reload': MdiRefresh,
  'xml': h('span', { class: 'material-symbols' }, 'code'),
  'airtable': LogosAirtable,
  'excelColored': VscodeIconsExcelColored,
  // grid: h('span', { class: 'material-symbols' }, 'grid_view'),
  // gallery: h('span', { class: 'material-symbols' }, 'image'),
  // form: h('span', { class: 'material-symbols' }, 'article'),
  // 'map': NcMapViewIcon,
  // kanban: h('span', { class: 'material-symbols' }, 'view_kanban'),
  'view': h('span', { class: 'material-symbols' }, 'visibility'),
  // rowHeight: h('span', { class: 'material-symbols' }, 'height'),
  'rowHeight': h(PhSplitVerticalThin, { style: { fontSize: '14px' } }),
  'columnWidth': h(PhSplitHorizontalThin, { style: { fontSize: '14px' } }),
  'closeCircle': h('span', { class: 'material-symbols' }, 'cancel'),
  'closeBox': h('span', { class: 'material-symbols' }, 'close'),
  'close': MSCloseRounded,
  'openInNew': h('span', { class: 'material-symbols' }, 'open_in_new'),
  'passwordChange': h('span', { class: 'material-symbols' }, 'vpn_key'),
  'mapMarker': h('span', { class: 'material-symbols' }, 'room'),
  'currentLocation': h('span', { class: 'material-symbols' }, 'my_location'),
  'plusThick': h('span', { class: 'material-symbols' }, 'add_box'),
  'dragVertical': h('span', { class: 'material-symbols' }, 'drag_indicator'),
  'databaseSync': h('span', { class: 'material-symbols' }, 'sync_alt'),
  'fileUpload': h('span', { class: 'material-symbols' }, 'cloud_upload'),
  'drag': MaterialSymbolsDragIndicator,
  'comment': h('span', { class: 'material-symbols' }, 'comment'),
  'doc': h('span', { class: 'material-symbols' }, 'menu_book'),
  'menu': NcMenuIcon,
  'move': MsMove,
  'creditCard': NcCreditCard,
  'heightShort': NcIconsRowHeightShort,
  'heightMedium': NcIconsRowHeightMedium,
  'heightTall': NcIconsRowHeightTall,
  'heightExtra': NcIconsRowHeightExtraTall,
  'databaseSearch': MdiDatabaseSearch,
  'layers': NcLayers,
  'ncDatabase': NcDatabaseIcon,
  'magic': PhSparkleFill,
  'magic1': MdiMagicStaff,
  'workspace': h('span', { class: 'material-symbols' }, 'dataset'),
  'notification': NcNotification,
  'role_owner': Owner,
  'role_creator': Creator,
  'role_editor': Editor,
  'role_commenter': Commentor,
  'role_viewer': Viewer,
  'role_inherit': NcLayers,
  'role_super': SuperAdmin,
  'role_no_access': NoAccess,
  'commentHere': NcCommentHere,
  'fileImage': FileImageIcon,
  'paste': NcPaste,
  'chevronDown': NcChevronDown,
  'pencil': NcPencil,
  'rename': NcRename,
  'ncEdit': NcEdit,
  'ncArrowUp': NcArrowUp,
  'ncArrowDown': NcArrowDown,
  'ncArrowLeft': NcArrowLeft,
  'ncArrowRight': NcArrowRight,
  'underline': NcUnderline,
  'bold': NcBold,
  'italic': NcItalic,
  'phoneCall': NcPhoneCall,
  'crop': NcCrop,
  'circleCheck2': NcCircleCheck,
  'ncDiscord': NcDiscord,
  'ncReddit': NcReddit,
  'ncTwitter': NcTwitter,
  'file': NcFile,
  'fileBig': NcFileBig,
  'ncSettings': NcSettings,
  'ncHelp': NcHelp,
  'puzzle': MdiPuzzle,
  'arrowDropUp': MaterialSymbolsArrowDropUp,
  'arrowDropDown': MaterialSymbolsArrowDropDown,
  'alertTriangle': NcAlertTriangle,
  'audit': NcAudit,
  'messageCircle': NcMessageCircle,
  'ncKey': NcKey,
  'minimize': NcMinimize,
  'minimizeAll': NcMinimizeAll,
  'maximize': NcMaximize,
  'maximizeAll': NcMaximizeAll,
  'ncDrag': NcDrag,
  'refresh': NcRefresh,
  'chevronUpDown': NcChevronUpDown,
  'play': NcPlay,
  'googleDocs': GoogleDocs,
  'pdfFile': MdiPdf,
  'globe': NcGlobe,
  'integration': NcIntegration,
  'gitCommit': NcGitCommit,
  'circle': NcCircle,
  'server1': NcServer1,
  'thumbsUpOutline': NcThumbsUpOutline,
  'appleSolid': NcAppleSolid,
  'asana': NcAsana,
  'box': NcBox,
  'githubSolid': NcGithubSolid,
  'chatwoot': h(NcChatwoot, { stroke: 'transparent' }),
  'linear': NcLinear,
  'gitlab': NcGitlab,
  'googleCalendar': NcGoogleCalendar,
  'googleSheet': NcGoogleSheet,
  'googleDrive': NcGoogleDrive,
  'hubspot': h(NcHubspot, { stroke: 'transparent' }),
  'jira': NcJira,
  'mailchimp': NcMailchimp,
  'microsoftAccess': NcMicrosoftAccess,
  'microsoftExcel': NcMicrosoftExcel,
  'microsoftOutlook': NcMicrosoftOutlook,
  'ncMailchimp': h(NcMailchimp, { stroke: 'transparent' }),
  'miro': NcMiro,
  'salesforce': h(NcSalesforce, { stroke: 'transparent' }),
  'snowflake': NcSnowflake,
  'stripe': NcStripe,
  'surveyMonkey': NcSurveyMonkey,
  'tableau': h(NcTableau, { stroke: 'transparent' }),
  'trello': NcTrello,
  'typeform': NcTypeform,
  'workday': NcWorkday,
  'zendesk': NcZendesk,
  'freshdesk': NcFreshdesk,
  'bookOpen': NcBookOpen,
  'circleCheckSolid': NcCircleCheckSolid,
  'alertTriangleSolid': NcAlertTriangleSolid,
  'mail': NcMail,
  'slack': NcSlack,
  'microsoftTeams': NcMicrosoftTeams,
  'mattermost': NcMattermost,
  'twilio': NcTwilio,
  'whatsapp': NcWhatsapp,
  'whatsappSolid': NcWhatsappSolid,
  'dollerSign': NcDollerSign,
  'multiFile': NcMultiFile,
  'heart': NcHeart,
  'ncSave': NcSave,
  'mysql': NcMySql,
  'postgreSql': NcPostgreSql,
  'sqlServer': NcSqlServer,
  'dataBricks': NcDataBricks,
  'mssqlServer': NcMssqlServer,
  'gmail': NcGmail,
  'telegram': NcTelegram,
  'microsoftDynamics365': NcMicrosoftDynamics365,
  'pipedrive': NcPipedrive,
  'zohoCrm': NcZohoCrm,
  'greenhouse': NcGreenhouse,
  'lever': h(NcLever, { stroke: 'transparent' }),
  'bitBucket': NcBitBucket,
  'bambooHR': NcLogoBambooHrColored,
  'quickbooks': NcQuickbooks,
  'intercom': NcIntercom,
  'dropbox': NcDropbox,
  'gift': NcIconsGift,
  'openai': h(NcOpenai, { stroke: 'transparent' }),
  'claude': h(NcClaude, { stroke: 'transparent' }),
  'ollama': h(NcOllama, { stroke: 'transparent' }),
  'groq': h(NcGroq, { stroke: 'transparent' }),
  'posthog': h(NcPosthog, { stroke: 'transparent' }),
  'nocodbPg': h(NcNocodbPg, { stroke: 'transparent' }),
  'refreshCw': NcRefreshCW,
  'iconReddit': NcRedditIcon,
  'iconTwitter': NcTwitterIcon,
  'iconDiscord': NcDiscordIcon,
  'attachFile': MdiNcAttachFile,
  'dashboards': NcDashboards,

  // Nc-IconsV2 Buttons
  'ncColumns': NcColumnsIcon,
  'ncUnderline': NcUnderlineIcon,
  'ncGrid': NcGridIcon,
  'ncTriangle': NcTriangleIcon,
  'ncSearch': NcSearchIcon,
  'ncVolume2': NcVolume2Icon,
  'ncArrowUpCircle': NcArrowUpCircleIcon,
  'ncArrowUpCircleSolid': NcArrowUpCircleSolidIcon,
  'ncPauseCircle': NcPauseCircleIcon,
  'ncCheckSquare': NcCheckSquareIcon,
  'ncArrowDown2': NcArrowDownIcon,
  'ncCornerRightUp': NcCornerRightUpIcon,
  'ncChevronsRight': NcChevronsRightIcon,
  'ncList': NcListIcon,
  'ncListEnd': NcListEndIcon,
  'ncWandSparkles': NcWandSparklesIcon,
  'ncUpgradeSparkle': h(NcUpgradeSparkleIcon, { stroke: 'transparent' }),
  'ncNumberList': NcNumberListIcon,
  'ncCheckList': NcCheckListIcon,
  'ncChevronsDown': NcChevronsDownIcon,
  'ncCornerUpRight': NcCornerUpRightIcon,
  'ncTarget': NcTargetIcon,
  'ncScissors': NcScissorsIcon,
  'ncMinimize2': NcMinimize2Icon,
  'ncPlayCircle': NcPlayCircleIcon,
  'ncCrosshair': NcCrosshairIcon,
  'ncAirplay': NcAirplayIcon,
  'ncXOctagon': NcXOctagonIcon,
  'ncRepeat': NcRepeatIcon,
  'ncEdit3': NcEdit3Icon,
  'ncVolume1': NcVolume1Icon,
  'ncToggleRight': NcToggleRightIcon,
  'ncUser': NcUserIcon,
  'ncFileMinus': NcFileMinusIcon,
  'ncXCircle': NcXCircleIcon,
  'ncCircle': NcCircleIcon,
  'ncPhoneMissed': NcPhoneMissedIcon,
  'ncEdit2': NcEdit2Icon,
  'ncCornerLeftUp': NcCornerLeftUpIcon,
  'ncHome': NcHomeIcon,
  'ncHomeFilled': h(NcHomeFilledIcon, { stroke: 'transparent' }),
  'ncTableOutline': NcTableOutlineIcon,
  'ncTableFilled': h(NcTableFilledIcon, { stroke: 'transparent' }),
  'ncAutomationsFilled': h(NcAutomationsFilledIcon, { stroke: 'transparent' }),
  'ncGitlab': NcGitlabIcon,
  'ncSmartphone': NcSmartphoneIcon,
  'ncMoreHorizontal': NcMoreHorizontalIcon,
  'ncSliders': NcSlidersIcon,
  'sliders': NcSlidersIcon,
  'ncArrowUpLeft': NcArrowUpLeftIcon,
  'ncChevronDown': NcChevronDownIcon,
  'ncHexagon': NcHexagonIcon,
  'ncGithub': NcGithubIcon,
  'ncCrop': NcCropIcon,
  'ncBriefcase': NcBriefcaseIcon,
  'ncRotateCw': NcRotateCwIcon,
  'ncInbox': NcInboxIcon,
  'ncAlignJustify': NcAlignJustifyIcon,
  'ncPlusSquare': NcPlusSquareIcon,
  'ncPower': NcPowerIcon,
  'ncCameraOff': NcCameraOffIcon,
  'ncToggleLeft': NcToggleLeftIcon,
  'ncFile': NcFileIcon,
  'ncMessageCircle': NcMessageCircleIcon,
  'ncTerminal': NcTerminalIcon,
  'ncMove': NcMoveIcon,
  'ncMoveHorizontal': NcMoveHorizontalIcon,
  'ncMaximize': NcMaximizeIcon,
  'ncChevronUp': NcChevronUpIcon,
  'ncArrowDownLeft': NcArrowDownLeftIcon,
  'ncFileText': NcFileTextIcon,
  'ncFileTextSolid': NcFileTextSolidIcon,
  'ncDroplet': NcDropletIcon,
  'ncZapOff': NcZapOffIcon,
  'ncX': NcXIcon,
  'ncBarChart': NcBarChartIcon,
  'ncLock': NcLockIcon,
  'ncLogIn': NcLogInIcon,
  'ncRefreshCw': NcRefreshCwIcon,
  'ncChevronRight': NcChevronRightIcon,
  'ncClipboard': NcClipboardIcon,
  'ncPackage': NcPackageIcon,
  'ncInstagram': NcInstagramIcon,
  'ncLink': NcLinkIcon,
  'ncVideoOff': NcVideoOffIcon,
  'ncKey2': NcKeyIcon,
  'ncCornerDownRight': NcCornerDownRightIcon,
  'ncArrowRight2': NcArrowRightIcon,
  'ncStopCircle2': NcStopCircleIcon,
  'ncLogOut': NcLogOutIcon,
  'ncArrowLeftCircle': NcArrowLeftCircleIcon,
  'ncBarChart2': NcBarChart2Icon,
  'ncGitPullRequest': NcGitPullRequestIcon,
  'ncMinimize': NcMinimizeIcon,
  'ncMinusSquare': NcMinusSquareIcon,
  'ncSettings2': NcSettingsIcon,
  'ncCloudSnow': NcCloudSnowIcon,
  'ncThumbsDown': NcThumbsDownIcon,
  'ncType': NcTypeIcon,
  'ncPhoneOutgoing': NcPhoneOutgoingIcon,
  'ncPocket': NcPocketIcon,
  'ncMail': NcMailIcon,
  'ncShield': NcShieldIcon,
  'ncDownload': NcDownloadIcon,
  'ncPhoneForwarded': NcPhoneForwardedIcon,
  'ncCornerRightDown': NcCornerRightDownIcon,
  'ncBookOpen': NcBookOpenIcon,
  'ncServer': NcServerIcon,
  'ncTv': NcTvIcon,
  'ncSkipForward': NcSkipForwardIcon,
  'ncVolume': NcVolumeIcon,
  'ncUserPlus': NcUserPlusIcon,
  'ncBatteryCharging': NcBatteryChargingIcon,
  'ncLayers': NcLayersIcon,
  'ncSlash': NcSlashIcon,
  'ncRadio': NcRadioIcon,
  'ncBook': NcBookIcon,
  'ncUserMinus': NcUserMinusIcon,
  'ncBell': NcBellIcon,
  'ncGitBranch': NcGitBranchIcon,
  'ncCode': NcCodeIcon,
  'ncCodeBlock': NcCodeBlockIcon,
  'ncCast': NcCastIcon,
  'ncFlag': NcFlagIcon,
  'ncEyeOff': NcEyeOffIcon,
  'ncBattery': NcBatteryIcon,
  'ncDisc': NcDiscIcon,
  'ncFrown': NcFrownIcon,
  'ncTool': NcToolIcon,
  'ncBold': NcBoldIcon,
  'ncHash': NcHashIcon,
  'ncShare2': NcShare2Icon,
  'ncPlus': NcPlusIcon,
  'ncCheck': NcCheckIcon,
  'ncRotateCcw': NcRotateCcwIcon,
  'ncUndo': NcUndoIcon,
  'ncRedo': NcRedoIcon,
  'ncHardDrive': NcHardDriveIcon,
  'ncBluetooth': NcBluetoothIcon,
  'ncPieChart': NcPieChartIcon,
  'ncRss': NcRssIcon,
  'ncWifi': NcWifiIcon,
  'ncCornerUpLeft': NcCornerUpLeftIcon,
  'ncInfo': NcInfoIcon,
  'ncUserX': NcUserXIcon,
  'ncLoader': NcLoaderIcon,
  'ncRefreshCcw': NcRefreshCcwIcon,
  'ncFolderPlus': NcFolderPlusIcon,
  'ncMic': NcMicIcon,
  'ncCopy': NcCopyIcon,
  'ncZoomIn': NcZoomInIcon,
  'ncArrowRightCircle': NcArrowRightCircleIcon,
  'ncAlignRight': NcAlignRightIcon,
  'ncImage': NcImageIcon,
  'ncMaximize2': NcMaximize2Icon,
  'ncCheckCircle': NcCheckCircleIcon,
  'ncSave2': NcSaveIcon,
  'ncSmile': NcSmileIcon,
  'ncNavigation': NcNavigationIcon,
  'ncPaperclip': NcPaperclipIcon,
  'ncFastForward': NcFastForwardIcon,
  'ncXSquare': NcXSquareIcon,
  'ncAward': NcAwardIcon,
  'ncZoomOut': NcZoomOutIcon,
  'ncBox': NcBoxIcon,
  'ncThumbsUp': NcThumbsUpIcon,
  'ncPercent': NcPercentIcon,
  'ncSidebar': NcSidebarIcon,
  'ncSquare': NcSquareIcon,
  'ncPlay': NcPlayIcon,
  'ncGitCommit': NcGitCommitIcon,
  'ncSend': NcSendIcon,
  'ncPhoneCall': NcPhoneCallIcon,
  'ncCamera': NcCameraIcon,
  'ncLink2': NcLink2Icon,
  'ncPrinter': NcPrinterIcon,
  'ncFolderMinus': NcFolderMinusIcon,
  'ncArrowUpRight': NcArrowUpRightIcon,
  'ncPenTool': NcPenToolIcon,
  'ncAtSign': NcAtSignIcon,
  'ncTrash': NcTrashIcon,
  'ncHistory': NcHistoryIcon,
  'ncWifiOff': NcWifiOffIcon,
  'ncCornerLeftDown': NcCornerLeftDownIcon,
  'ncDollarSign': NcDollarSignIcon,
  'ncStar': NcStarIcon,
  'ncCloudOff': NcCloudOffIcon,
  'ncMessageSquare': NcMessageSquareIcon,
  'ncMessageSquare1Outline': NcMessageSquare1OutlineIcon,
  'ncMessageSquare1Solid': NcMessageSquare1SolidIcon,
  'ncEDit2': NcEditIcon,
  'ncAlertCircle': NcAlertCircleIcon,
  'ncAlertCircleFilled': NcAlertCircleFilledIcon,
  'ncChevronsUp': NcChevronsUpIcon,
  'ncUploadCloud': NcUploadCloudIcon,
  'ncYoutube': NcYoutubeIcon,
  'ncUnlock': h(NcUnlockIcon, { stroke: 'transparent' }),
  'ncCompass': NcCompassIcon,
  'ncPlusCircle': NcPlusCircleIcon,
  'ncCreditCard': NcCreditCardIcon,
  'ncTrash2': NcTrash2Icon,
  'ncSkipBack': NcSkipBackIcon,
  'ncFilePlus': NcFilePlusIcon,
  'ncDelete': NcDeleteIcon,
  'ncCommand': NcCommandIcon,
  'ncClock': NcClockIcon,
  'ncOctagon': NcOctagonIcon,
  'ncPhone': NcPhoneIcon,
  'ncEye': NcEyeIcon,
  'ncPhoneOff': NcPhoneOffIcon,
  'ncExternalLink': NcExternalLinkIcon,
  'ncZap': NcZapIcon,
  'ncAgent': h(NcAgentIcon, { stroke: 'transparent' }),
  'ncTable': h(NcTableIcon, { stroke: 'transparent' }),
  'ncMoreVertical': NcMoreVerticalIcon,
  'ncMicOff': NcMicOffIcon,
  'ncShare': NcShareIcon,
  'ncArrowUp2': NcArrowUpIcon,
  'ncArrowUpDown': NcArrowUpDownIcon,
  'ncBellOff': NcBellOffIcon,
  'ncLinkedin': NcLinkedinIcon,
  'ncVideo': NcVideoIcon,
  'ncActivity': NcActivityIcon,
  'ncMapPin': NcMapPinIcon,
  'ncPin': NcPinIcon,
  'ncPinOff': NcPinOffIcon,
  'ncFilter': NcFilterIcon,
  'ncPhoneIncoming': NcPhoneIncomingIcon,
  'ncItalic': NcItalicIcon,
  'ncChevronsLeft': NcChevronsLeftIcon,
  'ncCalendar': NcCalendarIcon,
  'ncGlobe': NcGlobeIcon,
  'ncArrowLeft2': NcArrowLeftIcon,
  'ncAlignCenter': NcAlignCenterIcon,
  'ncMinusCircle': NcMinusCircleIcon,
  'ncArrowDownRight': NcArrowDownRightIcon,
  'ncVolumeX': NcVolumeXIcon,
  'ncCloud': NcCloudIcon,
  'ncDownloadCloud': NcDownloadCloudIcon,
  'ncShuffle': NcShuffleIcon,
  'ncRewind': NcRewindIcon,
  'ncUpload': NcUploadIcon,
  'ncTrendingDown': NcTrendingDownIcon,
  'ncPause': NcPauseIcon,
  'ncArrowDownCircle': NcArrowDownCircleIcon,
  'ncBookmark': NcBookmarkIcon,
  'ncBookmarkSolid': h(NcBookmarkSolidIcon, { stroke: 'transparent' }),
  'ncAlertTriangle': NcAlertTriangleIcon,
  'ncUserCheck': NcUserCheckIcon,
  'ncTablet': NcTabletIcon,
  'ncAlertOctagon': NcAlertOctagonIcon,
  'ncMenu': NcMenuIcon,
  'ncChrome': NcChromeIcon,
  'ncFolder': NcFolderIcon,
  'ncFolderClosed': NcFolderClosedIcon,
  'ncFolderOpen': NcFolderOpenIcon,
  'ncPalette': NcPaletteIcon,
  'ncUsers': NcUsersIcon,
  'ncCornerDownLeft': NcCornerDownLeftIcon,
  'ncMonitor': NcMonitorIcon,
  'ncMinus': NcMinusIcon,
  'ncNavigation2': NcNavigation2Icon,
  'ncChevronLeft': NcChevronLeftIcon,
  'ncFilm': NcFilmIcon,
  'ncMoon': NcMoonIcon,
  'ncShieldOff': NcShieldOffIcon,
  'ncMousePointer': NcMousePointerIcon,
  'ncAlignLeft': NcAlignLeftIcon,
  'ncInsertColumnLeft': NcInsertColumnLeftIcon,
  'ncInsertColumnRight': NcInsertColumnRightIcon,
  'ncInsertRowAbove': NcInsertRowAboveIcon,
  'ncInsertRowBelow': NcInsertRowBelowIcon,
  'ncMoveRowUp': NcMoveRowUpIcon,
  'ncMoveRowDown': NcMoveRowDownIcon,
  'ncMoveColumnLeft': NcMoveColumnLeftIcon,
  'ncMoveColumnRight': NcMoveColumnRightIcon,
  'ncVerticalAlignTop': NcVerticalAlignTop,
  'ncVerticalAlignCenter': NcVerticalAlignCenter,
  'ncVerticalAlignBottom': NcVerticalAlignBottom,
  'ncAngleRotateCw': NcAngleRotateCw,
  'ncHeart': NcHeartIcon,
  'ncTrendingUp': NcTrendingUpIcon,
  'chevronUpSmall': NcChevronUpSmall,
  'chevronDownSmall': NcChevronDownSmall,
  'chevronUpDownSmall': NcChevronUpDownSmall,
  'langShell': NcLangShell,
  'langJavascript': NcLangJavascript,
  'langNode': NcLangNode,
  'langNocodbSdk': NcLangNocodbSdk,
  'langPhp': NcLangPhp,
  'langPython': NcLangPython,
  'langRuby': NcLangRuby,
  'langJava': NcLangJava,
  'langC': NcLangC,
  'ncPuzzleSolid': NcPuzzleSolid,
  'ncPuzzleOutline': NcPuzzleOutline,
  'ncInfoSolid': NcInfoSolid,
  'ncPlaceholderIcon': NcPlaceholderIcon,
  'ncImagePlaceholderIcon': h(NcImagePlaceholderIcon, { stroke: 'transparent' }),
  'ncSpanner': NcSpanner,
  'ncScript': NcScript,
  'youtube': NcYoutube2Icon,
  'ncEnter': NcEnter,
  'NcAmazonAws': h(NcAmazonAws, { stroke: 'transparent' }),
  'ncAutoAwesome': h(NcAutoAwesome, { stroke: 'transparent' }),
  'ncPlusAi': h(NcPlusAi, { stroke: 'transparent' }),
  'ncPlusMultiple': NcPlusMultiple,
  'ncPlusSquareSolid': h(NcPlusSquareSolid, { stroke: 'transparent' }),
  'ncFileTypeCsv': h(NcFileTypeCsv, { stroke: 'transparent' }),
  'ncFileTypeCsvSmall': h(NcFileTypeCsvSmall, { stroke: 'transparent' }),
  'ncFileTypeExcel': h(NcFileTypeExcel, { stroke: 'transparent' }),
  'ncFileTypePdf': h(NcFileTypePdf, { stroke: 'transparent' }),
  'ncFileTypeWord': h(NcFileTypeWord, { stroke: 'transparent' }),
  'ncFileTypePresentation': h(NcFileTypePresentation, { stroke: 'transparent' }),
  'ncFileTypeVideo': h(NcFileTypeVideo, { stroke: 'transparent' }),
  'ncFileTypeAudio': h(NcFileTypeAudio, { stroke: 'transparent' }),
  'ncFileTypeImage': h(NcFileTypeImage, { stroke: 'transparent' }),
  'ncFileTypeZip': h(NcFileTypeZip, { stroke: 'transparent' }),
  'ncFileTypeUnknown': h(NcFileTypeUnknown, { stroke: 'transparent' }),
  'ncFileSearch': h(NcFileSearch, { stroke: 'transparent' }),
  'ncFileTypeJson': h(NcFileTypeJson, { stroke: 'transparent' }),
  'ncErd': h(NcErd, { stroke: 'transparent' }),
  'ncPenLine': h(NcPenLine, { stroke: 'transparent' }),
  'ncNode': h(NcNode, { stroke: 'transparent' }),
  'importAirtable': h(NcImportAirtable, { stroke: 'transparent' }),
  'importCsv': h(NcImportCsv, { stroke: 'transparent' }),
  'importJson': h(NcImportJson, { stroke: 'transparent' }),
  'importExcel': h(NcImportExcel, { stroke: 'transparent' }),
  'importSheets': h(NcImportSheets, { stroke: 'transparent' }),
  'importSalesforce': h(NcImportSalesforce, { stroke: 'transparent' }),
  'importMonday': h(NcImportMonday, { stroke: 'transparent' }),
  'ncHeading1': NcHeading1,
  'ncHeading2': NcHeading2,
  'ncHeading3': NcHeading3,
  'ncQuote': NcQuote,
  'ncAutomation': AutomationIcon,
  'ncWebhook': NcWebhook,
  'ncMessageCircleFilled': NcMessageCircleFilled,
  'ncLogoAsanaColored': h(NcLogoAsanaColored, { stroke: 'transparent' }),
  'ncLogoAsana': h(NcLogoAsana, { stroke: 'transparent' }),
  'ncLogoBitbucketColored': h(NcLogoBitbucketColored, { stroke: 'transparent' }),
  'ncLogoBitbucket': h(NcLogoBitbucket, { stroke: 'transparent' }),
  'ncLogoBoxLogoColored': h(NcLogoBoxLogoColored, { stroke: 'transparent' }),
  'ncLogoBoxLogo': h(NcLogoBoxLogo, { stroke: 'transparent' }),
  'ncLogoChromeColored': h(NcLogoChromeColored, { stroke: 'transparent' }),
  'ncLogoClaudeAiColored': h(NcLogoClaudeAiColored, { stroke: 'transparent' }),
  'ncLogoClaudeAi': h(NcLogoClaudeAi, { stroke: 'transparent' }),
  'ncLogoDiscord': h(NcLogoDiscord, { stroke: 'transparent' }),
  'ncLogoDiscordColored': h(NcLogoDiscordColored, { stroke: 'transparent' }),
  'ncLogoDropboxColored': h(NcLogoDropboxColored, { stroke: 'transparent' }),
  'ncLogoDropbox': h(NcLogoDropbox, { stroke: 'transparent' }),
  'ncLogoFacebookColored': h(NcLogoFacebookColored, { stroke: 'transparent' }),
  'ncLogoFacebook': h(NcLogoFacebook, { stroke: 'transparent' }),
  'ncLogoFigmaColored': h(NcLogoFigmaColored, { stroke: 'transparent' }),
  'ncLogoFigma': h(NcLogoFigma, { stroke: 'transparent' }),
  'ncLogoFramerColored': h(NcLogoFramerColored, { stroke: 'transparent' }),
  'ncLogoFramer': h(NcLogoFramer, { stroke: 'transparent' }),
  'ncLogoFreshdeskColored': h(NcLogoFreshdeskColored, { stroke: 'transparent' }),
  'ncLogoFreshdesk': h(NcLogoFreshdesk, { stroke: 'transparent' }),
  'ncLogoGeminiAiColored': h(NcLogoGeminiAiColored, { stroke: 'transparent' }),
  'ncLogoGeminiAi': h(NcLogoGeminiAi, { stroke: 'transparent' }),
  'ncLogoGithubColored': h(NcLogoGithubColored, { stroke: 'transparent' }),
  'ncLogoGitlabColored': h(NcLogoGitlabColored, { stroke: 'transparent' }),
  'ncLogoGmailColored': h(NcLogoGmailColored, { stroke: 'transparent' }),
  'ncLogoGmail': h(NcLogoGmail, { stroke: 'transparent' }),
  'ncLogoGoogleDriveColored': h(NcLogoGoogleDriveColored, { stroke: 'transparent' }),
  'ncLogoGoogleDrive': h(NcLogoGoogleDrive, { stroke: 'transparent' }),
  'ncLogoGreenhouseColored': h(NcLogoGreenhouseColored, { stroke: 'transparent' }),
  'ncLogoGoogleMapColored': h(NcLogoGoogleMapColored, { stroke: 'transparent' }),
  'ncLogoOpenStreetMapColored': h(NcLogoOpenStreetMapColored, { stroke: 'transparent' }),
  'ncLogoGreenhouse': h(NcLogoGreenhouse, { stroke: 'transparent' }),
  'ncLogoGroqAiColored': h(NcLogoGroqAiColored, { stroke: 'transparent' }),
  'ncLogoGroqAi': h(NcLogoGroqAi, { stroke: 'transparent' }),
  'ncLogoHubspotColored': h(NcLogoHubspotColored, { stroke: 'transparent' }),
  'ncLogoHubspot': h(NcLogoHubspot, { stroke: 'transparent' }),
  'ncLogoInstagramColored': h(NcLogoInstagramColored, { stroke: 'transparent' }),
  'ncLogoIntercomColored': h(NcLogoIntercomColored, { stroke: 'transparent' }),
  'ncLogoIntercom': h(NcLogoIntercom, { stroke: 'transparent' }),
  'ncLogoJiraColored': h(NcLogoJiraColored, { stroke: 'transparent' }),
  'ncLogoJira': h(NcLogoJira, { stroke: 'transparent' }),
  'ncLogoLeverColored': h(NcLogoLeverColored, { stroke: 'transparent' }),
  'ncLogoLever': h(NcLogoLever, { stroke: 'transparent' }),
  'ncLogoLinkedinColored': h(NcLogoLinkedinColored, { stroke: 'transparent' }),
  'ncLogoMailchimpColored': h(NcLogoMailchimpColored, { stroke: 'transparent' }),
  'ncLogoMailchimp': h(NcLogoMailchimp, { stroke: 'transparent' }),
  'ncLogoMiroColored': h(NcLogoMiroColored, { stroke: 'transparent' }),
  'ncLogoMiro': h(NcLogoMiro, { stroke: 'transparent' }),
  'ncLogoMondayColored': h(NcLogoMondayColored, { stroke: 'transparent' }),
  'ncLogoMsDynamicsColored': h(NcLogoMsDynamicsColored, { stroke: 'transparent' }),
  'ncLogoMsDynamics': h(NcLogoMsDynamics, { stroke: 'transparent' }),
  'ncLogoOllamaColored': h(NcLogoOllamaColored, { stroke: 'transparent' }),
  'ncLogoOllama': h(NcLogoOllama, { stroke: 'transparent' }),
  'ncLogoOpenAiColored': h(NcLogoOpenAiColored, { stroke: 'transparent' }),
  'ncLogoOpenAi': h(NcLogoOpenAi, { stroke: 'transparent' }),
  'ncLogoOutlookColored': h(NcLogoOutlookColored, { stroke: 'transparent' }),
  'ncLogoOutlook': h(NcLogoOutlook, { stroke: 'transparent' }),
  'ncLogoPipedriveColored': h(NcLogoPipedriveColored, { stroke: 'transparent' }),
  'ncLogoPipedrive': h(NcLogoPipedrive, { stroke: 'transparent' }),
  'ncLogoQuickbooksColored': h(NcLogoQuickbooksColored, { stroke: 'transparent' }),
  'ncLogoQuickbooks': h(NcLogoQuickbooks, { stroke: 'transparent' }),
  'ncLogoSalesforceColored': h(NcLogoSalesforceColored, { stroke: 'transparent' }),
  'ncLogoSalesforce': h(NcLogoSalesforce, { stroke: 'transparent' }),
  'ncLogoSlackColored': h(NcLogoSlackColored, { stroke: 'transparent' }),
  'ncLogoSlack': h(NcLogoSlack, { stroke: 'transparent' }),
  'ncLogoStripeColored': h(NcLogoStripeColored, { stroke: 'transparent' }),
  'ncLogoStripe': h(NcLogoStripe, { stroke: 'transparent' }),
  'ncLogoSurveyMonkeyColored': h(NcLogoSurveyMonkeyColored, { stroke: 'transparent' }),
  'ncLogoSurveyMonkey': h(NcLogoSurveyMonkey, { stroke: 'transparent' }),
  'ncLogoTeamsColored': h(NcLogoTeamsColored, { stroke: 'transparent' }),
  'ncLogoTeams': h(NcLogoTeams, { stroke: 'transparent' }),
  'ncLogoTelegramColored': h(NcLogoTelegramColored, { stroke: 'transparent' }),
  'ncLogoTelegram': h(NcLogoTelegram, { stroke: 'transparent' }),
  'ncLogoTrelloColored': h(NcLogoTrelloColored, { stroke: 'transparent' }),
  'ncLogoTrello': h(NcLogoTrello, { stroke: 'transparent' }),
  'ncLogoTwilioColored': h(NcLogoTwilioColored, { stroke: 'transparent' }),
  'ncLogoTwilio': h(NcLogoTwilio, { stroke: 'transparent' }),
  'ncLogoTwitchColored': h(NcLogoTwitchColored, { stroke: 'transparent' }),
  'ncLogoTwitch': h(NcLogoTwitch, { stroke: 'transparent' }),
  'ncLogoTwitterColored': h(NcLogoTwitterColored, { stroke: 'transparent' }),
  'ncLogoTwitter': h(NcLogoTwitter, { stroke: 'transparent' }),
  'ncLogoTypeformColored': h(NcLogoTypeformColored, { stroke: 'transparent' }),
  'ncLogoTypeform': h(NcLogoTypeform, { stroke: 'transparent' }),
  'ncLogoWhatsappColored': h(NcLogoWhatsappColored, { stroke: 'transparent' }),
  'ncLogoWhatsapp': h(NcLogoWhatsapp, { stroke: 'transparent' }),
  'ncLogoWorkdayColored': h(NcLogoWorkdayColored, { stroke: 'transparent' }),
  'ncLogoWorkdayColoredOutline': h(NcLogoWorkdayColoredOutline, { stroke: 'transparent' }),
  'ncLogoWorkday': h(NcLogoWorkday, { stroke: 'transparent' }),
  'ncLogoZendeskColored': h(NcLogoZendeskColored, { stroke: 'transparent' }),
  'ncLogoZendesk': h(NcLogoZendesk, { stroke: 'transparent' }),
  'ncLogoZohoColored': h(NcLogoZohoColored, { stroke: 'transparent' }),
  'ncLogoZoho': h(NcLogoZoho, { stroke: 'transparent' }),
  'ncLogoBaserowColored': h(NcLogoBaserowColored, { stroke: 'transparent' }),
  'ncLogoSoftrColored': h(NcLogoSoftrColored, { stroke: 'transparent' }),
  'ncLogoNotionColored': h(NcLogoNotionColored, { stroke: 'transparent' }),
  'ncLogoCodaColored': h(NcLogoCodaColored, { stroke: 'transparent' }),
  'ncLogoRetoolColored': h(NcLogoRetoolColored, { stroke: 'transparent' }),
  'ncLogoN8nColored': h(NcLogoN8nColored, { stroke: 'transparent' }),
  'ncLogoZapierColored': h(NcLogoZapierColored, { stroke: 'transparent' }),
  'ncLogoMakeColored': h(NcLogoMakeColored, { stroke: 'transparent' }),
  'ncLogoCrewAi': h(NcLogoCrewAi, { stroke: 'transparent' }),
  'ncLogoManusIm': h(NcLogoManusIm, { stroke: 'transparent' }),
  'ncLogoHuggingface': h(NcLogoHuggingface, { stroke: 'transparent' }),
  'ncLogoReplitAi': h(NcLogoReplitAi, { stroke: 'transparent' }),
  'ncLogoLangchain': h(NcLogoLangchain, { stroke: 'transparent' }),
  'ncLogoBambooHrColored': h(NcLogoBambooHrColored, { stroke: 'transparent' }),
  'ncLogoDockerColored': h(NcLogoDockerColored, { stroke: 'transparent' }),
  'ncLogoHootsuiteColored': h(NcLogoHootsuiteColored, { stroke: 'transparent' }),
  'ncLogoGongColored': h(NcLogoGongColored, { stroke: 'transparent' }),
  'ncLogoProductBoardColored': h(NcLogoProductBoardColored, { stroke: 'transparent' }),
  'ncLogoXeroColored': h(NcLogoXeroColored, { stroke: 'transparent' }),
  'ncLogoSketchColored': h(NcLogoSketchColored, { stroke: 'transparent' }),
  'ncLogoLookerColored': h(NcLogoLookerColored, { stroke: 'transparent' }),
  'ncLogoPowerLogoColored': h(NcLogoPowerLogoColored, { stroke: 'transparent' }),
  'ncLogoClickupColored': h(NcLogoClickupColored, { stroke: 'transparent' }),

  'ncSendAlt': h(NcSendAlt, { stroke: 'transparent' }),
  'ncSendHorizontal': NcSendHorizontal,
  'ncStopCircle': h(NcStopCircle, { stroke: 'transparent' }),
  'ncAiPlay': AiPlayIcon,
  'ncPaintRoller': NcPaintRoller,
  'ncConditions': NcConditions,
  'mdi-check-bold': MdiNcCropSquare,
  'mdi-crop-square': MdiNcCheckBold,
  'mdi-check-circle-outline': MdiNcCheckCircleOutline,
  'mdi-checkbox-blank-circle-outline': MdiNcCheckboxBlankCircleOutline,
  'mdi-star': MdiNcStar,
  'mdi-star-outline': MdiNcStarOutline,
  'mdi-heart': MdiNcHeart,
  'mdi-heart-outline': MdiNcHeartOutline,
  'mdi-moon-full': MdiNcMoonFull,
  'mdi-moon-new': MdiNcMoonNew,
  'mdi-thumb-up': MdiNcThumbUp,
  'mdi-thumb-up-outline': MdiNcThumbUpOutline,
  'mdi-flag': MdiNcFlag,
  'mdi-flag-outline': MdiNcFlagOutline,
  'sso': MdiCloudKeyOutline,
  'mcp': NcMCP,
  'ncBaseOutline': NcBaseOutline,
  'ncBasePrivate': NcBasePrivate,
  'ncBaseOutlineDuo': NcBaseOutlineDuo,
  'ncSearchDuo': NcSearchDuo,
  'ncSettingsDuo': NcSettingsDuo,
  'ncIntegrationDuo': NcIntegrationDuo,
  'ncMegaPhoneDuo': NcMegaPhoneDuo,
  'ncNotificationDuo': NcNotificationDuo,
  'ncLayout': NcLayout,
  'ncPlusCircleSolid': h(NcPlusCircleSolid, { stroke: 'transparent' }),
  'ncDiscordForum': NcDiscordForum,
  'ncHeadphone': NcHeadphone,
  'ncCrown': NcCrown,
  'ncMultiCircle': NcMultiCircle,
  'ncChartScatterPlot': h(NcChartScatterPlot, { stroke: 'transparent' }),
  'ncChartBar': h(NcChartBar, { stroke: 'transparent' }),
  'ncChartLine': h(NcChartLine, { stroke: 'transparent' }),
  'ncChartDonut': h(NcChartDonut, { stroke: 'transparent' }),
  'ncChartPie': h(NcChartPie, { stroke: 'transparent' }),
  'ncGaugeWidget': h(NcGaugeWidget, { stroke: 'transparent' }),
  'ncSun': NcSun,
  'ncSunMoon': NcSunMoon,
  'ncGraduationCap': NcGraduationCap,
  'ncSupportAgent': h(NcSupportAgent, { stroke: 'transparent' }),
  'ncBuilding': NcBuilding,
  'ncRecordCreate': NcRecordCreate,
  'ncRecordUpdate': NcRecordUpdate,
  'ncRecordDelete': NcRecordDelete,
  'ncRecordFind': NcAuditNew,
  'ncFormResponse': NcFormResponse,
  'ncIfElse': NcIfElse,
  'ncRecordEntersView': NcRecordEntersView,
  'ncExtUrlPreviewEmptyState': h(NcExtUrlPreviewEmptyState, { stroke: 'transparent' }),
  'ncClipboardType': NcClipboardType,
  'ncKeyboard': NcKeyboardIcon,
}

export const getMdiIcon = (type: string): any => {
  switch (type) {
    case 'mdi-check-bold':
      return MdiCheckBold
    case 'mdi-crop-square':
      return MdiCropSquare
    case 'mdi-check-circle-outline':
      return MdiCheckCircleOutline
    case 'mdi-checkbox-blank-circle-outline':
      return MdiCheckboxBlankCircleOutline
    case 'mdi-star':
      return MdiStar
    case 'mdi-star-outline':
      return MdiStarOutline
    case 'mdi-heart':
      return MdiHeart
    case 'mdi-heart-outline':
      return MdiHeartOutline
    case 'mdi-moon-full':
      return MdiMoonFull
    case 'mdi-moon-new':
      return MdiMoonNew
    case 'mdi-thumb-up':
      return MdiThumbUp
    case 'mdi-thumb-up-outline':
      return MdiThumbUpOutline
    case 'mdi-flag':
      return MdiFlag
    case 'mdi-flag-outline':
      return MdiFlagOutline
    case 'mdi-table-large':
      return MdiTableLarge
    case 'mdi-eye-circle-outline':
      return MdiEyeCircleOutline
    case 'mdi-account-group':
      return MdiAccountGroup
  }
}

export const emojiIcons = [
  'world-map',
  'map-of-japan',
  'snow-capped-mountain',
  'mountain',
  'volcano',
  'mount-fuji',
  'camping',
  'beach-with-umbrella',
  'desert',
  'desert-island',
  'national-park',
  'stadium',
  'classical-building',
  'building-construction',
  'houses',
  'derelict-house',
  'house',
  'house-with-garden',
  'office-building',
  'japanese-post-office',
  'post-office',
  'hospital',
  'bank',
  'hotel',
  'love-hotel',
  'convenience-store',
  'school',
  'department-store',
  'factory',
  'japanese-castle',
  'castle',
  'wedding',
  'tokyo-tower',
  'statue-of-liberty',
  'church',
  'mosque',
  'synagogue',
  'shinto-shrine',
  'kaaba',
  'fountain',
  'tent',
  'foggy',
  'night-with-stars',
  'cityscape',
  'sunrise-over-mountains',
  'sunrise',
  'cityscape-at-dusk',
  'sunset',
  'bridge-at-night',
  'hot-springs',
  'carousel-horse',
  'ferris-wheel',
  'roller-coaster',
  'barber-pole',
  'circus-tent',
  'locomotive',
  'railway-car',
  'high-speed-train',
  'bullet-train',
  'train',
  'metro',
  'light-rail',
  'station',
  'tram',
  'monorail',
  'mountain-railway',
  'tram-car',
  'bus',
  'oncoming-bus',
  'trolleybus',
  'minibus',
  'ambulance',
  'fire-engine',
  'police-car',
  'oncoming-police-car',
  'taxi',
  'oncoming-taxi',
  'automobile',
  'oncoming-automobile',
  'sport-utility-vehicle',
  'delivery-truck',
  'articulated-lorry',
  'tractor',
  'racing-car',
  'motorcycle',
  'motor-scooter',
  'bicycle',
  'kick-scooter',
  'bus-stop',
  'motorway',
  'railway-track',
  'oil-drum',
  'fuel-pump',
  'police-car-light',
  'horizontal-traffic-light',
  'vertical-traffic-light',
  'stop-sign',
  'construction',
  'anchor',
  'sailboat',
  'canoe',
  'speedboat',
  'passenger-ship',
  'ferry',
  'motor-boat',
  'ship',
  'airplane',
  'small-airplane',
  'airplane-departure',
  'airplane-arrival',
  'seat',
  'helicopter',
  'suspension-railway',
  'mountain-cableway',
  'aerial-tramway',
  'satellite',
  'rocket',
  'bellhop-bell',
  'hourglass-done',
  'hourglass-not-done',
  'watch',
  'alarm-clock',
  'stopwatch',
  'timer-clock',
  'mantelpiece-clock',
  'twelve-oclock',
  'twelve-thirty',
  'one-oclock',
  'one-thirty',
  'two-thirty',
  'three-oclock',
  'three-thirty',
  'four-oclock',
  'four-thirty',
  'five-oclock',
  'five-thirty',
  'six-oclock',
  'six-thirty',
  'seven-oclock',
  'seven-thirty',
  'eight-oclock',
  'eight-thirty',
  'nine-oclock',
  'nine-thirty',
  'ten-oclock',
  'ten-thirty',
  'eleven-oclock',
  'eleven-thirty',
  'new-moon',
  'waxing-crescent-moon',
  'first-quarter-moon',
  'waxing-gibbous-moon',
  'full-moon',
  'waning-gibbous-moon',
  'last-quarter-moon',
  'waning-crescent-moon',
  'crescent-moon',
  'new-moon-face',
  'first-quarter-moon-face',
  'last-quarter-moon-face',
  'thermometer',
  'sun',
  'full-moon-face',
  'sun-with-face',
  'star',
  'glowing-star',
  'shooting-star',
  'milky-way',
  'cloud',
  'sun-behind-cloud',
  'cloud-with-lightning-and-rain',
  'sun-behind-small-cloud',
  'sun-behind-large-cloud',
  'sun-behind-rain-cloud',
  'cloud-with-rain',
  'cloud-with-snow',
  'cloud-with-lightning',
  'tornado',
  'fog',
  'wind-face',
  'cyclone',
  'rainbow',
  'closed-umbrella',
  'umbrella',
  'umbrella-with-rain-drops',
  'umbrella-on-ground',
  'high-voltage',
  'snowflake',
  'snowman',
  'snowman-without-snow',
  'comet',
  'fire',
  'droplet',
  'water-wave',
  'jack-o-lantern',
  'christmas-tree',
  'fireworks',
  'sparkler',
  'sparkles',
  'balloon',
  'party-popper',
  'confetti-ball',
  'tanabata-tree',
  'pine-decoration',
  'japanese-dolls',
  'carp-streamer',
  'wind-chime',
  'moon-viewing-ceremony',
  'ribbon',
  'wrapped-gift',
  'reminder-ribbon',
  'admission-tickets',
  'ticket',
  'military-medal',
  'trophy',
  'sports-medal',
  '1st-place-medal',
  '2nd-place-medal',
  '3rd-place-medal',
  'soccer-ball',
  'baseball',
  'basketball',
  'volleyball',
  'american-football',
  'rugby-football',
  'tennis',
  'bowling',
  'cricket-game',
  'field-hockey',
  'ice-hockey',
  'ping-pong',
  'badminton',
  'boxing-glove',
  'martial-arts-uniform',
  'goal-net',
  'flag-in-hole',
  'ice-skate',
  'fishing-pole',
  'running-shirt',
  'skis',
  'direct-hit',
  'pool-8-ball',
  'crystal-ball',
  'video-game',
  'joystick',
  'slot-machine',
  'game-die',
  'spade-suit',
  'heart-suit',
  'diamond-suit',
  'club-suit',
  'joker',
  'mahjong-red-dragon',
  'flower-playing-cards',
  'performing-arts',
  'framed-picture',
  'artist-palette',
  'glasses',
  'sunglasses',
  'necktie',
  't-shirt',
  'jeans',
  'dress',
  'kimono',
  'bikini',
  'womans-clothes',
  'purse',
  'handbag',
  'clutch-bag',
  'shopping-bags',
  'backpack',
  'mans-shoe',
  'running-shoe',
  'high-heeled-shoe',
  'womans-sandal',
  'womans-boot',
  'crown',
  'womans-hat',
  'top-hat',
  'graduation-cap',
  'rescue-workers-helmet',
  'prayer-beads',
  'lipstick',
  'ring',
  'gem-stone',
  'muted-speaker',
  'speaker-low-volume',
  'speaker-medium-volume',
  'speaker-high-volume',
  'loudspeaker',
  'megaphone',
  'postal-horn',
  'bell',
  'bell-with-slash',
  'musical-score',
  'musical-note',
  'musical-notes',
  'studio-microphone',
  'level-slider',
  'control-knobs',
  'microphone',
  'headphone',
  'radio',
  'saxophone',
  'guitar',
  'musical-keyboard',
  'trumpet',
  'violin',
  'drum',
  'mobile-phone',
  'mobile-phone-with-arrow',
  'telephone',
  'telephone-receiver',
  'pager',
  'fax-machine',
  'battery',
  'electric-plug',
  'desktop-computer',
  'printer',
  'keyboard',
  'computer-mouse',
  'trackball',
  'computer-disk',
  'floppy-disk',
  'optical-disk',
  'dvd',
  'movie-camera',
  'film-frames',
  'film-projector',
  'clapper-board',
  'television',
  'camera',
  'camera-with-flash',
  'video-camera',
  'videocassette',
  'magnifying-glass-tilted-left',
  'magnifying-glass-tilted-right',
  'candle',
  'light-bulb',
  'flashlight',
  'red-paper-lantern',
  'notebook-with-decorative-cover',
  'closed-book',
  'open-book',
  'green-book',
  'blue-book',
  'orange-book',
  'books',
  'notebook',
  'ledger',
  'page-with-curl',
  'scroll',
  'page-facing-up',
  'newspaper',
  'rolled-up-newspaper',
  'bookmark-tabs',
  'bookmark',
  'label',
  'money-bag',
  'yen-banknote',
  'dollar-banknote',
  'euro-banknote',
  'pound-banknote',
  'money-with-wings',
  'credit-card',
  'chart-increasing-with-yen',
  'envelope',
  'e-mail',
  'incoming-envelope',
  'envelope-with-arrow',
  'outbox-tray',
  'inbox-tray',
  'package',
  'closed-mailbox-with-raised-flag',
  'closed-mailbox-with-lowered-flag',
  'open-mailbox-with-raised-flag',
  'open-mailbox-with-lowered-flag',
  'postbox',
  'ballot-box-with-ballot',
  'pencil',
  'black-nib',
  'fountain-pen',
  'pen',
  'paintbrush',
  'crayon',
  'memo',
  'briefcase',
  'file-folder',
  'open-file-folder',
  'card-index-dividers',
  'calendar',
  'tear-off-calendar',
  'spiral-notepad',
  'spiral-calendar',
  'card-index',
  'chart-increasing',
  'chart-decreasing',
  'bar-chart',
  'clipboard',
  'pushpin',
  'round-pushpin',
  'paperclip',
  'linked-paperclips',
  'straight-ruler',
  'triangular-ruler',
  'scissors',
  'card-file-box',
  'file-cabinet',
  'wastebasket',
  'locked',
  'unlocked',
  'locked-with-pen',
  'locked-with-key',
  'key',
  'old-key',
  'hammer',
  'pick',
  'hammer-and-pick',
  'hammer-and-wrench',
  'dagger',
  'crossed-swords',
  'pistol',
  'bow-and-arrow',
  'shield',
  'wrench',
  'nut-and-bolt',
  'gear',
  'clamp',
  'balance-scale',
  'link',
  'chains',
  'alembic',
  'microscope',
  'telescope',
  'satellite-antenna',
  'syringe',
  'pill',
  'door',
  'bed',
  'couch-and-lamp',
  'toilet',
  'shower',
  'bathtub',
  'shopping-cart',
  'cigarette',
  'coffin',
  'funeral-urn',
  'moai',
  'atm-sign',
  'litter-in-bin-sign',
  'potable-water',
  'wheelchair-symbol',
  'mens-room',
  'womens-room',
  'restroom',
  'baby-symbol',
  'water-closet',
  'passport-control',
  'customs',
  'baggage-claim',
  'left-luggage',
  'warning',
  'children-crossing',
  'no-entry',
  'prohibited',
  'no-bicycles',
  'no-smoking',
  'no-littering',
  'non-potable-water',
  'no-pedestrians',
  'no-mobile-phones',
  'no-one-under-eighteen',
  'radioactive',
  'biohazard',
  'up-arrow',
  'up-right-arrow',
  'right-arrow',
  'down-right-arrow',
  'down-arrow',
  'down-left-arrow',
  'left-arrow',
  'up-left-arrow',
  'up-down-arrow',
  'left-right-arrow',
  'right-arrow-curving-left',
  'left-arrow-curving-right',
  'right-arrow-curving-up',
  'right-arrow-curving-down',
  'clockwise-vertical-arrows',
  'counterclockwise-arrows-button',
  'back-arrow',
  'end-arrow',
  'on-arrow',
  'soon-arrow',
  'top-arrow',
  'place-of-worship',
  'atom-symbol',
  'om',
  'star-of-david',
  'wheel-of-dharma',
  'yin-yang',
  'latin-cross',
  'orthodox-cross',
  'star-and-crescent',
  'peace-symbol',
  'menorah',
  'dotted-six-pointed-star',
  'aries',
  'taurus',
  'gemini',
  'cancer',
  'leo',
  'virgo',
  'libra',
  'scorpio',
  'sagittarius',
  'capricorn',
  'aquarius',
  'pisces',
  'ophiuchus',
  'shuffle-tracks-button',
  'repeat-button',
  'repeat-single-button',
  'play-button',
  'fast-forward-button',
  'next-track-button',
  'play-or-pause-button',
  'reverse-button',
  'fast-reverse-button',
  'last-track-button',
  'upwards-button',
  'fast-up-button',
  'downwards-button',
  'fast-down-button',
  'pause-button',
  'stop-button',
  'record-button',
  'eject-button',
  'cinema',
  'dim-button',
  'bright-button',
  'antenna-bars',
  'vibration-mode',
  'mobile-phone-off',
  'double-exclamation-mark',
  'exclamation-question-mark',
  'question-mark',
  'white-question-mark',
  'white-exclamation-mark',
  'exclamation-mark',
  'wavy-dash',
  'currency-exchange',
  'heavy-dollar-sign',
  'recycling-symbol',
  'fleur-de-lis',
  'trident-emblem',
  'name-badge',
  'japanese-symbol-for-beginner',
  'cross-mark',
  'cross-mark-button',
  'curly-loop',
  'double-curly-loop',
  'part-alternation-mark',
  'eight-spoked-asterisk',
  'eight-pointed-star',
  'sparkle',
  'copyright',
  'registered',
  'trade-mark',
  'keycap-asterisk',
  'keycap-10',
  'input-latin-uppercase',
  'input-latin-lowercase',
  'input-numbers',
  'input-symbols',
  'input-latin-letters',
  'cl-button',
  'cool-button',
  'free-button',
  'information',
  'id-button',
  'circled-m',
  'new-button',
  'ng-button',
  'ok-button',
  'p-button',
  'sos-button',
  'vs-button',
  'japanese-here-button',
  'japanese-service-charge-button',
  'japanese-monthly-amount-button',
  'japanese-not-free-of-charge-button',
  'japanese-reserved-button',
  'japanese-bargain-button',
  'japanese-discount-button',
  'japanese-free-of-charge-button',
  'japanese-prohibited-button',
  'japanese-acceptable-button',
  'japanese-application-button',
  'japanese-passing-grade-button',
  'japanese-vacancy-button',
  'japanese-congratulations-button',
  'japanese-secret-button',
  'japanese-open-for-business-button',
  'japanese-no-vacancy-button',
  'black-circle',
  'white-circle',
  'black-large-square',
  'white-large-square',
  'black-medium-square',
  'white-medium-square',
  'black-medium-small-square',
  'white-medium-small-square',
  'black-small-square',
  'white-small-square',
  'large-orange-diamond',
  'large-blue-diamond',
  'small-orange-diamond',
  'small-blue-diamond',
  'red-triangle-pointed-up',
  'red-triangle-pointed-down',
  'diamond-with-a-dot',
  'radio-button',
  'white-square-button',
  'black-square-button',
  'flag-england',
  'flag-scotland',
  'digit-zero',
  'asterisk',
  'digit-nine',
  'digit-one',
  'digit-two',
  'digit-three',
  'digit-four',
  'digit-five',
  'digit-six',
  'digit-seven',
  'digit-eight',
  'grinning-face',
  'grinning-face-with-big-eyes',
  'grinning-face-with-smiling-eyes',
  'beaming-face-with-smiling-eyes',
  'grinning-squinting-face',
  'grinning-face-with-sweat',
  'rolling-on-the-floor-laughing',
  'face-with-tears-of-joy',
  'slightly-smiling-face',
  'upside-down-face',
  'winking-face',
  'smiling-face-with-smiling-eyes',
  'smiling-face-with-halo',
  'smiling-face-with-heart-eyes',
  'face-blowing-a-kiss',
  'kissing-face',
  'smiling-face',
  'kissing-face-with-closed-eyes',
  'kissing-face-with-smiling-eyes',
  'face-savoring-food',
  'face-with-tongue',
  'winking-face-with-tongue',
  'squinting-face-with-tongue',
  'money-mouth-face',
  'hugging-face',
  'thinking-face',
  'zipper-mouth-face',
  'neutral-face',
  'expressionless-face',
  'face-without-mouth',
  'smirking-face',
  'unamused-face',
  'face-with-rolling-eyes',
  'grimacing-face',
  'lying-face',
  'relieved-face',
  'pensive-face',
  'sleepy-face',
  'drooling-face',
  'sleeping-face',
  'face-with-medical-mask',
  'face-with-thermometer',
  'face-with-head-bandage',
  'nauseated-face',
  'sneezing-face',
  'dizzy-face',
  'cowboy-hat-face',
  'smiling-face-with-sunglasses',
  'nerd-face',
  'confused-face',
  'worried-face',
  'slightly-frowning-face',
  'frowning-face',
  'face-with-open-mouth',
  'hushed-face',
  'astonished-face',
  'flushed-face',
  'frowning-face-with-open-mouth',
  'anguished-face',
  'fearful-face',
  'anxious-face-with-sweat',
  'sad-but-relieved-face',
  'crying-face',
  'loudly-crying-face',
  'face-screaming-in-fear',
  'confounded-face',
  'persevering-face',
  'disappointed-face',
  'downcast-face-with-sweat',
  'weary-face',
  'tired-face',
  'face-with-steam-from-nose',
  'pouting-face',
  'angry-face',
  'smiling-face-with-horns',
  'angry-face-with-horns',
  'skull',
  'skull-and-crossbones',
  'pile-of-poo',
  'clown-face',
  'ogre',
  'goblin',
  'ghost',
  'alien',
  'alien-monster',
  'see-no-evil-monkey',
  'hear-no-evil-monkey',
  'speak-no-evil-monkey',
  'kiss-mark',
  'love-letter',
  'heart-with-arrow',
  'heart-with-ribbon',
  'sparkling-heart',
  'growing-heart',
  'beating-heart',
  'revolving-hearts',
  'two-hearts',
  'heart-decoration',
  'broken-heart',
  'red-heart',
  'yellow-heart',
  'green-heart',
  'blue-heart',
  'purple-heart',
  'black-heart',
  'hundred-points',
  'anger-symbol',
  'collision',
  'dizzy',
  'sweat-droplets',
  'dashing-away',
  'hole',
  'bomb',
  'speech-balloon',
  'eye-in-speech-bubble',
  'left-speech-bubble',
  'right-anger-bubble',
  'thought-balloon',
  'zzz',
  'waving-hand',
  'waving-hand-light-skin-tone',
  'waving-hand-medium-light-skin-tone',
  'waving-hand-medium-skin-tone',
  'waving-hand-medium-dark-skin-tone',
  'waving-hand-dark-skin-tone',
  'raised-back-of-hand',
  'raised-back-of-hand-light-skin-tone',
  'raised-back-of-hand-medium-light-skin-tone',
  'raised-back-of-hand-medium-skin-tone',
  'raised-back-of-hand-medium-dark-skin-tone',
  'raised-back-of-hand-dark-skin-tone',
  'hand-with-fingers-splayed',
  'hand-with-fingers-splayed-light-skin-tone',
  'hand-with-fingers-splayed-medium-light-skin-tone',
  'hand-with-fingers-splayed-medium-skin-tone',
  'hand-with-fingers-splayed-medium-dark-skin-tone',
  'hand-with-fingers-splayed-dark-skin-tone',
  'raised-hand',
  'raised-hand-light-skin-tone',
  'raised-hand-medium-light-skin-tone',
  'raised-hand-medium-skin-tone',
  'raised-hand-medium-dark-skin-tone',
  'raised-hand-dark-skin-tone',
  'vulcan-salute',
  'vulcan-salute-light-skin-tone',
  'vulcan-salute-medium-light-skin-tone',
  'vulcan-salute-medium-skin-tone',
  'vulcan-salute-medium-dark-skin-tone',
  'vulcan-salute-dark-skin-tone',
  'ok-hand',
  'ok-hand-light-skin-tone',
  'ok-hand-medium-light-skin-tone',
  'ok-hand-medium-skin-tone',
  'ok-hand-medium-dark-skin-tone',
  'ok-hand-dark-skin-tone',
  'victory-hand',
  'victory-hand-light-skin-tone',
  'victory-hand-medium-light-skin-tone',
  'victory-hand-medium-skin-tone',
  'victory-hand-medium-dark-skin-tone',
  'victory-hand-dark-skin-tone',
  'crossed-fingers',
  'crossed-fingers-light-skin-tone',
  'crossed-fingers-medium-light-skin-tone',
  'crossed-fingers-medium-skin-tone',
  'crossed-fingers-medium-dark-skin-tone',
  'crossed-fingers-dark-skin-tone',
  'sign-of-the-horns',
  'sign-of-the-horns-light-skin-tone',
  'sign-of-the-horns-medium-light-skin-tone',
  'sign-of-the-horns-medium-skin-tone',
  'sign-of-the-horns-medium-dark-skin-tone',
  'sign-of-the-horns-dark-skin-tone',
  'call-me-hand',
  'call-me-hand-light-skin-tone',
  'call-me-hand-medium-light-skin-tone',
  'call-me-hand-medium-skin-tone',
  'call-me-hand-medium-dark-skin-tone',
  'call-me-hand-dark-skin-tone',
  'backhand-index-pointing-left',
  'backhand-index-pointing-left-light-skin-tone',
  'backhand-index-pointing-left-medium-light-skin-tone',
  'backhand-index-pointing-left-medium-skin-tone',
  'backhand-index-pointing-left-medium-dark-skin-tone',
  'backhand-index-pointing-left-dark-skin-tone',
  'backhand-index-pointing-right',
  'backhand-index-pointing-right-light-skin-tone',
  'backhand-index-pointing-right-medium-light-skin-tone',
  'backhand-index-pointing-right-medium-skin-tone',
  'backhand-index-pointing-right-medium-dark-skin-tone',
  'backhand-index-pointing-right-dark-skin-tone',
  'backhand-index-pointing-up',
  'backhand-index-pointing-up-light-skin-tone',
  'backhand-index-pointing-up-medium-light-skin-tone',
  'backhand-index-pointing-up-medium-skin-tone',
  'backhand-index-pointing-up-medium-dark-skin-tone',
  'backhand-index-pointing-up-dark-skin-tone',
  'middle-finger',
  'middle-finger-light-skin-tone',
  'middle-finger-medium-light-skin-tone',
  'middle-finger-medium-skin-tone',
  'middle-finger-medium-dark-skin-tone',
  'middle-finger-dark-skin-tone',
  'backhand-index-pointing-down',
  'backhand-index-pointing-down-light-skin-tone',
  'backhand-index-pointing-down-medium-light-skin-tone',
  'backhand-index-pointing-down-medium-skin-tone',
  'backhand-index-pointing-down-medium-dark-skin-tone',
  'backhand-index-pointing-down-dark-skin-tone',
  'index-pointing-up',
  'index-pointing-up-light-skin-tone',
  'index-pointing-up-medium-light-skin-tone',
  'index-pointing-up-medium-skin-tone',
  'index-pointing-up-medium-dark-skin-tone',
  'index-pointing-up-dark-skin-tone',
  'thumbs-up',
  'thumbs-up-light-skin-tone',
  'thumbs-up-medium-light-skin-tone',
  'thumbs-up-medium-skin-tone',
  'thumbs-up-medium-dark-skin-tone',
  'thumbs-up-dark-skin-tone',
  'thumbs-down',
  'thumbs-down-light-skin-tone',
  'thumbs-down-medium-light-skin-tone',
  'thumbs-down-medium-skin-tone',
  'thumbs-down-medium-dark-skin-tone',
  'thumbs-down-dark-skin-tone',
  'raised-fist',
  'raised-fist-light-skin-tone',
  'raised-fist-medium-light-skin-tone',
  'raised-fist-medium-skin-tone',
  'raised-fist-medium-dark-skin-tone',
  'raised-fist-dark-skin-tone',
  'oncoming-fist',
  'oncoming-fist-light-skin-tone',
  'oncoming-fist-medium-light-skin-tone',
  'oncoming-fist-medium-skin-tone',
  'oncoming-fist-medium-dark-skin-tone',
  'oncoming-fist-dark-skin-tone',
  'left-facing-fist',
  'left-facing-fist-light-skin-tone',
  'left-facing-fist-medium-light-skin-tone',
  'left-facing-fist-medium-skin-tone',
  'left-facing-fist-medium-dark-skin-tone',
  'left-facing-fist-dark-skin-tone',
  'right-facing-fist',
  'right-facing-fist-light-skin-tone',
  'right-facing-fist-medium-light-skin-tone',
  'right-facing-fist-medium-skin-tone',
  'right-facing-fist-medium-dark-skin-tone',
  'right-facing-fist-dark-skin-tone',
  'clapping-hands',
  'clapping-hands-light-skin-tone',
  'clapping-hands-medium-light-skin-tone',
  'clapping-hands-medium-skin-tone',
  'clapping-hands-medium-dark-skin-tone',
  'clapping-hands-dark-skin-tone',
  'raising-hands',
  'raising-hands-light-skin-tone',
  'raising-hands-medium-light-skin-tone',
  'raising-hands-medium-skin-tone',
  'raising-hands-medium-dark-skin-tone',
  'raising-hands-dark-skin-tone',
  'open-hands',
  'open-hands-light-skin-tone',
  'open-hands-medium-light-skin-tone',
  'open-hands-medium-skin-tone',
  'open-hands-medium-dark-skin-tone',
  'open-hands-dark-skin-tone',
  'handshake',
  'handshake-light-skin-tone',
  'handshake-medium-light-skin-tone',
  'handshake-medium-skin-tone',
  'handshake-medium-dark-skin-tone',
  'handshake-dark-skin-tone',
  'folded-hands',
  'folded-hands-light-skin-tone',
  'folded-hands-medium-light-skin-tone',
  'folded-hands-medium-skin-tone',
  'folded-hands-medium-dark-skin-tone',
  'folded-hands-dark-skin-tone',
  'writing-hand',
  'writing-hand-light-skin-tone',
  'writing-hand-medium-light-skin-tone',
  'writing-hand-medium-skin-tone',
  'writing-hand-medium-dark-skin-tone',
  'writing-hand-dark-skin-tone',
  'nail-polish',
  'nail-polish-light-skin-tone',
  'nail-polish-medium-light-skin-tone',
  'nail-polish-medium-skin-tone',
  'nail-polish-medium-dark-skin-tone',
  'nail-polish-dark-skin-tone',
  'selfie',
  'selfie-light-skin-tone',
  'selfie-medium-light-skin-tone',
  'selfie-medium-skin-tone',
  'selfie-medium-dark-skin-tone',
  'selfie-dark-skin-tone',
  'flexed-biceps',
  'flexed-biceps-light-skin-tone',
  'flexed-biceps-medium-light-skin-tone',
  'flexed-biceps-medium-skin-tone',
  'flexed-biceps-medium-dark-skin-tone',
  'flexed-biceps-dark-skin-tone',
  'ear',
  'ear-light-skin-tone',
  'ear-medium-light-skin-tone',
  'ear-medium-skin-tone',
  'ear-medium-dark-skin-tone',
  'ear-dark-skin-tone',
  'nose',
  'nose-light-skin-tone',
  'nose-medium-light-skin-tone',
  'nose-medium-skin-tone',
  'nose-medium-dark-skin-tone',
  'nose-dark-skin-tone',
  'eyes',
  'eye',
  'tongue',
  'mouth',
  'baby',
  'baby-light-skin-tone',
  'baby-medium-light-skin-tone',
  'baby-medium-skin-tone',
  'baby-medium-dark-skin-tone',
  'baby-dark-skin-tone',
  'boy',
  'boy-light-skin-tone',
  'boy-medium-light-skin-tone',
  'boy-medium-skin-tone',
  'boy-medium-dark-skin-tone',
  'boy-dark-skin-tone',
  'girl',
  'girl-light-skin-tone',
  'girl-medium-light-skin-tone',
  'girl-medium-skin-tone',
  'girl-medium-dark-skin-tone',
  'girl-dark-skin-tone',
  'man',
  'man-light-skin-tone',
  'man-medium-light-skin-tone',
  'man-medium-skin-tone',
  'man-medium-dark-skin-tone',
  'man-dark-skin-tone',
  'woman',
  'woman-light-skin-tone',
  'woman-medium-light-skin-tone',
  'woman-medium-skin-tone',
  'woman-medium-dark-skin-tone',
  'woman-dark-skin-tone',
  'old-man',
  'old-man-light-skin-tone',
  'old-man-medium-light-skin-tone',
  'old-man-medium-skin-tone',
  'old-man-medium-dark-skin-tone',
  'old-man-dark-skin-tone',
  'old-woman',
  'old-woman-light-skin-tone',
  'old-woman-medium-light-skin-tone',
  'old-woman-medium-skin-tone',
  'old-woman-medium-dark-skin-tone',
  'old-woman-dark-skin-tone',
  'person-frowning',
  'person-frowning-light-skin-tone',
  'person-frowning-medium-light-skin-tone',
  'person-frowning-medium-skin-tone',
  'person-frowning-medium-dark-skin-tone',
  'person-frowning-dark-skin-tone',
  'person-pouting',
  'person-pouting-light-skin-tone',
  'person-pouting-medium-light-skin-tone',
  'person-pouting-medium-skin-tone',
  'person-pouting-medium-dark-skin-tone',
  'person-pouting-dark-skin-tone',
  'person-gesturing-no',
  'person-gesturing-no-light-skin-tone',
  'person-gesturing-no-medium-light-skin-tone',
  'person-gesturing-no-medium-skin-tone',
  'person-gesturing-no-medium-dark-skin-tone',
  'person-gesturing-no-dark-skin-tone',
  'person-gesturing-ok',
  'person-gesturing-ok-light-skin-tone',
  'person-gesturing-ok-medium-light-skin-tone',
  'person-gesturing-ok-medium-skin-tone',
  'person-gesturing-ok-medium-dark-skin-tone',
  'person-gesturing-ok-dark-skin-tone',
  'person-tipping-hand',
  'person-tipping-hand-light-skin-tone',
  'person-tipping-hand-medium-light-skin-tone',
  'person-tipping-hand-medium-skin-tone',
  'person-tipping-hand-medium-dark-skin-tone',
  'person-tipping-hand-dark-skin-tone',
  'person-raising-hand',
  'person-raising-hand-light-skin-tone',
  'person-raising-hand-medium-light-skin-tone',
  'person-raising-hand-medium-skin-tone',
  'person-raising-hand-medium-dark-skin-tone',
  'person-raising-hand-dark-skin-tone',
  'person-bowing',
  'person-bowing-light-skin-tone',
  'person-bowing-medium-light-skin-tone',
  'person-bowing-medium-skin-tone',
  'person-bowing-medium-dark-skin-tone',
  'person-bowing-dark-skin-tone',
  'person-facepalming',
  'person-facepalming-light-skin-tone',
  'person-facepalming-medium-light-skin-tone',
  'person-facepalming-medium-skin-tone',
  'person-facepalming-medium-dark-skin-tone',
  'person-facepalming-dark-skin-tone',
  'person-shrugging',
  'person-shrugging-light-skin-tone',
  'person-shrugging-medium-light-skin-tone',
  'person-shrugging-medium-skin-tone',
  'person-shrugging-medium-dark-skin-tone',
  'person-shrugging-dark-skin-tone',
  'police-officer',
  'police-officer-light-skin-tone',
  'police-officer-medium-light-skin-tone',
  'police-officer-medium-skin-tone',
  'police-officer-medium-dark-skin-tone',
  'police-officer-dark-skin-tone',
  'detective',
  'detective-light-skin-tone',
  'detective-medium-light-skin-tone',
  'detective-medium-skin-tone',
  'detective-medium-dark-skin-tone',
  'detective-dark-skin-tone',
  'guard',
  'guard-light-skin-tone',
  'guard-medium-light-skin-tone',
  'guard-medium-skin-tone',
  'guard-medium-dark-skin-tone',
  'guard-dark-skin-tone',
  'construction-worker',
  'construction-worker-light-skin-tone',
  'construction-worker-medium-light-skin-tone',
  'construction-worker-medium-skin-tone',
  'construction-worker-medium-dark-skin-tone',
  'construction-worker-dark-skin-tone',
  'prince',
  'prince-light-skin-tone',
  'prince-medium-light-skin-tone',
  'prince-medium-skin-tone',
  'prince-medium-dark-skin-tone',
  'prince-dark-skin-tone',
  'princess',
  'princess-light-skin-tone',
  'princess-medium-light-skin-tone',
  'princess-medium-skin-tone',
  'princess-medium-dark-skin-tone',
  'princess-dark-skin-tone',
  'person-wearing-turban',
  'person-wearing-turban-light-skin-tone',
  'person-wearing-turban-medium-light-skin-tone',
  'person-wearing-turban-medium-skin-tone',
  'person-wearing-turban-medium-dark-skin-tone',
  'person-wearing-turban-dark-skin-tone',
  'man-in-tuxedo',
  'man-in-tuxedo-light-skin-tone',
  'man-in-tuxedo-medium-light-skin-tone',
  'man-in-tuxedo-medium-skin-tone',
  'man-in-tuxedo-medium-dark-skin-tone',
  'man-in-tuxedo-dark-skin-tone',
  'pregnant-woman',
  'pregnant-woman-light-skin-tone',
  'pregnant-woman-medium-light-skin-tone',
  'pregnant-woman-medium-skin-tone',
  'pregnant-woman-medium-dark-skin-tone',
  'pregnant-woman-dark-skin-tone',
  'baby-angel',
  'baby-angel-light-skin-tone',
  'baby-angel-medium-light-skin-tone',
  'baby-angel-medium-skin-tone',
  'baby-angel-medium-dark-skin-tone',
  'baby-angel-dark-skin-tone',
  'santa-claus',
  'santa-claus-light-skin-tone',
  'santa-claus-medium-light-skin-tone',
  'santa-claus-medium-skin-tone',
  'santa-claus-medium-dark-skin-tone',
  'santa-claus-dark-skin-tone',
  'mrs-claus',
  'mrs-claus-light-skin-tone',
  'mrs-claus-medium-light-skin-tone',
  'mrs-claus-medium-skin-tone',
  'mrs-claus-medium-dark-skin-tone',
  'mrs-claus-dark-skin-tone',
  'person-getting-massage',
  'person-getting-massage-light-skin-tone',
  'person-getting-massage-medium-light-skin-tone',
  'person-getting-massage-medium-skin-tone',
  'person-getting-massage-medium-dark-skin-tone',
  'person-getting-massage-dark-skin-tone',
  'person-getting-haircut',
  'person-getting-haircut-light-skin-tone',
  'person-getting-haircut-medium-light-skin-tone',
  'person-getting-haircut-medium-skin-tone',
  'person-getting-haircut-medium-dark-skin-tone',
  'person-getting-haircut-dark-skin-tone',
  'person-walking',
  'person-walking-light-skin-tone',
  'person-walking-medium-light-skin-tone',
  'person-walking-medium-skin-tone',
  'person-walking-medium-dark-skin-tone',
  'person-walking-dark-skin-tone',
  'person-running',
  'person-running-light-skin-tone',
  'person-running-medium-light-skin-tone',
  'person-running-medium-skin-tone',
  'person-running-medium-dark-skin-tone',
  'person-running-dark-skin-tone',
  'woman-dancing',
  'woman-dancing-light-skin-tone',
  'woman-dancing-medium-light-skin-tone',
  'woman-dancing-medium-skin-tone',
  'woman-dancing-medium-dark-skin-tone',
  'woman-dancing-dark-skin-tone',
  'man-dancing',
  'man-dancing-light-skin-tone',
  'man-dancing-medium-light-skin-tone',
  'man-dancing-medium-skin-tone',
  'man-dancing-medium-dark-skin-tone',
  'man-dancing-dark-skin-tone',
  'people-with-bunny-ears',
  'person-fencing',
  'horse-racing',
  'horse-racing-light-skin-tone',
  'horse-racing-medium-light-skin-tone',
  'horse-racing-medium-skin-tone',
  'horse-racing-medium-dark-skin-tone',
  'horse-racing-dark-skin-tone',
  'skier',
  'snowboarder',
  'person-golfing',
  'person-surfing',
  'person-surfing-light-skin-tone',
  'person-surfing-medium-light-skin-tone',
  'person-surfing-medium-skin-tone',
  'person-surfing-medium-dark-skin-tone',
  'person-surfing-dark-skin-tone',
  'person-rowing-boat',
  'person-rowing-boat-light-skin-tone',
  'person-rowing-boat-medium-light-skin-tone',
  'person-rowing-boat-medium-skin-tone',
  'person-rowing-boat-medium-dark-skin-tone',
  'person-rowing-boat-dark-skin-tone',
  'person-swimming',
  'person-swimming-light-skin-tone',
  'person-swimming-medium-light-skin-tone',
  'person-swimming-medium-skin-tone',
  'person-swimming-medium-dark-skin-tone',
  'person-swimming-dark-skin-tone',
  'person-bouncing-ball',
  'person-bouncing-ball-light-skin-tone',
  'person-bouncing-ball-medium-light-skin-tone',
  'person-bouncing-ball-medium-skin-tone',
  'person-bouncing-ball-medium-dark-skin-tone',
  'person-bouncing-ball-dark-skin-tone',
  'person-lifting-weights',
  'person-lifting-weights-light-skin-tone',
  'person-lifting-weights-medium-light-skin-tone',
  'person-lifting-weights-medium-skin-tone',
  'person-lifting-weights-medium-dark-skin-tone',
  'person-lifting-weights-dark-skin-tone',
  'person-biking',
  'person-biking-light-skin-tone',
  'person-biking-medium-light-skin-tone',
  'person-biking-medium-skin-tone',
  'person-biking-medium-dark-skin-tone',
  'person-biking-dark-skin-tone',
  'person-mountain-biking',
  'person-mountain-biking-light-skin-tone',
  'person-mountain-biking-medium-light-skin-tone',
  'person-mountain-biking-medium-skin-tone',
  'person-mountain-biking-medium-dark-skin-tone',
  'person-mountain-biking-dark-skin-tone',
  'person-cartwheeling',
  'person-cartwheeling-light-skin-tone',
  'person-cartwheeling-medium-light-skin-tone',
  'person-cartwheeling-medium-skin-tone',
  'person-cartwheeling-medium-dark-skin-tone',
  'person-cartwheeling-dark-skin-tone',
  'people-wrestling',
  'person-playing-water-polo',
  'person-playing-water-polo-light-skin-tone',
  'person-playing-water-polo-medium-light-skin-tone',
  'person-playing-water-polo-medium-skin-tone',
  'person-playing-water-polo-medium-dark-skin-tone',
  'person-playing-water-polo-dark-skin-tone',
  'person-playing-handball',
  'person-playing-handball-light-skin-tone',
  'person-playing-handball-medium-light-skin-tone',
  'person-playing-handball-medium-skin-tone',
  'person-playing-handball-medium-dark-skin-tone',
  'person-playing-handball-dark-skin-tone',
  'person-juggling',
  'person-juggling-light-skin-tone',
  'person-juggling-medium-light-skin-tone',
  'person-juggling-medium-skin-tone',
  'person-juggling-medium-dark-skin-tone',
  'person-juggling-dark-skin-tone',
  'person-taking-bath',
  'person-taking-bath-light-skin-tone',
  'person-taking-bath-medium-light-skin-tone',
  'person-taking-bath-medium-skin-tone',
  'person-taking-bath-medium-dark-skin-tone',
  'person-taking-bath-dark-skin-tone',
  'person-in-bed',
  'kiss',
  'kiss-man-man',
  'kiss-woman-woman',
  'couple-with-heart',
  'couple-with-heart-man-man',
  'couple-with-heart-woman-woman',
  'family',
  'family-man-woman-girl',
  'family-man-woman-girl-boy',
  'family-man-woman-boy-boy',
  'family-man-woman-girl-girl',
  'family-man-man-boy',
  'family-man-man-girl',
  'family-man-man-girl-boy',
  'family-man-man-boy-boy',
  'family-man-man-girl-girl',
  'family-woman-woman-boy',
  'family-woman-woman-girl',
  'family-woman-woman-girl-boy',
  'family-woman-woman-boy-boy',
  'family-woman-woman-girl-girl',
  'speaking-head',
  'bust-in-silhouette',
  'busts-in-silhouette',
  'footprints',
  'light-skin-tone',
  'medium-light-skin-tone',
  'medium-skin-tone',
  'medium-dark-skin-tone',
  'dark-skin-tone',
  'monkey-face',
  'monkey',
  'gorilla',
  'dog-face',
  'dog',
  'poodle',
  'wolf',
  'fox',
  'cat-face',
  'cat',
  'tiger-face',
  'tiger',
  'leopard',
  'horse-face',
  'horse',
  'deer',
  'cow-face',
  'ox',
  'water-buffalo',
  'cow',
  'pig-face',
  'pig',
  'boar',
  'pig-nose',
  'ram',
  'ewe',
  'goat',
  'camel',
  'two-hump-camel',
  'elephant',
  'rhinoceros',
  'mouse-face',
  'mouse',
  'rat',
  'rabbit-face',
  'rabbit',
  'chipmunk',
  'bat',
  'koala',
  'paw-prints',
  'turkey',
  'chicken',
  'rooster',
  'hatching-chick',
  'baby-chick',
  'front-facing-baby-chick',
  'bird',
  'penguin',
  'dove',
  'eagle',
  'duck',
  'owl',
  'crocodile',
  'turtle',
  'lizard',
  'snake',
  'dragon-face',
  'dragon',
  'spouting-whale',
  'whale',
  'dolphin',
  'fish',
  'tropical-fish',
  'blowfish',
  'shark',
  'octopus',
  'spiral-shell',
  'snail',
  'butterfly',
  'bug',
  'ant',
  'honeybee',
  'lady-beetle',
  'spider',
  'spider-web',
  'scorpion',
  'bouquet',
  'cherry-blossom',
  'white-flower',
  'rosette',
  'rose',
  'wilted-flower',
  'hibiscus',
  'sunflower',
  'blossom',
  'tulip',
  'seedling',
  'evergreen-tree',
  'deciduous-tree',
  'palm-tree',
  'cactus',
  'sheaf-of-rice',
  'herb',
  'shamrock',
  'four-leaf-clover',
  'maple-leaf',
  'fallen-leaf',
  'leaf-fluttering-in-wind',
  'grapes',
  'melon',
  'watermelon',
  'tangerine',
  'lemon',
  'banana',
  'pineapple',
  'red-apple',
  'green-apple',
  'pear',
  'peach',
  'cherries',
  'strawberry',
  'kiwi-fruit',
  'tomato',
  'avocado',
  'eggplant',
  'potato',
  'carrot',
  'ear-of-corn',
  'hot-pepper',
  'cucumber',
  'mushroom',
  'peanuts',
  'chestnut',
  'bread',
  'croissant',
  'baguette-bread',
  'pancakes',
  'cheese-wedge',
  'meat-on-bone',
  'poultry-leg',
  'bacon',
  'hamburger',
  'french-fries',
  'pizza',
  'hot-dog',
  'taco',
  'burrito',
  'stuffed-flatbread',
  'egg',
  'cooking',
  'shallow-pan-of-food',
  'pot-of-food',
  'green-salad',
  'popcorn',
  'bento-box',
  'rice-cracker',
  'rice-ball',
  'cooked-rice',
  'curry-rice',
  'steaming-bowl',
  'spaghetti',
  'roasted-sweet-potato',
  'oden',
  'sushi',
  'fried-shrimp',
  'fish-cake-with-swirl',
  'dango',
  'crab',
  'shrimp',
  'squid',
  'soft-ice-cream',
  'shaved-ice',
  'ice-cream',
  'doughnut',
  'cookie',
  'birthday-cake',
  'shortcake',
  'chocolate-bar',
  'candy',
  'lollipop',
  'custard',
  'honey-pot',
  'baby-bottle',
  'glass-of-milk',
  'hot-beverage',
  'teacup-without-handle',
  'sake',
  'bottle-with-popping-cork',
  'wine-glass',
  'cocktail-glass',
  'tropical-drink',
  'beer-mug',
  'clinking-beer-mugs',
  'clinking-glasses',
  'tumbler-glass',
  'fork-and-knife-with-plate',
  'fork-and-knife',
  'spoon',
  'kitchen-knife',
  'amphora',
  'globe-showing-europe-africa',
  'globe-showing-americas',
  'globe-showing-asia-australia',
  'globe-with-meridians',
]

/**
 * keywords - add proper keywords which align with the icon name
 */
export const searchableMap = {
  ncColumns: { icon: NcColumnsIcon, keywords: ['Grid', 'Layout', 'Structure', 'Organization', 'Architecture'] },
  ncUnderline: { icon: NcUnderlineIcon, keywords: ['text', 'formatting', 'highlight', 'emphasis', 'typography'] },
  ncGrid: { icon: NcGridIcon, keywords: ['layout', 'structure', 'organization', 'pattern', 'matrix'] },
  ncTriangle: { icon: NcTriangleIcon, keywords: ['Shape', 'Geometry', 'Angle', 'Polygon', 'Arrowhead'] },
  ncSearch: { icon: NcSearchIcon, keywords: ['magnifying glass', 'find', 'look', 'query', 'explore'] },
  ncVolume2: { icon: NcVolume2Icon, keywords: ['Sound', 'Audio', 'Loud', 'Music', 'Speaker'] },
  ncArrowUpCircle: { icon: NcArrowUpCircleIcon, keywords: ['Up', 'Arrow', 'Circle', 'Increase', 'Ascend'] },
  ncPauseCircle: { icon: NcPauseCircleIcon, keywords: ['pause', 'circle', 'stop', 'hold', 'wait'] },
  ncCheckSquare: { icon: NcCheckSquareIcon, keywords: ['checked', 'box', 'verified', 'confirmed', 'approved'] },
  ncArrowDown2: { icon: NcArrowDownIcon, keywords: ['down', 'arrow', 'direction', 'navigation', 'dropdown'] },
  ncCornerRightUp: { icon: NcCornerRightUpIcon, keywords: ['Arrow', 'Direction', 'Navigation', 'Pointer', 'Upward'] },
  ncChevronsRight: { icon: NcChevronsRightIcon, keywords: ['next', 'forward', 'arrow', 'direction', 'navigation'] },
  ncList: { icon: NcListIcon, keywords: ['menu', 'catalog', 'index', 'directory', 'checklist', 'bulletlist'] },
  ncNumberList: { icon: NcNumberListIcon, keywords: ['menu', 'catalog', 'index', 'directory', 'numberlist'] },
  ncCheckList: { icon: NcCheckListIcon, keywords: ['menu', 'catalog', 'index', 'directory', 'checklist'] },
  ncChevronsDown: { icon: NcChevronsDownIcon, keywords: ['down', 'arrow', 'chevron', 'direction', 'expand'] },
  ncCornerUpRight: { icon: NcCornerUpRightIcon, keywords: ['Arrow', 'Direction', 'Navigation', 'Pointer', 'Upward'] },
  ncTarget: { icon: NcTargetIcon, keywords: ['Aim', 'Bullseye', 'Goal', 'Focus', 'Precision'] },
  ncScissors: { icon: NcScissorsIcon, keywords: ['Cut', 'Clip', 'Trim', 'Slice', 'Craft'] },
  ncMinimize2: { icon: NcMinimize2Icon, keywords: ['Collapse', 'Shrink', 'Down', 'Reduce', 'Contract'] },
  ncPlayCircle: { icon: NcPlayCircleIcon, keywords: ['play', 'circle', 'video', 'music', 'start'] },
  ncCrosshair: { icon: NcCrosshairIcon, keywords: ['target', 'aim', 'scope', 'sniper', 'precision'] },
  ncAirplay: { icon: NcAirplayIcon, keywords: ['streaming', 'wireless', 'connection', 'mirroring', 'casting'] },
  ncXOctagon: { icon: NcXOctagonIcon, keywords: ['stop', 'halt', 'cancel', 'close', 'exit'] },
  ncRepeat: { icon: NcRepeatIcon, keywords: ['replay', 'loop', 'refresh', 'restart', 'redo'] },
  ncEdit3: { icon: NcEdit3Icon, keywords: ['pencil', 'modify', 'update', 'write', 'compose'] },
  ncVolume1: { icon: NcVolume1Icon, keywords: ['Sound', 'Audio', 'Music', 'Mute', 'Speaker'] },
  ncToggleRight: { icon: NcToggleRightIcon, keywords: ['arrow', 'direction', 'navigation', 'right', 'switch'] },
  ncUser: { icon: NcUserIcon, keywords: ['person', 'profile', 'account', 'people', 'avatar'] },
  ncFileMinus: { icon: NcFileMinusIcon, keywords: ['delete', 'remove', 'subtract', 'exclude', 'erase'] },
  ncXCircle: { icon: NcXCircleIcon, keywords: ['Close', 'Delete', 'Cancel', 'Remove', 'Exit'] },
  ncCircle: { icon: NcCircleIcon, keywords: ['Ring', 'Round', 'Shape', 'Geometry', 'Orb'] },
  ncPhoneMissed: {
    icon: NcPhoneMissedIcon,
    keywords: ['Missed call', 'phone notification', 'unanswered call', 'call alert', 'voicemail'],
  },
  ncEdit2: { icon: NcEdit2Icon, keywords: ['pencil', 'modify', 'update', 'change', 'rewrite'] },
  ncCornerLeftUp: { icon: NcCornerLeftUpIcon, keywords: ['arrow', 'direction', 'navigation', 'pointer', 'up-left'] },
  ncHome: { icon: NcHomeIcon, keywords: ['house', 'residence', 'building', 'shelter', 'dwelling'] },
  ncGitlab: { icon: NcGitlabIcon, keywords: ['version control', 'repository', 'collaboration', 'development', 'coding'] },
  ncSmartphone: { icon: NcSmartphoneIcon, keywords: ['phone', 'mobile', 'device', 'cell', 'handheld'] },
  ncMoreHorizontal: { icon: NcMoreHorizontalIcon, keywords: ['dots', 'menu', 'navigation', 'options', 'ellipsis'] },
  sliders: { icon: NcSlidersIcon, keywords: ['Settings', 'Options', 'Preferences', 'Adjustments', 'Controls'] },
  ncArrowUpLeft: { icon: NcArrowUpLeftIcon, keywords: ['Navigate', 'Back', 'Previous', 'Direction', 'Return'] },
  ncChevronDown: { icon: NcChevronDownIcon, keywords: ['arrow', 'dropdown', 'expand', 'menu', 'navigation'] },
  ncHexagon: { icon: NcHexagonIcon, keywords: ['Geometry', 'Shape', 'Polygon', 'Six-sided', 'Symbol'] },
  ncGithub: { icon: NcGithubIcon, keywords: ['repository', 'code', 'development', 'programming', 'version control'] },
  ncCrop: { icon: NcCropIcon, keywords: ['Trim', 'Resize', 'Edit', 'Cut', 'Adjust'] },
  ncBriefcase: { icon: NcBriefcaseIcon, keywords: ['Work', 'Business', 'Office', 'Career', 'Suitcase'] },
  ncRotateCw: { icon: NcRotateCwIcon, keywords: ['rotate', 'clockwise', 'spin', 'turn', 'refresh'] },
  ncInbox: { icon: NcInboxIcon, keywords: ['Email', 'Messages', 'Mailbox', 'Communications', 'Notifications'] },
  ncAlignJustify: { icon: NcAlignJustifyIcon, keywords: ['justify', 'alignment', 'text', 'paragraph', 'formatting'] },
  ncPlusSquare: {
    icon: NcPlusSquareIcon,
    keywords: ['add', 'create', 'expand', 'increase', 'new'],
  },
  ncPower: {
    icon: NcPowerIcon,
    keywords: ['Energy', 'Electricity', 'Strength', 'Control', 'Battery'],
  },
  ncDatabase: {
    icon: NcDatabaseIcon2,
    keywords: ['data', 'storage', 'server', 'information', 'archive'],
  },
  ncCameraOff: {
    icon: NcCameraOffIcon,
    keywords: ['Disable', 'Mute', 'Off', 'Private', 'Restricted'],
  },
  ncToggleLeft: {
    icon: NcToggleLeftIcon,
    keywords: ['arrow', 'left', 'direction', 'navigation', 'switch'],
  },
  ncFile: {
    icon: NcFileIcon,
    keywords: ['document', 'data', 'folder', 'archive', 'storage'],
  },
  ncMessageCircle: {
    icon: NcMessageCircleIcon,
    keywords: ['comment', 'discussion', 'feedback', 'conversation', 'chat'],
  },
  ncTerminal: {
    icon: NcTerminalIcon,
    keywords: ['command', 'console', 'coding', 'programming', 'computer'],
  },
  ncMove: {
    icon: NcMoveIcon,
    keywords: ['relocate', 'transfer', 'shift', 'drag', 'rearrange'],
  },
  ncMaximize: {
    icon: NcMaximizeIcon,
    keywords: ['Enlarge', 'Expand', 'Fullscreen', 'Resize', 'Zoom'],
  },
  ncChevronUp: {
    icon: NcChevronUpIcon,
    keywords: ['arrow', 'up', 'direction', 'navigation', 'expand'],
  },
  ncArrowDownLeft: {
    icon: NcArrowDownLeftIcon,
    keywords: ['Navigation', 'Direction', 'Pointer', 'Backward', 'Southwest'],
  },
  ncFileText: {
    icon: NcFileTextIcon,
    keywords: ['document', 'text', 'file', 'note', 'script'],
  },
  ncDroplet: {
    icon: NcDropletIcon,
    keywords: ['water', 'liquid', 'drop', 'splash', 'hydration'],
  },
  ncZapOff: {
    icon: NcZapOffIcon,
    keywords: ['Disable', 'Off', 'Lightning', 'Electricity', 'Deactivate'],
  },
  ncX: {
    icon: NcXIcon,
    keywords: ['Close', 'Delete', 'Cancel', 'Exit', 'Remove'],
  },
  ncBarChart: {
    icon: NcBarChartIcon,
    keywords: ['statistics', 'graph', 'data', 'analytics', 'chart'],
  },
  ncLock: {
    icon: NcLockIcon,
    keywords: ['Security', 'Password', 'Protection', 'Encryption', 'Privacy'],
  },
  ncLogIn: {
    icon: NcLogInIcon,
    keywords: ['Sign in', 'Authentication', 'Login', 'Access', 'Account'],
  },
  ncRefreshCw: {
    icon: NcRefreshCwIcon,
    keywords: ['Reload', 'Update', 'Rotate', 'Sync', 'Reboot'],
  },
  ncChevronRight: {
    icon: NcChevronRightIcon,
    keywords: ['next', 'arrow', 'forward', 'navigate', 'rightward'],
  },
  ncClipboard: {
    icon: NcClipboardIcon,
    keywords: ['notes', 'copy', 'paste', 'document', 'office'],
  },
  ncPackage: {
    icon: NcPackageIcon,
    keywords: ['Box', 'Delivery', 'Shipping', 'Parcel', 'Cargo'],
  },
  ncInstagram: {
    icon: NcInstagramIcon,
    keywords: ['social media', 'photography', 'sharing', 'networking', 'app'],
  },
  ncLink: {
    icon: NcLinkIcon,
    keywords: ['chain', 'connection', 'hyperlink', 'url', 'attachment'],
  },
  ncVideoOff: {
    icon: NcVideoOffIcon,
    keywords: ['Disable', 'Mute', 'Pause', 'Stop', 'Deactivate'],
  },
  ncKey: {
    icon: NcKeyIcon,
    keywords: ['Unlock', 'Password', 'Security', 'Access', 'Lock'],
  },
  ncCornerDownRight: {
    icon: NcCornerDownRightIcon,
    keywords: ['arrow', 'direction', 'navigation', 'pointer', 'dropdown'],
  },
  ncArrowRight: {
    icon: NcArrowRightIcon,
    keywords: ['next', 'forward', 'direction', 'navigation', 'proceed'],
  },
  ncStopCircle: {
    icon: NcStopCircleIcon,
    keywords: ['block', 'halt', 'pause', 'prohibit', 'cancel'],
  },
  ncLogOut: {
    icon: NcLogOutIcon,
    keywords: ['exit', 'logout', 'sign out', 'leave', 'disconnect'],
  },
  ncArrowLeftCircle: {
    icon: NcArrowLeftCircleIcon,
    keywords: ['back', 'previous', 'navigate', 'left', 'return'],
  },
  ncBarChart2: {
    icon: NcBarChart2Icon,
    keywords: ['Statistics', 'Graph', 'Data', 'Analytics', 'Chart'],
  },
  ncGitPullRequest: {
    icon: NcGitPullRequestIcon,
    keywords: ['merge', 'request', 'pull', 'code', 'review'],
  },
  ncMinimize: {
    icon: NcMinimizeIcon,
    keywords: ['shrink', 'reduce', 'downsize', 'compact', 'collapse'],
  },
  ncMinusSquare: {
    icon: NcMinusSquareIcon,
    keywords: ['Remove', 'Delete', 'Subtract', 'Minus', 'Uncheck'],
  },
  ncSettings: {
    icon: NcSettingsIcon,
    keywords: ['configuration', 'preferences', 'options', 'gear', 'customization'],
  },
  ncCloudSnow: {
    icon: NcCloudSnowIcon,
    keywords: ['weather', 'snowflake', 'winter', 'frost', 'precipitation'],
  },
  ncThumbsDown: {
    icon: NcThumbsDownIcon,
    keywords: ['Dislike', 'Reject', 'Disapprove', 'Negative', 'Unhappy'],
  },
  ncType: {
    icon: NcTypeIcon,
    keywords: ['Keyboard', 'Text', 'Input', 'Write', 'Font'],
  },
  ncPhoneOutgoing: {
    icon: NcPhoneOutgoingIcon,
    keywords: ['call', 'dial', 'outgoing', 'ring', 'telephone'],
  },
  ncPocket: {
    icon: NcPocketIcon,
    keywords: ['bag', 'pouch', 'wallet', 'clothing', 'storage'],
  },
  ncMail: {
    icon: NcMailIcon,
    keywords: ['Email', 'Letter', 'Envelope', 'Message', 'Inbox'],
  },
  ncShield: {
    icon: NcShieldIcon,
    keywords: ['Protection', 'Defense', 'Security', 'Safety', 'Armor'],
  },
  ncDownload: {
    icon: NcDownloadIcon,
    keywords: ['Save', 'Export', 'Transfer', 'Receive', 'Import'],
  },
  ncPhoneForwarded: {
    icon: NcPhoneForwardedIcon,
    keywords: ['call', 'redirect', 'transfer', 'forward', 'reroute'],
  },
  ncCornerRightDown: {
    icon: NcCornerRightDownIcon,
    keywords: ['arrow', 'direction', 'navigation', 'pointer', 'dropdown'],
  },
  ncBookOpen: {
    icon: NcBookOpenIcon,
    keywords: ['reading', 'education', 'literature', 'study', 'knowledge'],
  },
  ncServer: {
    icon: NcServerIcon,
    keywords: ['computer', 'network', 'hosting', 'data', 'infrastructure'],
  },
  ncTv: {
    icon: NcTvIcon,
    keywords: ['television', 'screen', 'entertainment', 'media', 'broadcasting'],
  },
  ncSkipForward: {
    icon: NcSkipForwardIcon,
    keywords: ['fast forward', 'next', 'skip', 'forward', 'jump'],
  },
  ncVolume: {
    icon: NcVolumeIcon,
    keywords: ['Sound', 'Audio', 'Music', 'Loud', 'Mute'],
  },
  ncUserPlus: {
    icon: NcUserPlusIcon,
    keywords: ['Add user', 'New user', 'Create account', 'Register', 'Sign up'],
  },
  ncBatteryCharging: {
    icon: NcBatteryChargingIcon,
    keywords: ['Power', 'Charging', 'Energy', 'Recharge', 'Electricity'],
  },
  ncLayers: {
    icon: NcLayersIcon,
    keywords: ['stack', 'overlap', 'hierarchy', 'levels', 'organization'],
  },
  ncSlash: {
    icon: NcSlashIcon,
    keywords: ['divide', 'split', 'separate', 'cut', 'diagonal'],
  },
  ncRadio: {
    icon: NcRadioIcon,
    keywords: ['music', 'audio', 'broadcast', 'speaker', 'sound'],
  },
  ncBook: {
    icon: NcBookIcon,
    keywords: ['reading', 'education', 'literature', 'library', 'knowledge'],
  },
  ncUserMinus: {
    icon: NcUserMinusIcon,
    keywords: ['Remove User', 'Delete Account', 'Subtract Person', 'Minus Profile', 'Eliminate Member'],
  },
  ncBell: {
    icon: NcBellIcon,
    keywords: ['Notification', 'Alert', 'Ring', 'Sound', 'Alarm'],
  },
  ncGitBranch: {
    icon: NcGitBranchIcon,
    keywords: ['version control', 'branching', 'repository', 'development', 'coding'],
  },
  ncCode: {
    icon: NcCodeIcon,
    keywords: ['programming', 'development', 'coding', 'software', 'script'],
  },
  ncCodeBlock: {
    icon: NcCodeBlockIcon,
    keywords: ['programming', 'development', 'coding', 'software', 'script'],
  },
  ncCast: {
    icon: NcCastIcon,
    keywords: ['Chromecast', 'streaming', 'media', 'broadcast', 'television'],
  },
  ncFlag: {
    icon: NcFlagIcon,
    keywords: ['country', 'nation', 'patriotism', 'symbol', 'banner'],
  },
  ncEyeOff: {
    icon: NcEyeOffIcon,
    keywords: ['invisible', 'hide', 'unseen', 'private', 'disabled'],
  },
  ncBattery: {
    icon: NcBatteryIcon,
    keywords: ['Power', 'Energy', 'Charging', 'Electronics', 'Voltage'],
  },
  ncDisc: {
    icon: NcDiscIcon,
    keywords: ['CD', 'music', 'record', 'vinyl', 'album'],
  },
  ncFrown: {
    icon: NcFrownIcon,
    keywords: ['Sad', 'Unhappy', 'Disappointed', 'Depressed', 'Gloomy'],
  },
  ncTool: {
    icon: NcToolIcon,
    keywords: ['equipment', 'instrument', 'gadget', 'machinery', 'wrench'],
  },
  ncBold: {
    icon: NcBoldIcon,
    keywords: ['Font', 'Style', 'Text', 'Format', 'Typography'],
  },
  ncHash: {
    icon: NcHashIcon,
    keywords: ['Number', 'Symbol', 'Pound', 'Code', 'Tag'],
  },
  ncShare2: {
    icon: NcShare2Icon,
    keywords: ['share', 'social', 'exchange', 'distribute', 'forward'],
  },
  ncPlus: {
    icon: NcPlusIcon,
    keywords: ['Add', 'Create', 'Increase', 'Expand', 'More'],
  },
  ncCheck: {
    icon: NcCheckIcon,
    keywords: ['Verify', 'Confirm', 'Tick', 'Approval', 'Validate'],
  },
  ncRotateCcw: {
    icon: NcRotateCcwIcon,
    keywords: ['counterclockwise', 'rotate', 'turn', 'left', 'reverse'],
  },
  ncHardDrive: {
    icon: NcHardDriveIcon,
    keywords: ['Storage', 'Computer', 'Disk', 'Data', 'Hardware'],
  },
  ncBluetooth: {
    icon: NcBluetoothIcon,
    keywords: ['wireless', 'connectivity', 'device', 'technology', 'pairing'],
  },
  ncPieChart: {
    icon: NcPieChartIcon,
    keywords: ['statistics', 'graph', 'data', 'analysis', 'chart'],
  },
  ncRss: {
    icon: NcRssIcon,
    keywords: ['feed', 'news', 'subscription', 'blog', 'syndication'],
  },
  ncWifi: {
    icon: NcWifiIcon,
    keywords: ['Internet', 'Network', 'Connection', 'Wireless', 'Signal'],
  },
  ncCornerUpLeft: {
    icon: NcCornerUpLeftIcon,
    keywords: ['arrow', 'direction', 'navigation', 'pointer', 'back'],
  },
  ncInfo: {
    icon: NcInfoIcon,
    keywords: ['information', 'help', 'details', 'about', 'knowledge'],
  },
  ncUserX: {
    icon: NcUserXIcon,
    keywords: ['delete account', 'remove user', 'cancel profile', 'user delete', 'account removal'],
  },
  ncLoader: {
    icon: NcLoaderIcon,
    keywords: ['loading', 'progress', 'spinning', 'waiting', 'animation'],
  },
  ncRefreshCcw: {
    icon: NcRefreshCcwIcon,
    keywords: ['reload', 'update', 'rotate', 'counter-clockwise', 'sync'],
  },
  ncFolderPlus: {
    icon: NcFolderPlusIcon,
    keywords: ['add', 'create', 'new', 'organize', 'directory'],
  },
  ncMic: {
    icon: NcMicIcon,
    keywords: ['Microphone', 'Audio', 'Sound', 'Record', 'Speak'],
  },
  ncCopy: {
    icon: NcCopyIcon,
    keywords: ['Duplicate', 'Clone', 'Replicate', 'Paste', 'Duplicate File'],
  },
  ncZoomIn: {
    icon: NcZoomInIcon,
    keywords: ['magnify', 'enlarge', 'scale', 'focus', 'expand'],
  },
  ncArrowRightCircle: {
    icon: NcArrowRightCircleIcon,
    keywords: ['next', 'forward', 'navigate', 'direction', 'proceed'],
  },
  ncAlignRight: {
    icon: NcAlignRightIcon,
    keywords: ['Alignment', 'Text', 'Right', 'Justify', 'Format'],
  },
  ncImage: {
    icon: NcImageIcon,
    keywords: ['Picture', 'Photo', 'Graphic', 'Illustration', 'Snapshot'],
  },
  ncMaximize2: {
    icon: NcMaximize2Icon,
    keywords: ['enlarge', 'expand', 'full screen', 'resize', 'zoom'],
  },
  ncCheckCircle: {
    icon: NcCheckCircleIcon,
    keywords: ['Approved', 'Confirmation', 'Verified', 'Success', 'Validated'],
  },
  ncSave2: {
    icon: NcSaveIcon,
    keywords: ['Save', 'Disk', 'Download', 'Storage', 'Backup'],
  },
  ncSmile: {
    icon: NcSmileIcon,
    keywords: ['Happy', 'Face', 'Joy', 'Emotion', 'Grin'],
  },
  ncNavigation: {
    icon: NcNavigationIcon,
    keywords: ['direction', 'compass', 'map', 'location', 'GPS'],
  },
  ncPaperclip: {
    icon: NcPaperclipIcon,
    keywords: ['attachment', 'office', 'stationery', 'clip', 'document'],
  },
  ncFastForward: {
    icon: NcFastForwardIcon,
    keywords: ['Skip', 'Next', 'Speed', 'Advance', 'Playback'],
  },
  ncXSquare: {
    icon: NcXSquareIcon,
    keywords: ['Close', 'Delete', 'Remove', 'Cancel', 'Exit'],
  },
  ncAward: {
    icon: NcAwardIcon,
    keywords: ['Trophy', 'Prize', 'Medal', 'Recognition', 'Achievement'],
  },
  ncZoomOut: {
    icon: NcZoomOutIcon,
    keywords: ['magnify', 'minimize', 'scale', 'shrink', 'reduce'],
  },
  ncBox: {
    icon: NcBoxIcon,
    keywords: ['package', 'container', 'storage', 'shipping', 'parcel'],
  },
  ncThumbsUp: {
    icon: NcThumbsUpIcon,
    keywords: ['Approval', 'Like', 'Agree', 'Positive', 'Endorsement'],
  },
  ncPercent: {
    icon: NcPercentIcon,
    keywords: ['discount', 'percentage', 'proportion', 'rate', 'ratio'],
  },
  ncSidebar: {
    icon: NcSidebarIcon,
    keywords: ['menu', 'navigation', 'panel', 'column', 'dashboard'],
  },
  ncSquare: {
    icon: NcSquareIcon,
    keywords: ['Box', 'Rectangle', 'Shape', 'Block', 'Geometry'],
  },
  ncPlay: {
    icon: NcPlayIcon,
    keywords: ['Video', 'Music', 'Start', 'Button', 'Media'],
  },
  ncGitCommit: {
    icon: NcGitCommitIcon,
    keywords: ['version control', 'commit', 'git', 'code', 'repository'],
  },
  ncSend: {
    icon: NcSendIcon,
    keywords: ['Email', 'Message', 'Share', 'Transmit', 'Dispatch'],
  },
  ncPhoneCall: {
    icon: NcPhoneCallIcon,
    keywords: ['call', 'phone', 'contact', 'communication', 'dial'],
  },
  ncCamera: {
    icon: NcCameraIcon,
    keywords: ['photography', 'photo', 'picture', 'snapshot', 'lens'],
  },
  ncLink2: {
    icon: NcLink2Icon,
    keywords: ['chain', 'hyperlink', 'connection', 'attach', 'merge'],
  },
  ncPrinter: {
    icon: NcPrinterIcon,
    keywords: ['print', 'device', 'office', 'paper', 'hardware'],
  },
  ncFolderMinus: {
    icon: NcFolderMinusIcon,
    keywords: ['Remove', 'Delete', 'Exclude', 'Subtract', 'Unfile'],
  },
  ncArrowUpRight: {
    icon: NcArrowUpRightIcon,
    keywords: ['Direction', 'Navigation', 'Forward', 'Diagonal', 'Ascending'],
  },
  ncPenTool: {
    icon: NcPenToolIcon,
    keywords: ['vector', 'drawing', 'editing', 'illustration', 'design'],
  },
  ncAtSign: {
    icon: NcAtSignIcon,
    keywords: ['email', 'address', 'symbol', 'contact', 'sign'],
  },
  ncTrash: {
    icon: NcTrashIcon,
    keywords: ['delete', 'garbage', 'waste', 'bin', 'discard'],
  },
  ncWifiOff: {
    icon: NcWifiOffIcon,
    keywords: ['No internet', 'wifi disabled', 'no connection', 'offline', 'disconnected'],
  },
  ncCornerLeftDown: {
    icon: NcCornerLeftDownIcon,
    keywords: ['arrow', 'direction', 'navigation', 'pointer', 'southwest'],
  },
  ncDollarSign: {
    icon: NcDollarSignIcon,
    keywords: ['Money', 'Currency', 'Finance', 'Payment', 'Wealth'],
  },
  ncStar: {
    icon: NcStarIcon,
    keywords: ['Favorite', 'Rating', 'Review', 'Award', 'Excellence'],
  },
  ncCloudOff: {
    icon: NcCloudOffIcon,
    keywords: ['Cloud disabled', 'Cloud disconnected', 'No cloud', 'Cloud inactive', 'Offline cloud'],
  },
  ncMessageSquare: {
    icon: NcMessageSquareIcon,
    keywords: ['chat', 'conversation', 'discussion', 'note', 'comment'],
  },
  ncEdit: {
    icon: NcEditIcon,
    keywords: ['modify', 'update', 'change', 'write', 'revise'],
  },
  ncAlertCircle: {
    icon: NcAlertCircleIcon,
    keywords: ['Warning', 'Notification', 'Caution', 'Error', 'Alert'],
  },
  ncAlertCircleFilled: {
    icon: NcAlertCircleFilledIcon,
    keywords: ['Warning', 'Notification', 'Caution', 'Error', 'Alert'],
  },
  ncChevronsUp: {
    icon: NcChevronsUpIcon,
    keywords: ['Up arrow', 'Increase', 'Expand', 'Rise', 'Ascend'],
  },
  ncUploadCloud: {
    icon: NcUploadCloudIcon,
    keywords: ['cloud storage', 'upload file', 'cloud computing', 'data transfer', 'online backup'],
  },
  ncYoutube: {
    icon: NcYoutubeIcon,
    keywords: ['video', 'social media', 'streaming', 'entertainment', 'online'],
  },
  ncUnlock: {
    icon: h(NcUnlockIcon, { stroke: 'transparent' }),
    keywords: ['password', 'security', 'access', 'open', 'authorization'],
  },
  ncCompass: {
    icon: NcCompassIcon,
    keywords: ['Navigation', 'Direction', 'Map', 'Travel', 'Exploration'],
  },
  ncPlusCircle: {
    icon: NcPlusCircleIcon,
    keywords: ['Add', 'Create', 'New', 'Expand', 'Increase'],
  },
  ncCreditCard: {
    icon: NcCreditCardIcon,
    keywords: ['payment', 'finance', 'bank', 'money', 'transaction'],
  },
  ncTrash2: {
    icon: NcTrash2Icon,
    keywords: ['delete', 'garbage', 'waste', 'remove', 'discard'],
  },
  ncSkipBack: {
    icon: NcSkipBackIcon,
    keywords: ['previous', 'rewind', 'back', 'replay', 'restart'],
  },
  ncFilePlus: {
    icon: NcFilePlusIcon,
    keywords: ['add', 'create', 'document', 'new', 'upload'],
  },
  ncDelete: {
    icon: NcDeleteIcon,
    keywords: ['remove', 'trash', 'erase', 'cancel', 'discard'],
  },
  ncCommand: {
    icon: NcCommandIcon,
    keywords: ['Terminal', 'Console', 'Code', 'Programming', 'Execute'],
  },
  ncClock: {
    icon: NcClockIcon,
    keywords: ['Time', 'Schedule', 'Watch', 'Timer', 'Alarm'],
  },
  ncOctagon: {
    icon: NcOctagonIcon,
    keywords: ['shape', 'polygon', 'eight-sided', 'geometry', 'stop sign'],
  },
  ncPhone: {
    icon: NcPhoneIcon,
    keywords: ['call', 'mobile', 'device', 'communication', 'telephone'],
  },
  ncEye: {
    icon: NcEyeIcon,
    keywords: ['View', 'Look', 'See', 'Watch', 'Observe'],
  },
  ncPhoneOff: {
    icon: NcPhoneOffIcon,
    keywords: ['Mute', 'Silence', 'Disable', 'Offline', 'Disconnect'],
  },
  ncExternalLink: {
    icon: NcExternalLinkIcon,
    keywords: ['outbound', 'redirect', 'outside', 'website', 'hyperlink'],
  },
  ncZap: {
    icon: NcZapIcon,
    keywords: ['Lightning', 'Electricity', 'Energy', 'Shock', 'Bolt'],
  },
  ncAgent: {
    icon: h(NcAgentIcon, { stroke: 'transparent' }),
    keywords: ['Robot', 'Agent', 'AI', 'Bot', 'Automation'],
  },
  ncTable: {
    icon: h(NcTableIcon, { stroke: 'transparent' }),
    keywords: ['Table', 'Grid', 'Data', 'Spreadsheet', 'Database'],
  },
  ncMoreVertical: {
    icon: NcMoreVerticalIcon,
    keywords: ['dots', 'menu', 'vertical', 'ellipsis', 'options'],
  },
  ncMicOff: {
    icon: NcMicOffIcon,
    keywords: ['Mute', 'Microphone', 'Disabled', 'Silence', 'Off'],
  },
  ncShare: {
    icon: NcShareIcon,
    keywords: ['social', 'send', 'forward', 'distribute', 'exchange'],
  },
  ncArrowUp: {
    icon: NcArrowUpIcon,
    keywords: ['Up', 'Direction', 'Navigation', 'Ascending', 'Increase'],
  },
  ncArrowUpDown: {
    icon: NcArrowUpDownIcon,
    keywords: ['Sort', 'Up', 'Down', 'Arrow', 'Reorder', 'Swap'],
  },
  ncBellOff: {
    icon: NcBellOffIcon,
    keywords: ['Notification off', 'Mute alert', 'Silence', 'Disabled alarm', 'Quiet mode'],
  },
  ncLinkedin: {
    icon: NcLinkedinIcon,
    keywords: ['linkedin', 'social media', 'networking', 'career', 'professional'],
  },
  ncVideo: {
    icon: NcVideoIcon,
    keywords: ['Film', 'Movie', 'Camera', 'Recording', 'Multimedia'],
  },
  ncActivity: {
    icon: NcActivityIcon,
    keywords: ['action', 'movement', 'exercise', 'fitness', 'sports'],
  },
  ncMapPin: {
    icon: NcMapPinIcon,
    keywords: ['location', 'navigation', 'marker', 'geography', 'pinpoint'],
  },
  ncPin: {
    icon: NcPinIcon,
    keywords: ['pin', 'attach', 'stick', 'thumbtack', 'pushpin'],
  },
  ncPinOff: {
    icon: NcPinOffIcon,
    keywords: ['unpin', 'detach', 'remove pin', 'unstick'],
  },
  ncFilter: {
    icon: NcFilterIcon,
    keywords: ['Sort', 'refine', 'categorize', 'organize', 'sift'],
  },
  ncPhoneIncoming: {
    icon: NcPhoneIncomingIcon,
    keywords: ['call', 'incoming', 'phone', 'ring', 'answer'],
  },
  ncItalic: {
    icon: NcItalicIcon,
    keywords: ['font', 'style', 'text', 'formatting', 'typography'],
  },
  ncChevronsLeft: {
    icon: NcChevronsLeftIcon,
    keywords: ['back', 'previous', 'navigate', 'left', 'arrow'],
  },
  ncCalendar: {
    icon: NcCalendarIcon,
    keywords: ['Schedule', 'Date', 'Time', 'Organizer', 'Planner'],
  },
  ncGlobe: {
    icon: NcGlobeIcon,
    keywords: ['Earth', 'World', 'Map', 'International', 'Geography'],
  },
  ncArrowLeft: {
    icon: NcArrowLeftIcon,
    keywords: ['back', 'previous', 'navigate', 'direction', 'left'],
  },
  ncAlignCenter: {
    icon: NcAlignCenterIcon,
    keywords: ['center', 'middle', 'alignment', 'layout', 'formatting'],
  },
  ncMinusCircle: {
    icon: NcMinusCircleIcon,
    keywords: ['Remove', 'Delete', 'Subtract', 'Cancel', 'Unsubscribe'],
  },
  ncArrowDownRight: {
    icon: NcArrowDownRightIcon,
    keywords: ['down', 'right', 'direction', 'navigation', 'diagonal'],
  },
  ncVolumeX: {
    icon: NcVolumeXIcon,
    keywords: ['Mute', 'Sound', 'Volume', 'Quiet', 'Silence'],
  },
  ncCloud: {
    icon: NcCloudIcon,
    keywords: ['weather', 'storage', 'computing', 'network', 'sky'],
  },
  ncDownloadCloud: {
    icon: NcDownloadCloudIcon,
    keywords: ['cloud storage', 'download', 'cloud computing', 'data transfer', 'file download'],
  },
  ncShuffle: {
    icon: NcShuffleIcon,
    keywords: ['randomize', 'mix', 'reorder', 'music', 'playlist'],
  },
  ncRewind: {
    icon: NcRewindIcon,
    keywords: ['back', 'previous', 'replay', 'reverse', 'undo'],
  },
  ncUpload: {
    icon: NcUploadIcon,
    keywords: ['cloud', 'upload', 'file', 'transfer', 'send'],
  },
  ncTrendingDown: {
    icon: NcTrendingDownIcon,
    keywords: ['Decline', 'Decrease', 'Downward', 'Drop', 'Loss'],
  },
  ncPause: {
    icon: NcPauseIcon,
    keywords: ['stop', 'hold', 'wait', 'break', 'suspend'],
  },
  ncArrowDownCircle: {
    icon: NcArrowDownCircleIcon,
    keywords: ['download', 'dropdown', 'expand', 'show more', 'collapse'],
  },
  ncBookmark: {
    icon: NcBookmarkIcon,
    keywords: ['save', 'favorite', 'mark', 'read', 'later'],
  },
  ncAlertTriangle: {
    icon: NcAlertTriangleIcon,
    keywords: ['Warning', 'Notification', 'Error', 'Caution', 'Danger'],
  },
  ncUserCheck: {
    icon: NcUserCheckIcon,
    keywords: ['Verify', 'Profile', 'Validate', 'Authentication', 'Confirmation'],
  },
  ncTablet: {
    icon: NcTabletIcon,
    keywords: ['computer', 'device', 'mobile', 'screen', 'technology'],
  },
  ncAlertOctagon: {
    icon: NcAlertOctagonIcon,
    keywords: ['Warning', 'Notification', 'Caution', 'Error', 'Notification Symbol'],
  },
  ncMenu: {
    icon: NcMenuIcon,
    keywords: ['Navigation', 'Hamburger', 'Options', 'Settings', 'Dropdown'],
  },
  ncChrome: {
    icon: NcChromeIcon,
    keywords: ['browser', 'google', 'web', 'internet', 'surfing'],
  },
  ncFolder: {
    icon: NcFolderIcon,
    keywords: ['directory', 'file', 'storage', 'organize', 'documents'],
  },
  ncFolderClosed: {
    icon: NcFolderClosedIcon,
    keywords: ['directory', 'file', 'storage', 'organize', 'collapsed'],
  },
  ncFolderOpen: {
    icon: NcFolderOpenIcon,
    keywords: ['directory', 'file', 'storage', 'organize', 'expanded'],
  },
  ncUsers: {
    icon: NcUsersIcon,
    keywords: ['people', 'profiles', 'accounts', 'members', 'team'],
  },
  ncCornerDownLeft: {
    icon: NcCornerDownLeftIcon,
    keywords: ['arrow', 'direction', 'navigation', 'pointer', 'southwest'],
  },
  ncMonitor: {
    icon: NcMonitorIcon,
    keywords: ['Computer', 'Screen', 'Display', 'Desktop', 'Technology'],
  },
  ncMinus: {
    icon: NcMinusIcon,
    keywords: ['Subtract', 'Remove', 'Delete', 'Negative', 'Decrease'],
  },
  ncNavigation2: {
    icon: NcNavigation2Icon,
    keywords: ['Direction', 'Location', 'Map', 'Compass', 'GPS'],
  },
  ncChevronLeft: {
    icon: NcChevronLeftIcon,
    keywords: ['back', 'previous', 'arrow', 'left', 'navigation'],
  },
  ncFilm: {
    icon: NcFilmIcon,
    keywords: ['Movie', 'Cinema', 'Video', 'Camera', 'Hollywood'],
  },
  ncMoon: {
    icon: NcMoonIcon,
    keywords: ['Lunar', 'Night', 'Space', 'Astronomy', 'Celestial'],
  },
  ncShieldOff: {
    icon: NcShieldOffIcon,
    keywords: ['Inactive', 'Disabled', 'Unprotected', 'Vulnerable', 'Security'],
  },
  ncMousePointer: {
    icon: NcMousePointerIcon,
    keywords: ['cursor', 'pointer', 'mouse', 'navigation', 'select'],
  },
  ncAlignLeft: {
    icon: NcAlignLeftIcon,
    keywords: ['text', 'alignment', 'left', 'justify', 'formatting'],
  },
  ncHeart: {
    icon: NcHeartIcon,
    keywords: ['Love', 'Valentine', 'Health', 'Favorite', 'Like'],
  },
  ncTrendingUp: {
    icon: NcTrendingUpIcon,
    keywords: ['Growth', 'Increase', 'Success', 'Chart', 'Upward'],
  },
  ncAutoAwesome: {
    icon: h(NcAutoAwesome, { stroke: 'transparent' }),
    keywords: ['Magic', 'ai', 'autoAwesome', 'awesome'],
  },
  ncUpgradeSparkle: {
    icon: h(NcUpgradeSparkleIcon, { stroke: 'transparent' }),
    keywords: ['upgrade', 'sparkle', 'star', 'premium', 'plus', 'badge'],
  },
  ncHeading1: {
    icon: NcHeading1,
    keywords: ['heading', 'h1'],
  },
  ncHeading2: {
    icon: NcHeading2,
    keywords: ['heading', 'h2'],
  },
  ncHeading3: {
    icon: NcHeading3,
    keywords: ['heading', 'h3'],
  },
  ncQuote: {
    icon: NcQuote,
    keywords: ['quotes'],
  },
  ncFileSearch: {
    icon: h(NcFileSearch, { stroke: 'transparent' }),
    keywords: ['search', 'file', 'document'],
  },
  ncWebhook: {
    icon: NcWebhook,
    keywords: ['webhook'],
  },
  ncLogoAsana: {
    icon: h(NcLogoAsana, { stroke: 'transparent' }),
    keywords: ['project management', 'task tracking', 'collaboration', 'productivity', 'workflows'],
  },
  ncLogoBitbucket: {
    icon: h(NcLogoBitbucket, { stroke: 'transparent' }),
    keywords: ['git', 'version control', 'code repository', 'devops', 'collaboration'],
  },
  ncLogoBoxLogo: {
    icon: h(NcLogoBoxLogo, { stroke: 'transparent' }),
    keywords: ['cloud storage', 'file sharing', 'collaboration', 'document management', 'storage'],
  },
  ncLogoClaudeAi: {
    icon: h(NcLogoClaudeAi, { stroke: 'transparent' }),
    keywords: ['ai assistant', 'natural language', 'chatbot', 'anthropic', 'artificial intelligence'],
  },
  ncLogoDiscord: {
    icon: h(NcLogoDiscord, { stroke: 'transparent' }),
    keywords: ['chat', 'communication', 'community', 'voice chat', 'messaging'],
  },
  ncLogoDropbox: {
    icon: h(NcLogoDropbox, { stroke: 'transparent' }),
    keywords: ['cloud storage', 'file sharing', 'backup', 'sync', 'collaboration'],
  },
  ncLogoFacebook: {
    icon: h(NcLogoFacebook, { stroke: 'transparent' }),
    keywords: ['social media', 'networking', 'communication', 'marketing', 'meta'],
  },
  ncLogoFigma: {
    icon: h(NcLogoFigma, { stroke: 'transparent' }),
    keywords: ['design', 'ui/ux', 'collaboration', 'prototyping', 'interface'],
  },
  ncLogoFramer: {
    icon: h(NcLogoFramer, { stroke: 'transparent' }),
    keywords: ['prototyping', 'animation', 'design', 'interface', 'web design'],
  },
  ncLogoFreshdesk: {
    icon: h(NcLogoFreshdesk, { stroke: 'transparent' }),
    keywords: ['customer support', 'helpdesk', 'ticketing', 'service desk', 'support'],
  },
  ncLogoGeminiAi: {
    icon: h(NcLogoGeminiAi, { stroke: 'transparent' }),
    keywords: ['ai', 'machine learning', 'google ai', 'artificial intelligence', 'language model'],
  },
  ncLogoGmail: {
    icon: h(NcLogoGmail, { stroke: 'transparent' }),
    keywords: ['email', 'communication', 'google', 'messaging', 'mail'],
  },
  ncLogoGoogleDrive: {
    icon: h(NcLogoGoogleDrive, { stroke: 'transparent' }),
    keywords: ['cloud storage', 'file sharing', 'collaboration', 'google', 'documents'],
  },
  ncLogoGreenhouse: {
    icon: h(NcLogoGreenhouse, { stroke: 'transparent' }),
    keywords: ['recruiting', 'hiring', 'ats', 'talent', 'hr'],
  },
  ncLogoGroqAi: {
    icon: h(NcLogoGroqAi, { stroke: 'transparent' }),
    keywords: ['ai', 'machine learning', 'inference', 'artificial intelligence', 'compute'],
  },
  ncLogoHubspot: {
    icon: h(NcLogoHubspot, { stroke: 'transparent' }),
    keywords: ['crm', 'marketing', 'sales', 'customer service', 'automation'],
  },
  ncLogoIntercom: {
    icon: h(NcLogoIntercom, { stroke: 'transparent' }),
    keywords: ['customer messaging', 'support', 'chat', 'engagement', 'communication'],
  },
  ncLogoJira: {
    icon: h(NcLogoJira, { stroke: 'transparent' }),
    keywords: ['project management', 'agile', 'issue tracking', 'workflow', 'atlassian'],
  },
  ncLogoLever: {
    icon: h(NcLogoLever, { stroke: 'transparent' }),
    keywords: ['recruiting', 'hiring', 'talent acquisition', 'ats', 'hr'],
  },
  ncLogoMailchimp: {
    icon: h(NcLogoMailchimp, { stroke: 'transparent' }),
    keywords: ['email marketing', 'automation', 'campaigns', 'newsletters', 'crm'],
  },
  ncLogoMiro: {
    icon: h(NcLogoMiro, { stroke: 'transparent' }),
    keywords: ['whiteboard', 'collaboration', 'brainstorming', 'visual', 'planning'],
  },
  ncLogoMsDynamics: {
    icon: h(NcLogoMsDynamics, { stroke: 'transparent' }),
    keywords: ['crm', 'erp', 'business software', 'microsoft', 'enterprise'],
  },
  ncLogoOllama: {
    icon: h(NcLogoOllama, { stroke: 'transparent' }),
    keywords: ['ai', 'local models', 'machine learning', 'llm', 'artificial intelligence'],
  },
  ncLogoOpenAi: {
    icon: h(NcLogoOpenAi, { stroke: 'transparent' }),
    keywords: ['ai', 'gpt', 'machine learning', 'chatgpt', 'artificial intelligence'],
  },
  ncLogoOutlook: {
    icon: h(NcLogoOutlook, { stroke: 'transparent' }),
    keywords: ['email', 'calendar', 'microsoft', 'communication', 'scheduling'],
  },
  ncLogoPipedrive: {
    icon: h(NcLogoPipedrive, { stroke: 'transparent' }),
    keywords: ['crm', 'sales', 'pipeline', 'lead management', 'deals'],
  },
  ncLogoQuickbooks: {
    icon: h(NcLogoQuickbooks, { stroke: 'transparent' }),
    keywords: ['accounting', 'bookkeeping', 'finance', 'invoicing', 'payroll'],
  },
  ncLogoSalesforce: {
    icon: h(NcLogoSalesforce, { stroke: 'transparent' }),
    keywords: ['crm', 'sales', 'customer service', 'cloud', 'enterprise'],
  },
  ncLogoSlack: {
    icon: h(NcLogoSlack, { stroke: 'transparent' }),
    keywords: ['chat', 'communication', 'collaboration', 'messaging', 'teams'],
  },
  ncLogoStripe: {
    icon: h(NcLogoStripe, { stroke: 'transparent' }),
    keywords: ['payments', 'billing', 'ecommerce', 'financial', 'processing'],
  },
  ncLogoSurveyMonkey: {
    icon: h(NcLogoSurveyMonkey, { stroke: 'transparent' }),
    keywords: ['surveys', 'feedback', 'forms', 'research', 'data collection'],
  },
  ncLogoTeams: {
    icon: h(NcLogoTeams, { stroke: 'transparent' }),
    keywords: ['communication', 'collaboration', 'microsoft', 'chat', 'video conferencing'],
  },
  ncLogoTelegram: {
    icon: h(NcLogoTelegram, { stroke: 'transparent' }),
    keywords: ['messaging', 'chat', 'communication', 'social', 'instant messaging'],
  },
  ncLogoTrello: {
    icon: h(NcLogoTrello, { stroke: 'transparent' }),
    keywords: ['project management', 'kanban', 'tasks', 'collaboration', 'organization'],
  },
  ncLogoTwilio: {
    icon: h(NcLogoTwilio, { stroke: 'transparent' }),
    keywords: ['communications', 'sms', 'voice', 'api', 'messaging'],
  },
  ncLogoTwitch: {
    icon: h(NcLogoTwitch, { stroke: 'transparent' }),
    keywords: ['streaming', 'gaming', 'live content', 'entertainment', 'video'],
  },
  ncLogoTwitter: {
    icon: h(NcLogoTwitter, { stroke: 'transparent' }),
    keywords: ['social media', 'microblogging', 'news', 'communication', 'x'],
  },
  ncLogoTypeform: {
    icon: h(NcLogoTypeform, { stroke: 'transparent' }),
    keywords: ['forms', 'surveys', 'feedback', 'data collection', 'questionnaire'],
  },
  ncLogoWhatsapp: {
    icon: h(NcLogoWhatsapp, { stroke: 'transparent' }),
    keywords: ['messaging', 'chat', 'communication', 'social', 'mobile'],
  },
  ncLogoWorkday: {
    icon: h(NcLogoWorkday, { stroke: 'transparent' }),
    keywords: ['hr', 'finance', 'enterprise', 'hcm', 'management'],
  },
  ncLogoZendesk: {
    icon: h(NcLogoZendesk, { stroke: 'transparent' }),
    keywords: ['customer service', 'support', 'helpdesk', 'ticketing', 'crm'],
  },
  ncLogoZoho: {
    icon: h(NcLogoZoho, { stroke: 'transparent' }),
    keywords: ['crm', 'business apps', 'collaboration', 'productivity', 'enterprise'],
  },
  ncLogoBaserowColored: {
    icon: h(NcLogoBaserowColored, { stroke: 'transparent' }),
    keywords: ['baserow', 'nocode', 'database', 'table', 'collaboration', 'open-source'],
  },
  ncLogoSoftrColored: {
    icon: h(NcLogoSoftrColored, { stroke: 'transparent' }),
    keywords: ['softr', 'nocode', 'website', 'app', 'frontend', 'builder'],
  },
  ncLogoNotionColored: {
    icon: h(NcLogoNotionColored, { stroke: 'transparent' }),
    keywords: ['notion', 'docs', 'wiki', 'notes', 'productivity', 'database', 'collaboration'],
  },
  ncLogoCodaColored: {
    icon: h(NcLogoCodaColored, { stroke: 'transparent' }),
    keywords: ['coda', 'docs', 'automation', 'spreadsheet', 'teamwork', 'collaboration'],
  },
  ncLogoRetoolColored: {
    icon: h(NcLogoRetoolColored, { stroke: 'transparent' }),
    keywords: ['retool', 'internal-tools', 'builder', 'frontend', 'admin', 'dashboard', 'crud'],
  },
  ncLogoN8nColored: {
    icon: h(NcLogoN8nColored, { stroke: 'transparent' }),
    keywords: ['n8n', 'workflow', 'automation', 'integration', 'open-source', 'pipeline'],
  },
  ncLogoZapierColored: {
    icon: h(NcLogoZapierColored, { stroke: 'transparent' }),
    keywords: ['zapier', 'automation', 'integration', 'workflow', 'task', 'connect'],
  },
  ncLogoMakeColored: {
    icon: h(NcLogoMakeColored, { stroke: 'transparent' }),
    keywords: ['make', 'automation', 'workflow', 'integration', 'connect', 'nocode'],
  },
  ncLogoCrewAi: {
    icon: h(NcLogoCrewAi, { stroke: 'transparent' }),
    keywords: [
      'crew',
      'crew.ai',
      'workflow automation',
      'AI agents',
      'team collaboration',
      'autonomous agents',
      'ai',
      'nocode',
      'integration',
    ],
  },
  ncLogoManusIm: {
    icon: h(NcLogoManusIm, { stroke: 'transparent' }),
    keywords: [
      'manus',
      'manus.im',
      'automation',
      'AI workflows',
      'business automation',
      'nocode',
      'workflow builder',
      'integration',
    ],
  },
  ncLogoHuggingface: {
    icon: h(NcLogoHuggingface, { stroke: 'transparent' }),
    keywords: [
      'huggingface',
      'transformers',
      'nlp',
      'ai models',
      'ml',
      'machine learning',
      'text generation',
      'open source',
      'integration',
    ],
  },
  ncLogoReplitAi: {
    icon: h(NcLogoReplitAi, { stroke: 'transparent' }),
    keywords: [
      'replit',
      'replit.ai',
      'code',
      'cloud IDE',
      'developer tools',
      'generative AI',
      'ai coding',
      'automation',
      'nocode',
      'integration',
    ],
  },
  ncLogoLangchain: {
    icon: h(NcLogoLangchain, { stroke: 'transparent' }),
    keywords: [
      'langchain',
      'ai agents',
      'llm orchestration',
      'prompt chaining',
      'generative AI',
      'framework',
      'openai',
      'rag',
      'nocode',
      'workflow',
      'integration',
    ],
  },
  ncLogoBambooHrColored: {
    icon: h(NcLogoBambooHrColored, { stroke: 'transparent' }),
    keywords: [
      'bamboohr',
      'hr software',
      'human resources',
      'employee management',
      'performance',
      'time tracking',
      'hr automation',
      'workflow',
      'integration',
    ],
  },
  ncLogoDockerColored: {
    icon: h(NcLogoDockerColored, { stroke: 'transparent' }),
    keywords: ['docker', 'containerization', 'devops', 'cloud', 'infrastructure'],
  },
  ncLogoHootsuiteColored: {
    icon: h(NcLogoHootsuiteColored, { stroke: 'transparent' }),
    keywords: ['hootsuite', 'social', 'marketing', 'automation'],
  },
  ncLogoGongColored: {
    icon: h(NcLogoGongColored, { stroke: 'transparent' }),
    keywords: ['gong', 'revenue', 'analytics', 'sales'],
  },
  ncLogoProductBoardColored: {
    icon: h(NcLogoProductBoardColored, { stroke: 'transparent' }),
    keywords: ['productboard', 'roadmap', 'feedback', 'planning'],
  },
  ncLogoXeroColored: {
    icon: h(NcLogoXeroColored, { stroke: 'transparent' }),
    keywords: ['xero', 'accounting', 'finance', 'invoicing'],
  },
  ncLogoSketchColored: {
    icon: h(NcLogoSketchColored, { stroke: 'transparent' }),
    keywords: ['sketch', 'design', 'ui', 'prototype'],
  },
  ncLogoLookerColored: {
    icon: h(NcLogoLookerColored, { stroke: 'transparent' }),
    keywords: ['looker', 'analytics', 'data', 'visualization'],
  },
  ncLogoPowerLogoColored: {
    icon: h(NcLogoPowerLogoColored, { stroke: 'transparent' }),
    keywords: ['power', 'design', 'logo', 'branding'],
  },
  ncLogoClickupColored: {
    icon: h(NcLogoClickupColored, { stroke: 'transparent' }),
    keywords: ['clickup', 'tasks', 'collaboration', 'productivity'],
  },

  ncBaseOutline: {
    icon: NcBaseOutline,
    keywords: ['base', 'database', 'storage', 'db'],
  },
  ncBasePrivate: {
    icon: NcBasePrivate,
    keywords: ['base', 'database', 'storage', 'db', 'private', 'locked', 'secure'],
  },
  ncBaseOutlineDuo: {
    icon: NcBaseOutlineDuo,
    keywords: ['base', 'database', 'storage', 'db'],
  },
  ncSearchDuo: {
    icon: NcSearchDuo,
    keywords: ['search'],
  },
  ncSettingsDuo: {
    icon: NcSettingsDuo,
    keywords: ['settings'],
  },
  ncIntegrationDuo: {
    icon: NcIntegrationDuo,
    keywords: ['integration', 'settings'],
  },
  ncMegaPhoneDuo: {
    icon: NcMegaPhoneDuo,
    keywords: ['megaphone', 'horn'],
  },
  ncNotificationDuo: {
    icon: NcNotificationDuo,
    keywords: ['notification', 'bell'],
  },
  ncLayout: {
    icon: NcLayout,
    keywords: ['layout', 'table'],
  },
  ncHeadphone: {
    icon: NcHeadphone,
    keywords: ['headphone', 'call'],
  },
  ncPaintRoller: {
    icon: NcPaintRoller,
    keywords: ['paint', 'roller', 'color', 'paintbrush'],
  },
  ncConditions: {
    icon: NcConditions,
    keywords: ['conditions', 'filter', 'rule'],
  },
  ncCrown: {
    icon: NcCrown,
    keywords: ['crown', 'badge', 'award', 'achievement', 'honor', 'paid'],
  },
  ncMultiCircle: {
    icon: NcMultiCircle,
    keywords: ['multi', 'circle', 'multi-circle', 'multi-circle-outline'],
  },
  ncSun: {
    icon: NcSun,
    keywords: ['sun', 'sunny', 'weather', 'light', 'day', 'morning', 'summer', 'warm', 'warmth'],
  },
  ncSunMoon: {
    icon: NcSunMoon,
    keywords: ['sun', 'moon', 'dark', 'light', 'theme', 'auto theme', 'system theme', 'appearance'],
  },
  ncGraduationCap: {
    icon: NcGraduationCap,
    keywords: ['graduation', 'cap', 'school', 'education', 'academic'],
  },
  ncSupportAgent: {
    icon: h(NcSupportAgent, { stroke: 'transparent' }),
    keywords: ['support', 'agent', 'help', 'customer', 'service'],
  },
  ncBuilding: {
    icon: NcBuilding,
    keywords: ['building', 'office', 'building-outline'],
  },
  ncClipboardType: {
    icon: NcClipboardType,
    keywords: ['clipboard', 'type', 'copy', 'paste'],
  },
  ncKeyboard: {
    icon: NcKeyboardIcon,
    keywords: ['keyboard', 'type', 'input', 'keys', 'shortcut'],
  },
}

export const searchIcons = (searchTerm: string) => {
  if (!searchTerm)
    return Object.entries(searchableMap).map(([iconName, iconData]) => ({
      name: iconName,
      icon: iconData.icon,
      keywords: iconData.keywords,
    }))

  searchTerm = searchTerm.toLowerCase()

  return Object.entries(searchableMap)
    .filter(([iconName, iconData]) => {
      if (iconName.toLowerCase().includes(searchTerm)) {
        return true
      }

      return iconData.keywords.some((keyword) => keyword.toLowerCase().includes(searchTerm))
    })
    .map(([iconName, iconData]) => ({
      name: iconName,
      icon: iconData.icon,
      keywords: iconData.keywords,
    }))
}

export type IconMapKey = keyof typeof iconMap
